var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Knockout JavaScript library v3.4.2
 * (c) The Knockout.js team - http://knockoutjs.com/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

(function () {
    (function (n) {
        var x = this || (0, eval)("this"),
            t = x.document,
            M = x.navigator,
            u = x.jQuery,
            H = x.JSON;(function (n) {
            "function" === typeof define && define.amd ? define(["exports", "require"], n) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" === (typeof module === "undefined" ? "undefined" : _typeof(module)) ? n(module.exports || exports) : n(x.ko = {});
        })(function (N, O) {
            function J(a, c) {
                return null === a || (typeof a === "undefined" ? "undefined" : _typeof(a)) in R ? a === c : !1;
            }function S(b, c) {
                var d;return function () {
                    d || (d = a.a.setTimeout(function () {
                        d = n;b();
                    }, c));
                };
            }function T(b, c) {
                var d;return function () {
                    clearTimeout(d);d = a.a.setTimeout(b, c);
                };
            }function U(a, c) {
                c && c !== E ? "beforeChange" === c ? this.Ob(a) : this.Ja(a, c) : this.Pb(a);
            }function V(a, c) {
                null !== c && c.k && c.k();
            }function W(a, c) {
                var d = this.Mc,
                    e = d[s];e.T || (this.ob && this.Oa[c] ? (d.Sb(c, a, this.Oa[c]), this.Oa[c] = null, --this.ob) : e.s[c] || d.Sb(c, a, e.t ? { $: a } : d.yc(a)), a.Ha && a.Hc());
            }function K(b, c, d, e) {
                a.d[b] = { init: function init(b, g, h, l, m) {
                        var k, r;a.m(function () {
                            var q = g(),
                                p = a.a.c(q),
                                p = !d !== !p,
                                A = !r;if (A || c || p !== k) A && a.xa.Ca() && (r = a.a.wa(a.f.childNodes(b), !0)), p ? (A || a.f.fa(b, a.a.wa(r)), a.hb(e ? e(m, q) : m, b)) : a.f.za(b), k = p;
                        }, null, { i: b });return { controlsDescendantBindings: !0 };
                    } };a.h.va[b] = !1;a.f.aa[b] = !0;
            }var a = "undefined" !== typeof N ? N : {};a.b = function (b, c) {
                for (var d = b.split("."), e = a, f = 0; f < d.length - 1; f++) {
                    e = e[d[f]];
                }e[d[d.length - 1]] = c;
            };a.H = function (a, c, d) {
                a[c] = d;
            };a.version = "3.4.2";a.b("version", a.version);a.options = { deferUpdates: !1, useOnlyNativeEvents: !1 };a.a = function () {
                function b(a, b) {
                    for (var c in a) {
                        a.hasOwnProperty(c) && b(c, a[c]);
                    }
                }function c(a, b) {
                    if (b) for (var c in b) {
                        b.hasOwnProperty(c) && (a[c] = b[c]);
                    }return a;
                }function d(a, b) {
                    a.__proto__ = b;return a;
                }function e(b, c, d, e) {
                    var m = b[c].match(r) || [];a.a.r(d.match(r), function (b) {
                        a.a.ra(m, b, e);
                    });b[c] = m.join(" ");
                }var f = { __proto__: [] } instanceof Array,
                    g = "function" === typeof Symbol,
                    h = {},
                    l = {};h[M && /Firefox\/2/i.test(M.userAgent) ? "KeyboardEvent" : "UIEvents"] = ["keyup", "keydown", "keypress"];h.MouseEvents = "click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave".split(" ");b(h, function (a, b) {
                    if (b.length) for (var c = 0, d = b.length; c < d; c++) {
                        l[b[c]] = a;
                    }
                });var m = { propertychange: !0 },
                    k = t && function () {
                    for (var a = 3, b = t.createElement("div"), c = b.getElementsByTagName("i"); b.innerHTML = "\x3c!--[if gt IE " + ++a + "]><i></i><![endif]--\x3e", c[0];) {}return 4 < a ? a : n;
                }(),
                    r = /\S+/g;return { gc: ["authenticity_token", /^__RequestVerificationToken(_.*)?$/], r: function r(a, b) {
                        for (var c = 0, d = a.length; c < d; c++) {
                            b(a[c], c);
                        }
                    }, o: function o(a, b) {
                        if ("function" == typeof Array.prototype.indexOf) return Array.prototype.indexOf.call(a, b);for (var c = 0, d = a.length; c < d; c++) {
                            if (a[c] === b) return c;
                        }return -1;
                    }, Vb: function Vb(a, b, c) {
                        for (var d = 0, e = a.length; d < e; d++) {
                            if (b.call(c, a[d], d)) return a[d];
                        }return null;
                    }, Na: function Na(b, c) {
                        var d = a.a.o(b, c);0 < d ? b.splice(d, 1) : 0 === d && b.shift();
                    }, Wb: function Wb(b) {
                        b = b || [];for (var c = [], d = 0, e = b.length; d < e; d++) {
                            0 > a.a.o(c, b[d]) && c.push(b[d]);
                        }return c;
                    }, ib: function ib(a, b) {
                        a = a || [];for (var c = [], d = 0, e = a.length; d < e; d++) {
                            c.push(b(a[d], d));
                        }return c;
                    }, Ma: function Ma(a, b) {
                        a = a || [];for (var c = [], d = 0, e = a.length; d < e; d++) {
                            b(a[d], d) && c.push(a[d]);
                        }return c;
                    }, ta: function ta(a, b) {
                        if (b instanceof Array) a.push.apply(a, b);else for (var c = 0, d = b.length; c < d; c++) {
                            a.push(b[c]);
                        }return a;
                    }, ra: function ra(b, c, d) {
                        var e = a.a.o(a.a.Bb(b), c);0 > e ? d && b.push(c) : d || b.splice(e, 1);
                    }, la: f, extend: c, $a: d, ab: f ? d : c, D: b, Ea: function Ea(a, b) {
                        if (!a) return a;var c = {},
                            d;for (d in a) {
                            a.hasOwnProperty(d) && (c[d] = b(a[d], d, a));
                        }return c;
                    }, rb: function rb(b) {
                        for (; b.firstChild;) {
                            a.removeNode(b.firstChild);
                        }
                    }, nc: function nc(b) {
                        b = a.a.W(b);for (var c = (b[0] && b[0].ownerDocument || t).createElement("div"), d = 0, e = b.length; d < e; d++) {
                            c.appendChild(a.ba(b[d]));
                        }return c;
                    }, wa: function wa(b, c) {
                        for (var d = 0, e = b.length, m = []; d < e; d++) {
                            var k = b[d].cloneNode(!0);m.push(c ? a.ba(k) : k);
                        }return m;
                    }, fa: function fa(b, c) {
                        a.a.rb(b);if (c) for (var d = 0, e = c.length; d < e; d++) {
                            b.appendChild(c[d]);
                        }
                    }, uc: function uc(b, c) {
                        var d = b.nodeType ? [b] : b;if (0 < d.length) {
                            for (var e = d[0], m = e.parentNode, k = 0, f = c.length; k < f; k++) {
                                m.insertBefore(c[k], e);
                            }k = 0;for (f = d.length; k < f; k++) {
                                a.removeNode(d[k]);
                            }
                        }
                    }, Ba: function Ba(a, b) {
                        if (a.length) {
                            for (b = 8 === b.nodeType && b.parentNode || b; a.length && a[0].parentNode !== b;) {
                                a.splice(0, 1);
                            }for (; 1 < a.length && a[a.length - 1].parentNode !== b;) {
                                a.length--;
                            }if (1 < a.length) {
                                var c = a[0],
                                    d = a[a.length - 1];for (a.length = 0; c !== d;) {
                                    a.push(c), c = c.nextSibling;
                                }a.push(d);
                            }
                        }return a;
                    }, wc: function wc(a, b) {
                        7 > k ? a.setAttribute("selected", b) : a.selected = b;
                    }, cb: function cb(a) {
                        return null === a || a === n ? "" : a.trim ? a.trim() : a.toString().replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
                    }, sd: function sd(a, b) {
                        a = a || "";return b.length > a.length ? !1 : a.substring(0, b.length) === b;
                    }, Rc: function Rc(a, b) {
                        if (a === b) return !0;if (11 === a.nodeType) return !1;if (b.contains) return b.contains(3 === a.nodeType ? a.parentNode : a);if (b.compareDocumentPosition) return 16 == (b.compareDocumentPosition(a) & 16);for (; a && a != b;) {
                            a = a.parentNode;
                        }return !!a;
                    }, qb: function qb(b) {
                        return a.a.Rc(b, b.ownerDocument.documentElement);
                    }, Tb: function Tb(b) {
                        return !!a.a.Vb(b, a.a.qb);
                    }, A: function A(a) {
                        return a && a.tagName && a.tagName.toLowerCase();
                    }, Zb: function Zb(b) {
                        return a.onError ? function () {
                            try {
                                return b.apply(this, arguments);
                            } catch (c) {
                                throw a.onError && a.onError(c), c;
                            }
                        } : b;
                    }, setTimeout: function (_setTimeout) {
                        function setTimeout(_x, _x2) {
                            return _setTimeout.apply(this, arguments);
                        }

                        setTimeout.toString = function () {
                            return _setTimeout.toString();
                        };

                        return setTimeout;
                    }(function (b, c) {
                        return setTimeout(a.a.Zb(b), c);
                    }), dc: function dc(b) {
                        setTimeout(function () {
                            a.onError && a.onError(b);throw b;
                        }, 0);
                    }, q: function q(b, c, d) {
                        var e = a.a.Zb(d);d = k && m[c];if (a.options.useOnlyNativeEvents || d || !u) {
                            if (d || "function" != typeof b.addEventListener) {
                                if ("undefined" != typeof b.attachEvent) {
                                    var f = function f(a) {
                                        e.call(b, a);
                                    },
                                        l = "on" + c;b.attachEvent(l, f);a.a.G.qa(b, function () {
                                        b.detachEvent(l, f);
                                    });
                                } else throw Error("Browser doesn't support addEventListener or attachEvent");
                            } else b.addEventListener(c, e, !1);
                        } else u(b).bind(c, e);
                    }, Fa: function Fa(b, c) {
                        if (!b || !b.nodeType) throw Error("element must be a DOM node when calling triggerEvent");var d;"input" === a.a.A(b) && b.type && "click" == c.toLowerCase() ? (d = b.type, d = "checkbox" == d || "radio" == d) : d = !1;if (a.options.useOnlyNativeEvents || !u || d) {
                            if ("function" == typeof t.createEvent) {
                                if ("function" == typeof b.dispatchEvent) d = t.createEvent(l[c] || "HTMLEvents"), d.initEvent(c, !0, !0, x, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, b), b.dispatchEvent(d);else throw Error("The supplied element doesn't support dispatchEvent");
                            } else if (d && b.click) b.click();else if ("undefined" != typeof b.fireEvent) b.fireEvent("on" + c);else throw Error("Browser doesn't support triggering events");
                        } else u(b).trigger(c);
                    }, c: function c(b) {
                        return a.I(b) ? b() : b;
                    }, Bb: function Bb(b) {
                        return a.I(b) ? b.p() : b;
                    }, fb: function fb(b, c, d) {
                        var k;c && ("object" === _typeof(b.classList) ? (k = b.classList[d ? "add" : "remove"], a.a.r(c.match(r), function (a) {
                            k.call(b.classList, a);
                        })) : "string" === typeof b.className.baseVal ? e(b.className, "baseVal", c, d) : e(b, "className", c, d));
                    }, bb: function bb(b, c) {
                        var d = a.a.c(c);if (null === d || d === n) d = "";var e = a.f.firstChild(b);!e || 3 != e.nodeType || a.f.nextSibling(e) ? a.f.fa(b, [b.ownerDocument.createTextNode(d)]) : e.data = d;a.a.Wc(b);
                    }, vc: function vc(a, b) {
                        a.name = b;if (7 >= k) try {
                            a.mergeAttributes(t.createElement("<input name='" + a.name + "'/>"), !1);
                        } catch (c) {}
                    }, Wc: function Wc(a) {
                        9 <= k && (a = 1 == a.nodeType ? a : a.parentNode, a.style && (a.style.zoom = a.style.zoom));
                    }, Sc: function Sc(a) {
                        if (k) {
                            var b = a.style.width;a.style.width = 0;a.style.width = b;
                        }
                    }, nd: function nd(b, c) {
                        b = a.a.c(b);c = a.a.c(c);for (var d = [], e = b; e <= c; e++) {
                            d.push(e);
                        }return d;
                    }, W: function W(a) {
                        for (var b = [], c = 0, d = a.length; c < d; c++) {
                            b.push(a[c]);
                        }return b;
                    }, bc: function bc(a) {
                        return g ? Symbol(a) : a;
                    }, xd: 6 === k,
                    yd: 7 === k, C: k, ic: function ic(b, c) {
                        for (var d = a.a.W(b.getElementsByTagName("input")).concat(a.a.W(b.getElementsByTagName("textarea"))), e = "string" == typeof c ? function (a) {
                            return a.name === c;
                        } : function (a) {
                            return c.test(a.name);
                        }, k = [], m = d.length - 1; 0 <= m; m--) {
                            e(d[m]) && k.push(d[m]);
                        }return k;
                    }, kd: function kd(b) {
                        return "string" == typeof b && (b = a.a.cb(b)) ? H && H.parse ? H.parse(b) : new Function("return " + b)() : null;
                    }, Gb: function Gb(b, c, d) {
                        if (!H || !H.stringify) throw Error("Cannot find JSON.stringify(). Some browsers (e.g., IE < 8) don't support it natively, but you can overcome this by adding a script reference to json2.js, downloadable from http://www.json.org/json2.js");
                        return H.stringify(a.a.c(b), c, d);
                    }, ld: function ld(c, d, e) {
                        e = e || {};var k = e.params || {},
                            m = e.includeFields || this.gc,
                            f = c;if ("object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && "form" === a.a.A(c)) for (var f = c.action, l = m.length - 1; 0 <= l; l--) {
                            for (var g = a.a.ic(c, m[l]), h = g.length - 1; 0 <= h; h--) {
                                k[g[h].name] = g[h].value;
                            }
                        }d = a.a.c(d);var r = t.createElement("form");r.style.display = "none";r.action = f;r.method = "post";for (var n in d) {
                            c = t.createElement("input"), c.type = "hidden", c.name = n, c.value = a.a.Gb(a.a.c(d[n])), r.appendChild(c);
                        }b(k, function (a, b) {
                            var c = t.createElement("input");
                            c.type = "hidden";c.name = a;c.value = b;r.appendChild(c);
                        });t.body.appendChild(r);e.submitter ? e.submitter(r) : r.submit();setTimeout(function () {
                            r.parentNode.removeChild(r);
                        }, 0);
                    } };
            }();a.b("utils", a.a);a.b("utils.arrayForEach", a.a.r);a.b("utils.arrayFirst", a.a.Vb);a.b("utils.arrayFilter", a.a.Ma);a.b("utils.arrayGetDistinctValues", a.a.Wb);a.b("utils.arrayIndexOf", a.a.o);a.b("utils.arrayMap", a.a.ib);a.b("utils.arrayPushAll", a.a.ta);a.b("utils.arrayRemoveItem", a.a.Na);a.b("utils.extend", a.a.extend);a.b("utils.fieldsIncludedWithJsonPost", a.a.gc);a.b("utils.getFormFields", a.a.ic);a.b("utils.peekObservable", a.a.Bb);a.b("utils.postJson", a.a.ld);a.b("utils.parseJson", a.a.kd);a.b("utils.registerEventHandler", a.a.q);a.b("utils.stringifyJson", a.a.Gb);a.b("utils.range", a.a.nd);a.b("utils.toggleDomNodeCssClass", a.a.fb);a.b("utils.triggerEvent", a.a.Fa);a.b("utils.unwrapObservable", a.a.c);a.b("utils.objectForEach", a.a.D);a.b("utils.addOrRemoveItem", a.a.ra);a.b("utils.setTextContent", a.a.bb);a.b("unwrap", a.a.c);Function.prototype.bind || (Function.prototype.bind = function (a) {
                var c = this;if (1 === arguments.length) return function () {
                    return c.apply(a, arguments);
                };var d = Array.prototype.slice.call(arguments, 1);return function () {
                    var e = d.slice(0);e.push.apply(e, arguments);return c.apply(a, e);
                };
            });a.a.e = new function () {
                function a(b, g) {
                    var h = b[d];if (!h || "null" === h || !e[h]) {
                        if (!g) return n;h = b[d] = "ko" + c++;e[h] = {};
                    }return e[h];
                }var c = 0,
                    d = "__ko__" + new Date().getTime(),
                    e = {};return { get: function get(c, d) {
                        var e = a(c, !1);return e === n ? n : e[d];
                    }, set: function set(c, d, e) {
                        if (e !== n || a(c, !1) !== n) a(c, !0)[d] = e;
                    }, clear: function clear(a) {
                        var b = a[d];return b ? (delete e[b], a[d] = null, !0) : !1;
                    }, J: function J() {
                        return c++ + d;
                    } };
            }();a.b("utils.domData", a.a.e);a.b("utils.domData.clear", a.a.e.clear);a.a.G = new function () {
                function b(b, c) {
                    var e = a.a.e.get(b, d);e === n && c && (e = [], a.a.e.set(b, d, e));return e;
                }function c(d) {
                    var e = b(d, !1);if (e) for (var e = e.slice(0), l = 0; l < e.length; l++) {
                        e[l](d);
                    }a.a.e.clear(d);a.a.G.cleanExternalData(d);if (f[d.nodeType]) for (e = d.firstChild; d = e;) {
                        e = d.nextSibling, 8 === d.nodeType && c(d);
                    }
                }var d = a.a.e.J(),
                    e = { 1: !0, 8: !0, 9: !0 },
                    f = { 1: !0, 9: !0 };return { qa: function qa(a, c) {
                        if ("function" != typeof c) throw Error("Callback must be a function");b(a, !0).push(c);
                    }, tc: function tc(c, e) {
                        var f = b(c, !1);f && (a.a.Na(f, e), 0 == f.length && a.a.e.set(c, d, n));
                    }, ba: function ba(b) {
                        if (e[b.nodeType] && (c(b), f[b.nodeType])) {
                            var d = [];a.a.ta(d, b.getElementsByTagName("*"));for (var l = 0, m = d.length; l < m; l++) {
                                c(d[l]);
                            }
                        }return b;
                    }, removeNode: function removeNode(b) {
                        a.ba(b);b.parentNode && b.parentNode.removeChild(b);
                    }, cleanExternalData: function cleanExternalData(a) {
                        u && "function" == typeof u.cleanData && u.cleanData([a]);
                    } };
            }();
            a.ba = a.a.G.ba;a.removeNode = a.a.G.removeNode;a.b("cleanNode", a.ba);a.b("removeNode", a.removeNode);a.b("utils.domNodeDisposal", a.a.G);a.b("utils.domNodeDisposal.addDisposeCallback", a.a.G.qa);a.b("utils.domNodeDisposal.removeDisposeCallback", a.a.G.tc);(function () {
                var b = [0, "", ""],
                    c = [1, "<table>", "</table>"],
                    d = [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                    e = [1, "<select multiple='multiple'>", "</select>"],
                    f = { thead: c, tbody: c, tfoot: c, tr: [2, "<table><tbody>", "</tbody></table>"], td: d, th: d, option: e, optgroup: e },
                    g = 8 >= a.a.C;a.a.na = function (c, d) {
                    var e;if (u) {
                        if (u.parseHTML) e = u.parseHTML(c, d) || [];else {
                            if ((e = u.clean([c], d)) && e[0]) {
                                for (var k = e[0]; k.parentNode && 11 !== k.parentNode.nodeType;) {
                                    k = k.parentNode;
                                }k.parentNode && k.parentNode.removeChild(k);
                            }
                        }
                    } else {
                        (e = d) || (e = t);var k = e.parentWindow || e.defaultView || x,
                            r = a.a.cb(c).toLowerCase(),
                            q = e.createElement("div"),
                            p;p = (r = r.match(/^<([a-z]+)[ >]/)) && f[r[1]] || b;r = p[0];p = "ignored<div>" + p[1] + c + p[2] + "</div>";"function" == typeof k.innerShiv ? q.appendChild(k.innerShiv(p)) : (g && e.appendChild(q), q.innerHTML = p, g && q.parentNode.removeChild(q));for (; r--;) {
                            q = q.lastChild;
                        }e = a.a.W(q.lastChild.childNodes);
                    }return e;
                };a.a.Eb = function (b, c) {
                    a.a.rb(b);c = a.a.c(c);if (null !== c && c !== n) if ("string" != typeof c && (c = c.toString()), u) u(b).html(c);else for (var d = a.a.na(c, b.ownerDocument), e = 0; e < d.length; e++) {
                        b.appendChild(d[e]);
                    }
                };
            })();a.b("utils.parseHtmlFragment", a.a.na);a.b("utils.setHtml", a.a.Eb);a.N = function () {
                function b(c, e) {
                    if (c) if (8 == c.nodeType) {
                        var f = a.N.pc(c.nodeValue);null != f && e.push({ Qc: c, hd: f });
                    } else if (1 == c.nodeType) for (var f = 0, g = c.childNodes, h = g.length; f < h; f++) {
                        b(g[f], e);
                    }
                }var c = {};return { yb: function yb(a) {
                        if ("function" != typeof a) throw Error("You can only pass a function to ko.memoization.memoize()");var b = (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1) + (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1);c[b] = a;return "\x3c!--[ko_memo:" + b + "]--\x3e";
                    }, Bc: function Bc(a, b) {
                        var f = c[a];if (f === n) throw Error("Couldn't find any memo with ID " + a + ". Perhaps it's already been unmemoized.");try {
                            return f.apply(null, b || []), !0;
                        } finally {
                            delete c[a];
                        }
                    }, Cc: function Cc(c, e) {
                        var f = [];b(c, f);for (var g = 0, h = f.length; g < h; g++) {
                            var l = f[g].Qc,
                                m = [l];e && a.a.ta(m, e);a.N.Bc(f[g].hd, m);l.nodeValue = "";l.parentNode && l.parentNode.removeChild(l);
                        }
                    }, pc: function pc(a) {
                        return (a = a.match(/^\[ko_memo\:(.*?)\]$/)) ? a[1] : null;
                    } };
            }();a.b("memoization", a.N);a.b("memoization.memoize", a.N.yb);a.b("memoization.unmemoize", a.N.Bc);a.b("memoization.parseMemoText", a.N.pc);a.b("memoization.unmemoizeDomNodeAndDescendants", a.N.Cc);a.Z = function () {
                function b() {
                    if (e) for (var b = e, c = 0, m; g < e;) {
                        if (m = d[g++]) {
                            if (g > b) {
                                if (5E3 <= ++c) {
                                    g = e;a.a.dc(Error("'Too much recursion' after processing " + c + " task groups."));break;
                                }b = e;
                            }try {
                                m();
                            } catch (k) {
                                a.a.dc(k);
                            }
                        }
                    }
                }function c() {
                    b();g = e = d.length = 0;
                }var d = [],
                    e = 0,
                    f = 1,
                    g = 0;return { scheduler: x.MutationObserver ? function (a) {
                        var b = t.createElement("div");new MutationObserver(a).observe(b, { attributes: !0 });return function () {
                            b.classList.toggle("foo");
                        };
                    }(c) : t && "onreadystatechange" in t.createElement("script") ? function (a) {
                        var b = t.createElement("script");b.onreadystatechange = function () {
                            b.onreadystatechange = null;t.documentElement.removeChild(b);b = null;a();
                        };t.documentElement.appendChild(b);
                    } : function (a) {
                        setTimeout(a, 0);
                    }, Za: function Za(b) {
                        e || a.Z.scheduler(c);d[e++] = b;return f++;
                    }, cancel: function cancel(a) {
                        a -= f - e;a >= g && a < e && (d[a] = null);
                    }, resetForTesting: function resetForTesting() {
                        var a = e - g;g = e = d.length = 0;return a;
                    }, rd: b };
            }();a.b("tasks", a.Z);a.b("tasks.schedule", a.Z.Za);a.b("tasks.runEarly", a.Z.rd);a.Aa = { throttle: function throttle(b, c) {
                    b.throttleEvaluation = c;var d = null;return a.B({ read: b, write: function write(e) {
                            clearTimeout(d);
                            d = a.a.setTimeout(function () {
                                b(e);
                            }, c);
                        } });
                }, rateLimit: function rateLimit(a, c) {
                    var d, e, f;"number" == typeof c ? d = c : (d = c.timeout, e = c.method);a.gb = !1;f = "notifyWhenChangesStop" == e ? T : S;a.Wa(function (a) {
                        return f(a, d);
                    });
                }, deferred: function deferred(b, c) {
                    if (!0 !== c) throw Error("The 'deferred' extender only accepts the value 'true', because it is not supported to turn deferral off once enabled.");b.gb || (b.gb = !0, b.Wa(function (c) {
                        var e,
                            f = !1;return function () {
                            if (!f) {
                                a.Z.cancel(e);e = a.Z.Za(c);try {
                                    f = !0, b.notifySubscribers(n, "dirty");
                                } finally {
                                    f = !1;
                                }
                            }
                        };
                    }));
                }, notify: function notify(a, c) {
                    a.equalityComparer = "always" == c ? null : J;
                } };var R = { undefined: 1, "boolean": 1, number: 1, string: 1 };a.b("extenders", a.Aa);a.zc = function (b, c, d) {
                this.$ = b;this.jb = c;this.Pc = d;this.T = !1;a.H(this, "dispose", this.k);
            };a.zc.prototype.k = function () {
                this.T = !0;this.Pc();
            };a.K = function () {
                a.a.ab(this, D);D.ub(this);
            };var E = "change",
                D = { ub: function ub(a) {
                    a.F = { change: [] };a.Qb = 1;
                }, Y: function Y(b, c, d) {
                    var e = this;d = d || E;var f = new a.zc(e, c ? b.bind(c) : b, function () {
                        a.a.Na(e.F[d], f);e.Ka && e.Ka(d);
                    });e.ua && e.ua(d);
                    e.F[d] || (e.F[d] = []);e.F[d].push(f);return f;
                }, notifySubscribers: function notifySubscribers(b, c) {
                    c = c || E;c === E && this.Kb();if (this.Ra(c)) {
                        var d = c === E && this.Fc || this.F[c].slice(0);try {
                            a.l.Xb();for (var e = 0, f; f = d[e]; ++e) {
                                f.T || f.jb(b);
                            }
                        } finally {
                            a.l.end();
                        }
                    }
                }, Pa: function Pa() {
                    return this.Qb;
                }, Zc: function Zc(a) {
                    return this.Pa() !== a;
                }, Kb: function Kb() {
                    ++this.Qb;
                }, Wa: function Wa(b) {
                    var c = this,
                        d = a.I(c),
                        e,
                        f,
                        g,
                        h;c.Ja || (c.Ja = c.notifySubscribers, c.notifySubscribers = U);var l = b(function () {
                        c.Ha = !1;d && h === c && (h = c.Mb ? c.Mb() : c());var a = f || c.Ua(g, h);f = e = !1;
                        a && c.Ja(g = h);
                    });c.Pb = function (a) {
                        c.Fc = c.F[E].slice(0);c.Ha = e = !0;h = a;l();
                    };c.Ob = function (a) {
                        e || (g = a, c.Ja(a, "beforeChange"));
                    };c.Hc = function () {
                        c.Ua(g, c.p(!0)) && (f = !0);
                    };
                }, Ra: function Ra(a) {
                    return this.F[a] && this.F[a].length;
                }, Xc: function Xc(b) {
                    if (b) return this.F[b] && this.F[b].length || 0;var c = 0;a.a.D(this.F, function (a, b) {
                        "dirty" !== a && (c += b.length);
                    });return c;
                }, Ua: function Ua(a, c) {
                    return !this.equalityComparer || !this.equalityComparer(a, c);
                }, extend: function extend(b) {
                    var c = this;b && a.a.D(b, function (b, e) {
                        var f = a.Aa[b];"function" == typeof f && (c = f(c, e) || c);
                    });return c;
                } };a.H(D, "subscribe", D.Y);a.H(D, "extend", D.extend);a.H(D, "getSubscriptionsCount", D.Xc);a.a.la && a.a.$a(D, Function.prototype);a.K.fn = D;a.lc = function (a) {
                return null != a && "function" == typeof a.Y && "function" == typeof a.notifySubscribers;
            };a.b("subscribable", a.K);a.b("isSubscribable", a.lc);a.xa = a.l = function () {
                function b(a) {
                    d.push(e);e = a;
                }function c() {
                    e = d.pop();
                }var d = [],
                    e,
                    f = 0;return { Xb: b, end: c, sc: function sc(b) {
                        if (e) {
                            if (!a.lc(b)) throw Error("Only subscribable things can act as dependencies");
                            e.jb.call(e.Lc, b, b.Gc || (b.Gc = ++f));
                        }
                    }, w: function w(a, d, e) {
                        try {
                            return b(), a.apply(d, e || []);
                        } finally {
                            c();
                        }
                    }, Ca: function Ca() {
                        if (e) return e.m.Ca();
                    }, Va: function Va() {
                        if (e) return e.Va;
                    } };
            }();a.b("computedContext", a.xa);a.b("computedContext.getDependenciesCount", a.xa.Ca);a.b("computedContext.isInitial", a.xa.Va);a.b("ignoreDependencies", a.wd = a.l.w);var F = a.a.bc("_latestValue");a.O = function (b) {
                function c() {
                    if (0 < arguments.length) return c.Ua(c[F], arguments[0]) && (c.ia(), c[F] = arguments[0], c.ha()), this;a.l.sc(c);return c[F];
                }
                c[F] = b;a.a.la || a.a.extend(c, a.K.fn);a.K.fn.ub(c);a.a.ab(c, B);a.options.deferUpdates && a.Aa.deferred(c, !0);return c;
            };var B = { equalityComparer: J, p: function p() {
                    return this[F];
                }, ha: function ha() {
                    this.notifySubscribers(this[F]);
                }, ia: function ia() {
                    this.notifySubscribers(this[F], "beforeChange");
                } };a.a.la && a.a.$a(B, a.K.fn);var I = a.O.md = "__ko_proto__";B[I] = a.O;a.Qa = function (b, c) {
                return null === b || b === n || b[I] === n ? !1 : b[I] === c ? !0 : a.Qa(b[I], c);
            };a.I = function (b) {
                return a.Qa(b, a.O);
            };a.Da = function (b) {
                return "function" == typeof b && b[I] === a.O || "function" == typeof b && b[I] === a.B && b.$c ? !0 : !1;
            };a.b("observable", a.O);a.b("isObservable", a.I);a.b("isWriteableObservable", a.Da);a.b("isWritableObservable", a.Da);a.b("observable.fn", B);a.H(B, "peek", B.p);a.H(B, "valueHasMutated", B.ha);a.H(B, "valueWillMutate", B.ia);a.ma = function (b) {
                b = b || [];if ("object" != (typeof b === "undefined" ? "undefined" : _typeof(b)) || !("length" in b)) throw Error("The argument passed when initializing an observable array must be an array, or null, or undefined.");b = a.O(b);a.a.ab(b, a.ma.fn);return b.extend({ trackArrayChanges: !0 });
            };
            a.ma.fn = { remove: function remove(b) {
                    for (var c = this.p(), d = [], e = "function" != typeof b || a.I(b) ? function (a) {
                        return a === b;
                    } : b, f = 0; f < c.length; f++) {
                        var g = c[f];e(g) && (0 === d.length && this.ia(), d.push(g), c.splice(f, 1), f--);
                    }d.length && this.ha();return d;
                }, removeAll: function removeAll(b) {
                    if (b === n) {
                        var c = this.p(),
                            d = c.slice(0);this.ia();c.splice(0, c.length);this.ha();return d;
                    }return b ? this.remove(function (c) {
                        return 0 <= a.a.o(b, c);
                    }) : [];
                }, destroy: function destroy(b) {
                    var c = this.p(),
                        d = "function" != typeof b || a.I(b) ? function (a) {
                        return a === b;
                    } : b;this.ia();
                    for (var e = c.length - 1; 0 <= e; e--) {
                        d(c[e]) && (c[e]._destroy = !0);
                    }this.ha();
                }, destroyAll: function destroyAll(b) {
                    return b === n ? this.destroy(function () {
                        return !0;
                    }) : b ? this.destroy(function (c) {
                        return 0 <= a.a.o(b, c);
                    }) : [];
                }, indexOf: function indexOf(b) {
                    var c = this();return a.a.o(c, b);
                }, replace: function replace(a, c) {
                    var d = this.indexOf(a);0 <= d && (this.ia(), this.p()[d] = c, this.ha());
                } };a.a.la && a.a.$a(a.ma.fn, a.O.fn);a.a.r("pop push reverse shift sort splice unshift".split(" "), function (b) {
                a.ma.fn[b] = function () {
                    var a = this.p();this.ia();this.Yb(a, b, arguments);
                    var d = a[b].apply(a, arguments);this.ha();return d === a ? this : d;
                };
            });a.a.r(["slice"], function (b) {
                a.ma.fn[b] = function () {
                    var a = this();return a[b].apply(a, arguments);
                };
            });a.b("observableArray", a.ma);a.Aa.trackArrayChanges = function (b, c) {
                function d() {
                    if (!e) {
                        e = !0;l = b.notifySubscribers;b.notifySubscribers = function (a, b) {
                            b && b !== E || ++h;return l.apply(this, arguments);
                        };var c = [].concat(b.p() || []);f = null;g = b.Y(function (d) {
                            d = [].concat(d || []);if (b.Ra("arrayChange")) {
                                var e;if (!f || 1 < h) f = a.a.lb(c, d, b.kb);e = f;
                            }c = d;f = null;h = 0;
                            e && e.length && b.notifySubscribers(e, "arrayChange");
                        });
                    }
                }b.kb = {};c && "object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && a.a.extend(b.kb, c);b.kb.sparse = !0;if (!b.Yb) {
                    var e = !1,
                        f = null,
                        g,
                        h = 0,
                        l,
                        m = b.ua,
                        k = b.Ka;b.ua = function (a) {
                        m && m.call(b, a);"arrayChange" === a && d();
                    };b.Ka = function (a) {
                        k && k.call(b, a);"arrayChange" !== a || b.Ra("arrayChange") || (l && (b.notifySubscribers = l, l = n), g.k(), e = !1);
                    };b.Yb = function (b, c, d) {
                        function k(a, b, c) {
                            return m[m.length] = { status: a, value: b, index: c };
                        }if (e && !h) {
                            var m = [],
                                l = b.length,
                                g = d.length,
                                G = 0;switch (c) {case "push":
                                    G = l;case "unshift":
                                    for (c = 0; c < g; c++) {
                                        k("added", d[c], G + c);
                                    }break;case "pop":
                                    G = l - 1;case "shift":
                                    l && k("deleted", b[G], G);break;case "splice":
                                    c = Math.min(Math.max(0, 0 > d[0] ? l + d[0] : d[0]), l);for (var l = 1 === g ? l : Math.min(c + (d[1] || 0), l), g = c + g - 2, G = Math.max(l, g), n = [], s = [], w = 2; c < G; ++c, ++w) {
                                        c < l && s.push(k("deleted", b[c], c)), c < g && n.push(k("added", d[w], c));
                                    }a.a.hc(s, n);break;default:
                                    return;}f = m;
                        }
                    };
                }
            };var s = a.a.bc("_state");a.m = a.B = function (b, c, d) {
                function e() {
                    if (0 < arguments.length) {
                        if ("function" === typeof f) f.apply(g.sb, arguments);else throw Error("Cannot write a value to a ko.computed unless you specify a 'write' option. If you wish to read the current value, don't pass any parameters.");
                        return this;
                    }a.l.sc(e);(g.V || g.t && e.Sa()) && e.U();return g.M;
                }"object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) ? d = b : (d = d || {}, b && (d.read = b));if ("function" != typeof d.read) throw Error("Pass a function that returns the value of the ko.computed");var f = d.write,
                    g = { M: n, da: !0, V: !0, Ta: !1, Hb: !1, T: !1, Ya: !1, t: !1, od: d.read, sb: c || d.owner, i: d.disposeWhenNodeIsRemoved || d.i || null, ya: d.disposeWhen || d.ya, pb: null, s: {}, L: 0, fc: null };e[s] = g;e.$c = "function" === typeof f;a.a.la || a.a.extend(e, a.K.fn);a.K.fn.ub(e);a.a.ab(e, z);d.pure ? (g.Ya = !0, g.t = !0, a.a.extend(e, Y)) : d.deferEvaluation && a.a.extend(e, Z);a.options.deferUpdates && a.Aa.deferred(e, !0);g.i && (g.Hb = !0, g.i.nodeType || (g.i = null));g.t || d.deferEvaluation || e.U();g.i && e.ca() && a.a.G.qa(g.i, g.pb = function () {
                    e.k();
                });return e;
            };var z = { equalityComparer: J, Ca: function Ca() {
                    return this[s].L;
                }, Sb: function Sb(a, c, d) {
                    if (this[s].Ya && c === this) throw Error("A 'pure' computed must not be called recursively");this[s].s[a] = d;d.Ia = this[s].L++;d.pa = c.Pa();
                }, Sa: function Sa() {
                    var a,
                        c,
                        d = this[s].s;for (a in d) {
                        if (d.hasOwnProperty(a) && (c = d[a], this.oa && c.$.Ha || c.$.Zc(c.pa))) return !0;
                    }
                }, gd: function gd() {
                    this.oa && !this[s].Ta && this.oa(!1);
                }, ca: function ca() {
                    var a = this[s];return a.V || 0 < a.L;
                }, qd: function qd() {
                    this.Ha ? this[s].V && (this[s].da = !0) : this.ec();
                }, yc: function yc(a) {
                    if (a.gb && !this[s].i) {
                        var c = a.Y(this.gd, this, "dirty"),
                            d = a.Y(this.qd, this);return { $: a, k: function k() {
                                c.k();d.k();
                            } };
                    }return a.Y(this.ec, this);
                }, ec: function ec() {
                    var b = this,
                        c = b.throttleEvaluation;c && 0 <= c ? (clearTimeout(this[s].fc), this[s].fc = a.a.setTimeout(function () {
                        b.U(!0);
                    }, c)) : b.oa ? b.oa(!0) : b.U(!0);
                }, U: function U(b) {
                    var c = this[s],
                        d = c.ya,
                        e = !1;if (!c.Ta && !c.T) {
                        if (c.i && !a.a.qb(c.i) || d && d()) {
                            if (!c.Hb) {
                                this.k();return;
                            }
                        } else c.Hb = !1;c.Ta = !0;try {
                            e = this.Vc(b);
                        } finally {
                            c.Ta = !1;
                        }c.L || this.k();return e;
                    }
                }, Vc: function Vc(b) {
                    var c = this[s],
                        d = !1,
                        e = c.Ya ? n : !c.L,
                        f = { Mc: this, Oa: c.s, ob: c.L };a.l.Xb({ Lc: f, jb: W, m: this, Va: e });c.s = {};c.L = 0;f = this.Uc(c, f);this.Ua(c.M, f) && (c.t || this.notifySubscribers(c.M, "beforeChange"), c.M = f, c.t ? this.Kb() : b && this.notifySubscribers(c.M), d = !0);e && this.notifySubscribers(c.M, "awake");return d;
                }, Uc: function Uc(b, c) {
                    try {
                        var d = b.od;return b.sb ? d.call(b.sb) : d();
                    } finally {
                        a.l.end(), c.ob && !b.t && a.a.D(c.Oa, V), b.da = b.V = !1;
                    }
                }, p: function p(a) {
                    var c = this[s];(c.V && (a || !c.L) || c.t && this.Sa()) && this.U();return c.M;
                }, Wa: function Wa(b) {
                    a.K.fn.Wa.call(this, b);this.Mb = function () {
                        this[s].da ? this.U() : this[s].V = !1;return this[s].M;
                    };this.oa = function (a) {
                        this.Ob(this[s].M);this[s].V = !0;a && (this[s].da = !0);this.Pb(this);
                    };
                }, k: function k() {
                    var b = this[s];!b.t && b.s && a.a.D(b.s, function (a, b) {
                        b.k && b.k();
                    });b.i && b.pb && a.a.G.tc(b.i, b.pb);b.s = null;b.L = 0;b.T = !0;b.da = !1;b.V = !1;b.t = !1;b.i = null;
                } },
                Y = { ua: function ua(b) {
                    var c = this,
                        d = c[s];if (!d.T && d.t && "change" == b) {
                        d.t = !1;if (d.da || c.Sa()) d.s = null, d.L = 0, c.U() && c.Kb();else {
                            var e = [];a.a.D(d.s, function (a, b) {
                                e[b.Ia] = a;
                            });a.a.r(e, function (a, b) {
                                var e = d.s[a],
                                    l = c.yc(e.$);l.Ia = b;l.pa = e.pa;d.s[a] = l;
                            });
                        }d.T || c.notifySubscribers(d.M, "awake");
                    }
                }, Ka: function Ka(b) {
                    var c = this[s];c.T || "change" != b || this.Ra("change") || (a.a.D(c.s, function (a, b) {
                        b.k && (c.s[a] = { $: b.$, Ia: b.Ia, pa: b.pa }, b.k());
                    }), c.t = !0, this.notifySubscribers(n, "asleep"));
                }, Pa: function Pa() {
                    var b = this[s];b.t && (b.da || this.Sa()) && this.U();return a.K.fn.Pa.call(this);
                } },
                Z = { ua: function ua(a) {
                    "change" != a && "beforeChange" != a || this.p();
                } };a.a.la && a.a.$a(z, a.K.fn);var P = a.O.md;a.m[P] = a.O;z[P] = a.m;a.bd = function (b) {
                return a.Qa(b, a.m);
            };a.cd = function (b) {
                return a.Qa(b, a.m) && b[s] && b[s].Ya;
            };a.b("computed", a.m);a.b("dependentObservable", a.m);a.b("isComputed", a.bd);a.b("isPureComputed", a.cd);a.b("computed.fn", z);a.H(z, "peek", z.p);a.H(z, "dispose", z.k);a.H(z, "isActive", z.ca);a.H(z, "getDependenciesCount", z.Ca);a.rc = function (b, c) {
                if ("function" === typeof b) return a.m(b, c, { pure: !0 });b = a.a.extend({}, b);b.pure = !0;return a.m(b, c);
            };a.b("pureComputed", a.rc);(function () {
                function b(a, f, g) {
                    g = g || new d();a = f(a);if ("object" != (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a || a === n || a instanceof RegExp || a instanceof Date || a instanceof String || a instanceof Number || a instanceof Boolean) return a;var h = a instanceof Array ? [] : {};g.save(a, h);c(a, function (c) {
                        var d = f(a[c]);switch (typeof d === "undefined" ? "undefined" : _typeof(d)) {case "boolean":case "number":case "string":case "function":
                                h[c] = d;break;case "object":case "undefined":
                                var k = g.get(d);h[c] = k !== n ? k : b(d, f, g);}
                    });return h;
                }function c(a, b) {
                    if (a instanceof Array) {
                        for (var c = 0; c < a.length; c++) {
                            b(c);
                        }"function" == typeof a.toJSON && b("toJSON");
                    } else for (c in a) {
                        b(c);
                    }
                }function d() {
                    this.keys = [];this.Lb = [];
                }a.Ac = function (c) {
                    if (0 == arguments.length) throw Error("When calling ko.toJS, pass the object you want to convert.");return b(c, function (b) {
                        for (var c = 0; a.I(b) && 10 > c; c++) {
                            b = b();
                        }return b;
                    });
                };a.toJSON = function (b, c, d) {
                    b = a.Ac(b);return a.a.Gb(b, c, d);
                };d.prototype = { save: function save(b, c) {
                        var d = a.a.o(this.keys, b);0 <= d ? this.Lb[d] = c : (this.keys.push(b), this.Lb.push(c));
                    }, get: function get(b) {
                        b = a.a.o(this.keys, b);return 0 <= b ? this.Lb[b] : n;
                    } };
            })();a.b("toJS", a.Ac);a.b("toJSON", a.toJSON);(function () {
                a.j = { u: function u(b) {
                        switch (a.a.A(b)) {case "option":
                                return !0 === b.__ko__hasDomDataOptionValue__ ? a.a.e.get(b, a.d.options.zb) : 7 >= a.a.C ? b.getAttributeNode("value") && b.getAttributeNode("value").specified ? b.value : b.text : b.value;case "select":
                                return 0 <= b.selectedIndex ? a.j.u(b.options[b.selectedIndex]) : n;default:
                                return b.value;}
                    }, ja: function ja(b, c, d) {
                        switch (a.a.A(b)) {case "option":
                                switch (typeof c === "undefined" ? "undefined" : _typeof(c)) {case "string":
                                        a.a.e.set(b, a.d.options.zb, n);"__ko__hasDomDataOptionValue__" in b && delete b.__ko__hasDomDataOptionValue__;b.value = c;break;default:
                                        a.a.e.set(b, a.d.options.zb, c), b.__ko__hasDomDataOptionValue__ = !0, b.value = "number" === typeof c ? c : "";}break;case "select":
                                if ("" === c || null === c) c = n;for (var e = -1, f = 0, g = b.options.length, h; f < g; ++f) {
                                    if (h = a.j.u(b.options[f]), h == c || "" == h && c === n) {
                                        e = f;break;
                                    }
                                }if (d || 0 <= e || c === n && 1 < b.size) b.selectedIndex = e;break;default:
                                if (null === c || c === n) c = "";b.value = c;}
                    } };
            })();a.b("selectExtensions", a.j);a.b("selectExtensions.readValue", a.j.u);a.b("selectExtensions.writeValue", a.j.ja);a.h = function () {
                function b(b) {
                    b = a.a.cb(b);123 === b.charCodeAt(0) && (b = b.slice(1, -1));var c = [],
                        d = b.match(e),
                        r,
                        h = [],
                        p = 0;if (d) {
                        d.push(",");for (var A = 0, y; y = d[A]; ++A) {
                            var v = y.charCodeAt(0);if (44 === v) {
                                if (0 >= p) {
                                    c.push(r && h.length ? { key: r, value: h.join("") } : { unknown: r || h.join("") });r = p = 0;h = [];continue;
                                }
                            } else if (58 === v) {
                                if (!p && !r && 1 === h.length) {
                                    r = h.pop();continue;
                                }
                            } else 47 === v && A && 1 < y.length ? (v = d[A - 1].match(f)) && !g[v[0]] && (b = b.substr(b.indexOf(y) + 1), d = b.match(e), d.push(","), A = -1, y = "/") : 40 === v || 123 === v || 91 === v ? ++p : 41 === v || 125 === v || 93 === v ? --p : r || h.length || 34 !== v && 39 !== v || (y = y.slice(1, -1));h.push(y);
                        }
                    }return c;
                }var c = ["true", "false", "null", "undefined"],
                    d = /^(?:[$_a-z][$\w]*|(.+)(\.\s*[$_a-z][$\w]*|\[.+\]))$/i,
                    e = RegExp("\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'|/(?:[^/\\\\]|\\\\.)*/w*|[^\\s:,/][^,\"'{}()/:[\\]]*[^\\s,\"'{}()/:[\\]]|[^\\s]", "g"),
                    f = /[\])"'A-Za-z0-9_$]+$/,
                    g = { "in": 1, "return": 1, "typeof": 1 },
                    h = {};return { va: [], ga: h, Ab: b, Xa: function Xa(e, m) {
                        function k(b, e) {
                            var m;if (!A) {
                                var l = a.getBindingHandler(b);if (l && l.preprocess && !(e = l.preprocess(e, b, k))) return;if (l = h[b]) m = e, 0 <= a.a.o(c, m) ? m = !1 : (l = m.match(d), m = null === l ? !1 : l[1] ? "Object(" + l[1] + ")" + l[2] : m), l = m;l && g.push("'" + b + "':function(_z){" + m + "=_z}");
                            }p && (e = "function(){return " + e + " }");f.push("'" + b + "':" + e);
                        }m = m || {};var f = [],
                            g = [],
                            p = m.valueAccessors,
                            A = m.bindingParams,
                            y = "string" === typeof e ? b(e) : e;a.a.r(y, function (a) {
                            k(a.key || a.unknown, a.value);
                        });g.length && k("_ko_property_writers", "{" + g.join(",") + " }");return f.join(",");
                    }, fd: function fd(a, b) {
                        for (var c = 0; c < a.length; c++) {
                            if (a[c].key == b) return !0;
                        }return !1;
                    }, Ga: function Ga(b, c, d, e, f) {
                        if (b && a.I(b)) !a.Da(b) || f && b.p() === e || b(e);else if ((b = c.get("_ko_property_writers")) && b[d]) b[d](e);
                    } };
            }();a.b("expressionRewriting", a.h);a.b("expressionRewriting.bindingRewriteValidators", a.h.va);a.b("expressionRewriting.parseObjectLiteral", a.h.Ab);a.b("expressionRewriting.preProcessBindings", a.h.Xa);a.b("expressionRewriting._twoWayBindings", a.h.ga);a.b("jsonExpressionRewriting", a.h);a.b("jsonExpressionRewriting.insertPropertyAccessorsIntoJson", a.h.Xa);(function () {
                function b(a) {
                    return 8 == a.nodeType && g.test(f ? a.text : a.nodeValue);
                }function c(a) {
                    return 8 == a.nodeType && h.test(f ? a.text : a.nodeValue);
                }function d(a, d) {
                    for (var e = a, f = 1, l = []; e = e.nextSibling;) {
                        if (c(e) && (f--, 0 === f)) return l;l.push(e);b(e) && f++;
                    }if (!d) throw Error("Cannot find closing comment tag to match: " + a.nodeValue);return null;
                }function e(a, b) {
                    var c = d(a, b);return c ? 0 < c.length ? c[c.length - 1].nextSibling : a.nextSibling : null;
                }var f = t && "\x3c!--test--\x3e" === t.createComment("test").text,
                    g = f ? /^\x3c!--\s*ko(?:\s+([\s\S]+))?\s*--\x3e$/ : /^\s*ko(?:\s+([\s\S]+))?\s*$/,
                    h = f ? /^\x3c!--\s*\/ko\s*--\x3e$/ : /^\s*\/ko\s*$/,
                    l = { ul: !0, ol: !0 };a.f = { aa: {}, childNodes: function childNodes(a) {
                        return b(a) ? d(a) : a.childNodes;
                    }, za: function za(c) {
                        if (b(c)) {
                            c = a.f.childNodes(c);for (var d = 0, e = c.length; d < e; d++) {
                                a.removeNode(c[d]);
                            }
                        } else a.a.rb(c);
                    }, fa: function fa(c, d) {
                        if (b(c)) {
                            a.f.za(c);for (var e = c.nextSibling, f = 0, l = d.length; f < l; f++) {
                                e.parentNode.insertBefore(d[f], e);
                            }
                        } else a.a.fa(c, d);
                    }, qc: function qc(a, c) {
                        b(a) ? a.parentNode.insertBefore(c, a.nextSibling) : a.firstChild ? a.insertBefore(c, a.firstChild) : a.appendChild(c);
                    }, kc: function kc(c, d, e) {
                        e ? b(c) ? c.parentNode.insertBefore(d, e.nextSibling) : e.nextSibling ? c.insertBefore(d, e.nextSibling) : c.appendChild(d) : a.f.qc(c, d);
                    }, firstChild: function firstChild(a) {
                        return b(a) ? !a.nextSibling || c(a.nextSibling) ? null : a.nextSibling : a.firstChild;
                    }, nextSibling: function nextSibling(a) {
                        b(a) && (a = e(a));return a.nextSibling && c(a.nextSibling) ? null : a.nextSibling;
                    }, Yc: b, vd: function vd(a) {
                        return (a = (f ? a.text : a.nodeValue).match(g)) ? a[1] : null;
                    }, oc: function oc(d) {
                        if (l[a.a.A(d)]) {
                            var k = d.firstChild;if (k) {
                                do {
                                    if (1 === k.nodeType) {
                                        var f;f = k.firstChild;var g = null;if (f) {
                                            do {
                                                if (g) g.push(f);else if (b(f)) {
                                                    var h = e(f, !0);h ? f = h : g = [f];
                                                } else c(f) && (g = [f]);
                                            } while (f = f.nextSibling);
                                        }if (f = g) for (g = k.nextSibling, h = 0; h < f.length; h++) {
                                            g ? d.insertBefore(f[h], g) : d.appendChild(f[h]);
                                        }
                                    }
                                } while (k = k.nextSibling);
                            }
                        }
                    } };
            })();a.b("virtualElements", a.f);a.b("virtualElements.allowedBindings", a.f.aa);a.b("virtualElements.emptyNode", a.f.za);a.b("virtualElements.insertAfter", a.f.kc);a.b("virtualElements.prepend", a.f.qc);a.b("virtualElements.setDomNodeChildren", a.f.fa);(function () {
                a.S = function () {
                    this.Kc = {};
                };a.a.extend(a.S.prototype, { nodeHasBindings: function nodeHasBindings(b) {
                        switch (b.nodeType) {case 1:
                                return null != b.getAttribute("data-bind") || a.g.getComponentNameForNode(b);case 8:
                                return a.f.Yc(b);default:
                                return !1;}
                    }, getBindings: function getBindings(b, c) {
                        var d = this.getBindingsString(b, c),
                            d = d ? this.parseBindingsString(d, c, b) : null;return a.g.Rb(d, b, c, !1);
                    }, getBindingAccessors: function getBindingAccessors(b, c) {
                        var d = this.getBindingsString(b, c),
                            d = d ? this.parseBindingsString(d, c, b, { valueAccessors: !0 }) : null;return a.g.Rb(d, b, c, !0);
                    }, getBindingsString: function getBindingsString(b) {
                        switch (b.nodeType) {case 1:
                                return b.getAttribute("data-bind");case 8:
                                return a.f.vd(b);default:
                                return null;}
                    }, parseBindingsString: function parseBindingsString(b, c, d, e) {
                        try {
                            var f = this.Kc,
                                g = b + (e && e.valueAccessors || ""),
                                h;if (!(h = f[g])) {
                                var l,
                                    m = "with($context){with($data||{}){return{" + a.h.Xa(b, e) + "}}}";l = new Function("$context", "$element", m);h = f[g] = l;
                            }return h(c, d);
                        } catch (k) {
                            throw k.message = "Unable to parse bindings.\nBindings value: " + b + "\nMessage: " + k.message, k;
                        }
                    } });a.S.instance = new a.S();
            })();a.b("bindingProvider", a.S);(function () {
                function b(a) {
                    return function () {
                        return a;
                    };
                }function c(a) {
                    return a();
                }function d(b) {
                    return a.a.Ea(a.l.w(b), function (a, c) {
                        return function () {
                            return b()[c];
                        };
                    });
                }function e(c, e, k) {
                    return "function" === typeof c ? d(c.bind(null, e, k)) : a.a.Ea(c, b);
                }function f(a, b) {
                    return d(this.getBindings.bind(this, a, b));
                }function g(b, c, d) {
                    var e,
                        k = a.f.firstChild(c),
                        f = a.S.instance,
                        m = f.preprocessNode;if (m) {
                        for (; e = k;) {
                            k = a.f.nextSibling(e), m.call(f, e);
                        }k = a.f.firstChild(c);
                    }for (; e = k;) {
                        k = a.f.nextSibling(e), h(b, e, d);
                    }
                }function h(b, c, d) {
                    var e = !0,
                        k = 1 === c.nodeType;k && a.f.oc(c);if (k && d || a.S.instance.nodeHasBindings(c)) e = m(c, null, b, d).shouldBindDescendants;e && !r[a.a.A(c)] && g(b, c, !k);
                }function l(b) {
                    var c = [],
                        d = {},
                        e = [];a.a.D(b, function X(k) {
                        if (!d[k]) {
                            var f = a.getBindingHandler(k);f && (f.after && (e.push(k), a.a.r(f.after, function (c) {
                                if (b[c]) {
                                    if (-1 !== a.a.o(e, c)) throw Error("Cannot combine the following bindings, because they have a cyclic dependency: " + e.join(", "));
                                    X(c);
                                }
                            }), e.length--), c.push({ key: k, jc: f }));d[k] = !0;
                        }
                    });return c;
                }function m(b, d, e, k) {
                    var m = a.a.e.get(b, q);if (!d) {
                        if (m) throw Error("You cannot apply bindings multiple times to the same element.");a.a.e.set(b, q, !0);
                    }!m && k && a.xc(b, e);var g;if (d && "function" !== typeof d) g = d;else {
                        var h = a.S.instance,
                            r = h.getBindingAccessors || f,
                            p = a.B(function () {
                            (g = d ? d(e, b) : r.call(h, b, e)) && e.Q && e.Q();return g;
                        }, null, { i: b });g && p.ca() || (p = null);
                    }var s;if (g) {
                        var t = p ? function (a) {
                            return function () {
                                return c(p()[a]);
                            };
                        } : function (a) {
                            return g[a];
                        },
                            u = function u() {
                            return a.a.Ea(p ? p() : g, c);
                        };u.get = function (a) {
                            return g[a] && c(t(a));
                        };u.has = function (a) {
                            return a in g;
                        };k = l(g);a.a.r(k, function (c) {
                            var d = c.jc.init,
                                k = c.jc.update,
                                f = c.key;if (8 === b.nodeType && !a.f.aa[f]) throw Error("The binding '" + f + "' cannot be used with virtual elements");try {
                                "function" == typeof d && a.l.w(function () {
                                    var a = d(b, t(f), u, e.$data, e);if (a && a.controlsDescendantBindings) {
                                        if (s !== n) throw Error("Multiple bindings (" + s + " and " + f + ") are trying to control descendant bindings of the same element. You cannot use these bindings together on the same element.");
                                        s = f;
                                    }
                                }), "function" == typeof k && a.B(function () {
                                    k(b, t(f), u, e.$data, e);
                                }, null, { i: b });
                            } catch (m) {
                                throw m.message = 'Unable to process binding "' + f + ": " + g[f] + '"\nMessage: ' + m.message, m;
                            }
                        });
                    }return { shouldBindDescendants: s === n };
                }function k(b) {
                    return b && b instanceof a.R ? b : new a.R(b);
                }a.d = {};var r = { script: !0, textarea: !0, template: !0 };a.getBindingHandler = function (b) {
                    return a.d[b];
                };a.R = function (b, c, d, e, k) {
                    function f() {
                        var k = g ? b() : b,
                            m = a.a.c(k);c ? (c.Q && c.Q(), a.a.extend(l, c), l.Q = r) : (l.$parents = [], l.$root = m, l.ko = a);l.$rawData = k;l.$data = m;d && (l[d] = m);e && e(l, c, m);return l.$data;
                    }function m() {
                        return h && !a.a.Tb(h);
                    }var l = this,
                        g = "function" == typeof b && !a.I(b),
                        h,
                        r;k && k.exportDependencies ? f() : (r = a.B(f, null, { ya: m, i: !0 }), r.ca() && (l.Q = r, r.equalityComparer = null, h = [], r.Dc = function (b) {
                        h.push(b);a.a.G.qa(b, function (b) {
                            a.a.Na(h, b);h.length || (r.k(), l.Q = r = n);
                        });
                    }));
                };a.R.prototype.createChildContext = function (b, c, d, e) {
                    return new a.R(b, this, c, function (a, b) {
                        a.$parentContext = b;a.$parent = b.$data;a.$parents = (b.$parents || []).slice(0);a.$parents.unshift(a.$parent);
                        d && d(a);
                    }, e);
                };a.R.prototype.extend = function (b) {
                    return new a.R(this.Q || this.$data, this, null, function (c, d) {
                        c.$rawData = d.$rawData;a.a.extend(c, "function" == typeof b ? b() : b);
                    });
                };a.R.prototype.ac = function (a, b) {
                    return this.createChildContext(a, b, null, { exportDependencies: !0 });
                };var q = a.a.e.J(),
                    p = a.a.e.J();a.xc = function (b, c) {
                    if (2 == arguments.length) a.a.e.set(b, p, c), c.Q && c.Q.Dc(b);else return a.a.e.get(b, p);
                };a.La = function (b, c, d) {
                    1 === b.nodeType && a.f.oc(b);return m(b, c, k(d), !0);
                };a.Ic = function (b, c, d) {
                    d = k(d);return a.La(b, e(c, d, b), d);
                };a.hb = function (a, b) {
                    1 !== b.nodeType && 8 !== b.nodeType || g(k(a), b, !0);
                };a.Ub = function (a, b) {
                    !u && x.jQuery && (u = x.jQuery);if (b && 1 !== b.nodeType && 8 !== b.nodeType) throw Error("ko.applyBindings: first parameter should be your view model; second parameter should be a DOM node");b = b || x.document.body;h(k(a), b, !0);
                };a.nb = function (b) {
                    switch (b.nodeType) {case 1:case 8:
                            var c = a.xc(b);if (c) return c;if (b.parentNode) return a.nb(b.parentNode);}return n;
                };a.Oc = function (b) {
                    return (b = a.nb(b)) ? b.$data : n;
                };a.b("bindingHandlers", a.d);a.b("applyBindings", a.Ub);a.b("applyBindingsToDescendants", a.hb);a.b("applyBindingAccessorsToNode", a.La);a.b("applyBindingsToNode", a.Ic);a.b("contextFor", a.nb);a.b("dataFor", a.Oc);
            })();(function (b) {
                function c(c, e) {
                    var m = f.hasOwnProperty(c) ? f[c] : b,
                        k;m ? m.Y(e) : (m = f[c] = new a.K(), m.Y(e), d(c, function (b, d) {
                        var e = !(!d || !d.synchronous);g[c] = { definition: b, dd: e };delete f[c];k || e ? m.notifySubscribers(b) : a.Z.Za(function () {
                            m.notifySubscribers(b);
                        });
                    }), k = !0);
                }function d(a, b) {
                    e("getConfig", [a], function (c) {
                        c ? e("loadComponent", [a, c], function (a) {
                            b(a, c);
                        }) : b(null, null);
                    });
                }function e(c, d, f, k) {
                    k || (k = a.g.loaders.slice(0));var g = k.shift();if (g) {
                        var q = g[c];if (q) {
                            var p = !1;if (q.apply(g, d.concat(function (a) {
                                p ? f(null) : null !== a ? f(a) : e(c, d, f, k);
                            })) !== b && (p = !0, !g.suppressLoaderExceptions)) throw Error("Component loaders must supply values by invoking the callback, not by returning values synchronously.");
                        } else e(c, d, f, k);
                    } else f(null);
                }var f = {},
                    g = {};a.g = { get: function get(d, e) {
                        var f = g.hasOwnProperty(d) ? g[d] : b;f ? f.dd ? a.l.w(function () {
                            e(f.definition);
                        }) : a.Z.Za(function () {
                            e(f.definition);
                        }) : c(d, e);
                    }, $b: function $b(a) {
                        delete g[a];
                    }, Nb: e };a.g.loaders = [];a.b("components", a.g);a.b("components.get", a.g.get);a.b("components.clearCachedDefinition", a.g.$b);
            })();(function () {
                function b(b, c, d, e) {
                    function g() {
                        0 === --y && e(h);
                    }var h = {},
                        y = 2,
                        v = d.template;d = d.viewModel;v ? f(c, v, function (c) {
                        a.g.Nb("loadTemplate", [b, c], function (a) {
                            h.template = a;g();
                        });
                    }) : g();d ? f(c, d, function (c) {
                        a.g.Nb("loadViewModel", [b, c], function (a) {
                            h[l] = a;g();
                        });
                    }) : g();
                }function c(a, b, d) {
                    if ("function" === typeof b) d(function (a) {
                        return new b(a);
                    });else if ("function" === typeof b[l]) d(b[l]);else if ("instance" in b) {
                        var e = b.instance;d(function () {
                            return e;
                        });
                    } else "viewModel" in b ? c(a, b.viewModel, d) : a("Unknown viewModel value: " + b);
                }function d(b) {
                    switch (a.a.A(b)) {case "script":
                            return a.a.na(b.text);case "textarea":
                            return a.a.na(b.value);case "template":
                            if (e(b.content)) return a.a.wa(b.content.childNodes);}return a.a.wa(b.childNodes);
                }function e(a) {
                    return x.DocumentFragment ? a instanceof DocumentFragment : a && 11 === a.nodeType;
                }function f(a, b, c) {
                    "string" === typeof b.require ? O || x.require ? (O || x.require)([b.require], c) : a("Uses require, but no AMD loader is present") : c(b);
                }function g(a) {
                    return function (b) {
                        throw Error("Component '" + a + "': " + b);
                    };
                }var h = {};a.g.register = function (b, c) {
                    if (!c) throw Error("Invalid configuration for " + b);if (a.g.wb(b)) throw Error("Component " + b + " is already registered");h[b] = c;
                };a.g.wb = function (a) {
                    return h.hasOwnProperty(a);
                };a.g.ud = function (b) {
                    delete h[b];a.g.$b(b);
                };a.g.cc = { getConfig: function getConfig(a, b) {
                        b(h.hasOwnProperty(a) ? h[a] : null);
                    }, loadComponent: function loadComponent(a, c, d) {
                        var e = g(a);f(e, c, function (c) {
                            b(a, e, c, d);
                        });
                    }, loadTemplate: function loadTemplate(b, c, f) {
                        b = g(b);if ("string" === typeof c) f(a.a.na(c));else if (c instanceof Array) f(c);else if (e(c)) f(a.a.W(c.childNodes));else if (c.element) {
                            if (c = c.element, x.HTMLElement ? c instanceof HTMLElement : c && c.tagName && 1 === c.nodeType) f(d(c));else if ("string" === typeof c) {
                                var l = t.getElementById(c);l ? f(d(l)) : b("Cannot find element with ID " + c);
                            } else b("Unknown element type: " + c);
                        } else b("Unknown template value: " + c);
                    }, loadViewModel: function loadViewModel(a, b, d) {
                        c(g(a), b, d);
                    } };var l = "createViewModel";a.b("components.register", a.g.register);a.b("components.isRegistered", a.g.wb);a.b("components.unregister", a.g.ud);a.b("components.defaultLoader", a.g.cc);a.g.loaders.push(a.g.cc);a.g.Ec = h;
            })();(function () {
                function b(b, e) {
                    var f = b.getAttribute("params");if (f) {
                        var f = c.parseBindingsString(f, e, b, { valueAccessors: !0, bindingParams: !0 }),
                            f = a.a.Ea(f, function (c) {
                            return a.m(c, null, { i: b });
                        }),
                            g = a.a.Ea(f, function (c) {
                            var e = c.p();return c.ca() ? a.m({ read: function read() {
                                    return a.a.c(c());
                                }, write: a.Da(e) && function (a) {
                                    c()(a);
                                }, i: b }) : e;
                        });g.hasOwnProperty("$raw") || (g.$raw = f);return g;
                    }return { $raw: {} };
                }a.g.getComponentNameForNode = function (b) {
                    var c = a.a.A(b);if (a.g.wb(c) && (-1 != c.indexOf("-") || "[object HTMLUnknownElement]" == "" + b || 8 >= a.a.C && b.tagName === c)) return c;
                };a.g.Rb = function (c, e, f, g) {
                    if (1 === e.nodeType) {
                        var h = a.g.getComponentNameForNode(e);if (h) {
                            c = c || {};if (c.component) throw Error('Cannot use the "component" binding on a custom element matching a component');var l = { name: h, params: b(e, f) };c.component = g ? function () {
                                return l;
                            } : l;
                        }
                    }return c;
                };var c = new a.S();9 > a.a.C && (a.g.register = function (a) {
                    return function (b) {
                        t.createElement(b);return a.apply(this, arguments);
                    };
                }(a.g.register), t.createDocumentFragment = function (b) {
                    return function () {
                        var c = b(),
                            f = a.g.Ec,
                            g;for (g in f) {
                            f.hasOwnProperty(g) && c.createElement(g);
                        }return c;
                    };
                }(t.createDocumentFragment));
            })();(function (b) {
                function c(b, c, d) {
                    c = c.template;if (!c) throw Error("Component '" + b + "' has no template");b = a.a.wa(c);a.f.fa(d, b);
                }function d(a, b, c, d) {
                    var e = a.createViewModel;return e ? e.call(a, d, { element: b, templateNodes: c }) : d;
                }var e = 0;a.d.component = { init: function init(f, g, h, l, m) {
                        function k() {
                            var a = r && r.dispose;"function" === typeof a && a.call(r);q = r = null;
                        }var r,
                            q,
                            p = a.a.W(a.f.childNodes(f));a.a.G.qa(f, k);a.m(function () {
                            var l = a.a.c(g()),
                                h,
                                v;"string" === typeof l ? h = l : (h = a.a.c(l.name), v = a.a.c(l.params));if (!h) throw Error("No component name specified");var n = q = ++e;a.g.get(h, function (e) {
                                if (q === n) {
                                    k();if (!e) throw Error("Unknown component '" + h + "'");c(h, e, f);var l = d(e, f, p, v);e = m.createChildContext(l, b, function (a) {
                                        a.$component = l;a.$componentTemplateNodes = p;
                                    });r = l;a.hb(e, f);
                                }
                            });
                        }, null, { i: f });return { controlsDescendantBindings: !0 };
                    } };a.f.aa.component = !0;
            })();var Q = { "class": "className", "for": "htmlFor" };a.d.attr = { update: function update(b, c) {
                    var d = a.a.c(c()) || {};a.a.D(d, function (c, d) {
                        d = a.a.c(d);var g = !1 === d || null === d || d === n;g && b.removeAttribute(c);8 >= a.a.C && c in Q ? (c = Q[c], g ? b.removeAttribute(c) : b[c] = d) : g || b.setAttribute(c, d.toString());"name" === c && a.a.vc(b, g ? "" : d.toString());
                    });
                } };(function () {
                a.d.checked = { after: ["value", "attr"], init: function init(b, c, d) {
                        function e() {
                            var e = b.checked,
                                f = p ? g() : e;if (!a.xa.Va() && (!l || e)) {
                                var h = a.l.w(c);if (k) {
                                    var m = r ? h.p() : h;q !== f ? (e && (a.a.ra(m, f, !0), a.a.ra(m, q, !1)), q = f) : a.a.ra(m, f, e);r && a.Da(h) && h(m);
                                } else a.h.Ga(h, d, "checked", f, !0);
                            }
                        }function f() {
                            var d = a.a.c(c());b.checked = k ? 0 <= a.a.o(d, g()) : h ? d : g() === d;
                        }var g = a.rc(function () {
                            return d.has("checkedValue") ? a.a.c(d.get("checkedValue")) : d.has("value") ? a.a.c(d.get("value")) : b.value;
                        }),
                            h = "checkbox" == b.type,
                            l = "radio" == b.type;if (h || l) {
                            var m = c(),
                                k = h && a.a.c(m) instanceof Array,
                                r = !(k && m.push && m.splice),
                                q = k ? g() : n,
                                p = l || k;l && !b.name && a.d.uniqueName.init(b, function () {
                                return !0;
                            });a.m(e, null, { i: b });a.a.q(b, "click", e);a.m(f, null, { i: b });m = n;
                        }
                    } };a.h.ga.checked = !0;a.d.checkedValue = { update: function update(b, c) {
                        b.value = a.a.c(c());
                    } };
            })();a.d.css = { update: function update(b, c) {
                    var d = a.a.c(c());null !== d && "object" == (typeof d === "undefined" ? "undefined" : _typeof(d)) ? a.a.D(d, function (c, d) {
                        d = a.a.c(d);a.a.fb(b, c, d);
                    }) : (d = a.a.cb(String(d || "")), a.a.fb(b, b.__ko__cssValue, !1), b.__ko__cssValue = d, a.a.fb(b, d, !0));
                } };a.d.enable = { update: function update(b, c) {
                    var d = a.a.c(c());
                    d && b.disabled ? b.removeAttribute("disabled") : d || b.disabled || (b.disabled = !0);
                } };a.d.disable = { update: function update(b, c) {
                    a.d.enable.update(b, function () {
                        return !a.a.c(c());
                    });
                } };a.d.event = { init: function init(b, c, d, e, f) {
                    var g = c() || {};a.a.D(g, function (g) {
                        "string" == typeof g && a.a.q(b, g, function (b) {
                            var m,
                                k = c()[g];if (k) {
                                try {
                                    var r = a.a.W(arguments);e = f.$data;r.unshift(e);m = k.apply(e, r);
                                } finally {
                                    !0 !== m && (b.preventDefault ? b.preventDefault() : b.returnValue = !1);
                                }!1 === d.get(g + "Bubble") && (b.cancelBubble = !0, b.stopPropagation && b.stopPropagation());
                            }
                        });
                    });
                } };
            a.d.foreach = { mc: function mc(b) {
                    return function () {
                        var c = b(),
                            d = a.a.Bb(c);if (!d || "number" == typeof d.length) return { foreach: c, templateEngine: a.X.vb };a.a.c(c);return { foreach: d.data, as: d.as, includeDestroyed: d.includeDestroyed, afterAdd: d.afterAdd, beforeRemove: d.beforeRemove, afterRender: d.afterRender, beforeMove: d.beforeMove, afterMove: d.afterMove, templateEngine: a.X.vb };
                    };
                }, init: function init(b, c) {
                    return a.d.template.init(b, a.d.foreach.mc(c));
                }, update: function update(b, c, d, e, f) {
                    return a.d.template.update(b, a.d.foreach.mc(c), d, e, f);
                } };a.h.va.foreach = !1;a.f.aa.foreach = !0;a.d.hasfocus = { init: function init(b, c, d) {
                    function e(e) {
                        b.__ko_hasfocusUpdating = !0;var f = b.ownerDocument;if ("activeElement" in f) {
                            var g;try {
                                g = f.activeElement;
                            } catch (k) {
                                g = f.body;
                            }e = g === b;
                        }f = c();a.h.Ga(f, d, "hasfocus", e, !0);b.__ko_hasfocusLastValue = e;b.__ko_hasfocusUpdating = !1;
                    }var f = e.bind(null, !0),
                        g = e.bind(null, !1);a.a.q(b, "focus", f);a.a.q(b, "focusin", f);a.a.q(b, "blur", g);a.a.q(b, "focusout", g);
                }, update: function update(b, c) {
                    var d = !!a.a.c(c());b.__ko_hasfocusUpdating || b.__ko_hasfocusLastValue === d || (d ? b.focus() : b.blur(), !d && b.__ko_hasfocusLastValue && b.ownerDocument.body.focus(), a.l.w(a.a.Fa, null, [b, d ? "focusin" : "focusout"]));
                } };a.h.ga.hasfocus = !0;a.d.hasFocus = a.d.hasfocus;a.h.ga.hasFocus = !0;a.d.html = { init: function init() {
                    return { controlsDescendantBindings: !0 };
                }, update: function update(b, c) {
                    a.a.Eb(b, c());
                } };K("if");K("ifnot", !1, !0);K("with", !0, !1, function (a, c) {
                return a.ac(c);
            });var L = {};a.d.options = { init: function init(b) {
                    if ("select" !== a.a.A(b)) throw Error("options binding applies only to SELECT elements");for (; 0 < b.length;) {
                        b.remove(0);
                    }return { controlsDescendantBindings: !0 };
                }, update: function update(b, c, d) {
                    function e() {
                        return a.a.Ma(b.options, function (a) {
                            return a.selected;
                        });
                    }function f(a, b, c) {
                        var d = typeof b === "undefined" ? "undefined" : _typeof(b);return "function" == d ? b(a) : "string" == d ? a[b] : c;
                    }function g(c, e) {
                        if (A && k) a.j.ja(b, a.a.c(d.get("value")), !0);else if (p.length) {
                            var f = 0 <= a.a.o(p, a.j.u(e[0]));a.a.wc(e[0], f);A && !f && a.l.w(a.a.Fa, null, [b, "change"]);
                        }
                    }var h = b.multiple,
                        l = 0 != b.length && h ? b.scrollTop : null,
                        m = a.a.c(c()),
                        k = d.get("valueAllowUnset") && d.has("value"),
                        r = d.get("optionsIncludeDestroyed");c = {};var q,
                        p = [];k || (h ? p = a.a.ib(e(), a.j.u) : 0 <= b.selectedIndex && p.push(a.j.u(b.options[b.selectedIndex])));m && ("undefined" == typeof m.length && (m = [m]), q = a.a.Ma(m, function (b) {
                        return r || b === n || null === b || !a.a.c(b._destroy);
                    }), d.has("optionsCaption") && (m = a.a.c(d.get("optionsCaption")), null !== m && m !== n && q.unshift(L)));var A = !1;c.beforeRemove = function (a) {
                        b.removeChild(a);
                    };m = g;d.has("optionsAfterRender") && "function" == typeof d.get("optionsAfterRender") && (m = function m(b, c) {
                        g(0, c);
                        a.l.w(d.get("optionsAfterRender"), null, [c[0], b !== L ? b : n]);
                    });a.a.Db(b, q, function (c, e, g) {
                        g.length && (p = !k && g[0].selected ? [a.j.u(g[0])] : [], A = !0);e = b.ownerDocument.createElement("option");c === L ? (a.a.bb(e, d.get("optionsCaption")), a.j.ja(e, n)) : (g = f(c, d.get("optionsValue"), c), a.j.ja(e, a.a.c(g)), c = f(c, d.get("optionsText"), g), a.a.bb(e, c));return [e];
                    }, c, m);a.l.w(function () {
                        k ? a.j.ja(b, a.a.c(d.get("value")), !0) : (h ? p.length && e().length < p.length : p.length && 0 <= b.selectedIndex ? a.j.u(b.options[b.selectedIndex]) !== p[0] : p.length || 0 <= b.selectedIndex) && a.a.Fa(b, "change");
                    });a.a.Sc(b);l && 20 < Math.abs(l - b.scrollTop) && (b.scrollTop = l);
                } };a.d.options.zb = a.a.e.J();a.d.selectedOptions = { after: ["options", "foreach"], init: function init(b, c, d) {
                    a.a.q(b, "change", function () {
                        var e = c(),
                            f = [];a.a.r(b.getElementsByTagName("option"), function (b) {
                            b.selected && f.push(a.j.u(b));
                        });a.h.Ga(e, d, "selectedOptions", f);
                    });
                }, update: function update(b, c) {
                    if ("select" != a.a.A(b)) throw Error("values binding applies only to SELECT elements");var d = a.a.c(c()),
                        e = b.scrollTop;
                    d && "number" == typeof d.length && a.a.r(b.getElementsByTagName("option"), function (b) {
                        var c = 0 <= a.a.o(d, a.j.u(b));b.selected != c && a.a.wc(b, c);
                    });b.scrollTop = e;
                } };a.h.ga.selectedOptions = !0;a.d.style = { update: function update(b, c) {
                    var d = a.a.c(c() || {});a.a.D(d, function (c, d) {
                        d = a.a.c(d);if (null === d || d === n || !1 === d) d = "";b.style[c] = d;
                    });
                } };a.d.submit = { init: function init(b, c, d, e, f) {
                    if ("function" != typeof c()) throw Error("The value for a submit binding must be a function");a.a.q(b, "submit", function (a) {
                        var d,
                            e = c();try {
                            d = e.call(f.$data, b);
                        } finally {
                            !0 !== d && (a.preventDefault ? a.preventDefault() : a.returnValue = !1);
                        }
                    });
                } };a.d.text = { init: function init() {
                    return { controlsDescendantBindings: !0 };
                }, update: function update(b, c) {
                    a.a.bb(b, c());
                } };a.f.aa.text = !0;(function () {
                if (x && x.navigator) var b = function b(a) {
                    if (a) return parseFloat(a[1]);
                },
                    c = x.opera && x.opera.version && parseInt(x.opera.version()),
                    d = x.navigator.userAgent,
                    e = b(d.match(/^(?:(?!chrome).)*version\/([^ ]*) safari/i)),
                    f = b(d.match(/Firefox\/([^ ]*)/));if (10 > a.a.C) var g = a.a.e.J(),
                    h = a.a.e.J(),
                    l = function l(b) {
                    var c = this.activeElement;(c = c && a.a.e.get(c, h)) && c(b);
                },
                    m = function m(b, c) {
                    var d = b.ownerDocument;a.a.e.get(d, g) || (a.a.e.set(d, g, !0), a.a.q(d, "selectionchange", l));a.a.e.set(b, h, c);
                };a.d.textInput = { init: function init(b, d, g) {
                        function l(c, d) {
                            a.a.q(b, c, d);
                        }function h() {
                            var c = a.a.c(d());if (null === c || c === n) c = "";u !== n && c === u ? a.a.setTimeout(h, 4) : b.value !== c && (s = c, b.value = c);
                        }function y() {
                            t || (u = b.value, t = a.a.setTimeout(v, 4));
                        }function v() {
                            clearTimeout(t);u = t = n;var c = b.value;s !== c && (s = c, a.h.Ga(d(), g, "textInput", c));
                        }var s = b.value,
                            t,
                            u,
                            x = 9 == a.a.C ? y : v;10 > a.a.C ? (l("propertychange", function (a) {
                            "value" === a.propertyName && x(a);
                        }), 8 == a.a.C && (l("keyup", v), l("keydown", v)), 8 <= a.a.C && (m(b, x), l("dragend", y))) : (l("input", v), 5 > e && "textarea" === a.a.A(b) ? (l("keydown", y), l("paste", y), l("cut", y)) : 11 > c ? l("keydown", y) : 4 > f && (l("DOMAutoComplete", v), l("dragdrop", v), l("drop", v)));l("change", v);a.m(h, null, { i: b });
                    } };a.h.ga.textInput = !0;a.d.textinput = { preprocess: function preprocess(a, b, c) {
                        c("textInput", a);
                    } };
            })();a.d.uniqueName = { init: function init(b, c) {
                    if (c()) {
                        var d = "ko_unique_" + ++a.d.uniqueName.Nc;a.a.vc(b, d);
                    }
                } };a.d.uniqueName.Nc = 0;a.d.value = { after: ["options", "foreach"], init: function init(b, c, d) {
                    if ("input" != b.tagName.toLowerCase() || "checkbox" != b.type && "radio" != b.type) {
                        var e = ["change"],
                            f = d.get("valueUpdate"),
                            g = !1,
                            h = null;f && ("string" == typeof f && (f = [f]), a.a.ta(e, f), e = a.a.Wb(e));var l = function l() {
                            h = null;g = !1;var e = c(),
                                f = a.j.u(b);a.h.Ga(e, d, "value", f);
                        };!a.a.C || "input" != b.tagName.toLowerCase() || "text" != b.type || "off" == b.autocomplete || b.form && "off" == b.form.autocomplete || -1 != a.a.o(e, "propertychange") || (a.a.q(b, "propertychange", function () {
                            g = !0;
                        }), a.a.q(b, "focus", function () {
                            g = !1;
                        }), a.a.q(b, "blur", function () {
                            g && l();
                        }));a.a.r(e, function (c) {
                            var d = l;a.a.sd(c, "after") && (d = function d() {
                                h = a.j.u(b);a.a.setTimeout(l, 0);
                            }, c = c.substring(5));a.a.q(b, c, d);
                        });var m = function m() {
                            var e = a.a.c(c()),
                                f = a.j.u(b);if (null !== h && e === h) a.a.setTimeout(m, 0);else if (e !== f) if ("select" === a.a.A(b)) {
                                var g = d.get("valueAllowUnset"),
                                    f = function f() {
                                    a.j.ja(b, e, g);
                                };f();g || e === a.j.u(b) ? a.a.setTimeout(f, 0) : a.l.w(a.a.Fa, null, [b, "change"]);
                            } else a.j.ja(b, e);
                        };a.m(m, null, { i: b });
                    } else a.La(b, { checkedValue: c });
                }, update: function update() {} };a.h.ga.value = !0;a.d.visible = { update: function update(b, c) {
                    var d = a.a.c(c()),
                        e = "none" != b.style.display;d && !e ? b.style.display = "" : !d && e && (b.style.display = "none");
                } };(function (b) {
                a.d[b] = { init: function init(c, d, e, f, g) {
                        return a.d.event.init.call(this, c, function () {
                            var a = {};a[b] = d();return a;
                        }, e, f, g);
                    } };
            })("click");a.P = function () {};a.P.prototype.renderTemplateSource = function () {
                throw Error("Override renderTemplateSource");
            };a.P.prototype.createJavaScriptEvaluatorBlock = function () {
                throw Error("Override createJavaScriptEvaluatorBlock");
            };a.P.prototype.makeTemplateSource = function (b, c) {
                if ("string" == typeof b) {
                    c = c || t;var d = c.getElementById(b);if (!d) throw Error("Cannot find template with ID " + b);return new a.v.n(d);
                }if (1 == b.nodeType || 8 == b.nodeType) return new a.v.sa(b);throw Error("Unknown template type: " + b);
            };a.P.prototype.renderTemplate = function (a, c, d, e) {
                a = this.makeTemplateSource(a, e);return this.renderTemplateSource(a, c, d, e);
            };a.P.prototype.isTemplateRewritten = function (a, c) {
                return !1 === this.allowTemplateRewriting ? !0 : this.makeTemplateSource(a, c).data("isRewritten");
            };a.P.prototype.rewriteTemplate = function (a, c, d) {
                a = this.makeTemplateSource(a, d);c = c(a.text());a.text(c);a.data("isRewritten", !0);
            };a.b("templateEngine", a.P);a.Ib = function () {
                function b(b, c, d, h) {
                    b = a.h.Ab(b);for (var l = a.h.va, m = 0; m < b.length; m++) {
                        var k = b[m].key;if (l.hasOwnProperty(k)) {
                            var r = l[k];if ("function" === typeof r) {
                                if (k = r(b[m].value)) throw Error(k);
                            } else if (!r) throw Error("This template engine does not support the '" + k + "' binding within its templates");
                        }
                    }d = "ko.__tr_ambtns(function($context,$element){return(function(){return{ " + a.h.Xa(b, { valueAccessors: !0 }) + " } })()},'" + d.toLowerCase() + "')";return h.createJavaScriptEvaluatorBlock(d) + c;
                }var c = /(<([a-z]+\d*)(?:\s+(?!data-bind\s*=\s*)[a-z0-9\-]+(?:=(?:\"[^\"]*\"|\'[^\']*\'|[^>]*))?)*\s+)data-bind\s*=\s*(["'])([\s\S]*?)\3/gi,
                    d = /\x3c!--\s*ko\b\s*([\s\S]*?)\s*--\x3e/g;return { Tc: function Tc(b, c, d) {
                        c.isTemplateRewritten(b, d) || c.rewriteTemplate(b, function (b) {
                            return a.Ib.jd(b, c);
                        }, d);
                    }, jd: function jd(a, f) {
                        return a.replace(c, function (a, c, d, e, k) {
                            return b(k, c, d, f);
                        }).replace(d, function (a, c) {
                            return b(c, "\x3c!-- ko --\x3e", "#comment", f);
                        });
                    }, Jc: function Jc(b, c) {
                        return a.N.yb(function (d, h) {
                            var l = d.nextSibling;l && l.nodeName.toLowerCase() === c && a.La(l, b, h);
                        });
                    } };
            }();a.b("__tr_ambtns", a.Ib.Jc);(function () {
                a.v = {};a.v.n = function (b) {
                    if (this.n = b) {
                        var c = a.a.A(b);this.eb = "script" === c ? 1 : "textarea" === c ? 2 : "template" == c && b.content && 11 === b.content.nodeType ? 3 : 4;
                    }
                };a.v.n.prototype.text = function () {
                    var b = 1 === this.eb ? "text" : 2 === this.eb ? "value" : "innerHTML";if (0 == arguments.length) return this.n[b];var c = arguments[0];"innerHTML" === b ? a.a.Eb(this.n, c) : this.n[b] = c;
                };var b = a.a.e.J() + "_";a.v.n.prototype.data = function (c) {
                    if (1 === arguments.length) return a.a.e.get(this.n, b + c);a.a.e.set(this.n, b + c, arguments[1]);
                };var c = a.a.e.J();a.v.n.prototype.nodes = function () {
                    var b = this.n;if (0 == arguments.length) return (a.a.e.get(b, c) || {}).mb || (3 === this.eb ? b.content : 4 === this.eb ? b : n);a.a.e.set(b, c, { mb: arguments[0] });
                };a.v.sa = function (a) {
                    this.n = a;
                };a.v.sa.prototype = new a.v.n();a.v.sa.prototype.text = function () {
                    if (0 == arguments.length) {
                        var b = a.a.e.get(this.n, c) || {};b.Jb === n && b.mb && (b.Jb = b.mb.innerHTML);return b.Jb;
                    }a.a.e.set(this.n, c, { Jb: arguments[0] });
                };a.b("templateSources", a.v);a.b("templateSources.domElement", a.v.n);a.b("templateSources.anonymousTemplate", a.v.sa);
            })();(function () {
                function b(b, c, d) {
                    var e;for (c = a.f.nextSibling(c); b && (e = b) !== c;) {
                        b = a.f.nextSibling(e), d(e, b);
                    }
                }function c(c, d) {
                    if (c.length) {
                        var e = c[0],
                            f = c[c.length - 1],
                            g = e.parentNode,
                            h = a.S.instance,
                            n = h.preprocessNode;if (n) {
                            b(e, f, function (a, b) {
                                var c = a.previousSibling,
                                    d = n.call(h, a);d && (a === e && (e = d[0] || b), a === f && (f = d[d.length - 1] || c));
                            });c.length = 0;if (!e) return;e === f ? c.push(e) : (c.push(e, f), a.a.Ba(c, g));
                        }b(e, f, function (b) {
                            1 !== b.nodeType && 8 !== b.nodeType || a.Ub(d, b);
                        });b(e, f, function (b) {
                            1 !== b.nodeType && 8 !== b.nodeType || a.N.Cc(b, [d]);
                        });a.a.Ba(c, g);
                    }
                }function d(a) {
                    return a.nodeType ? a : 0 < a.length ? a[0] : null;
                }function e(b, e, f, h, q) {
                    q = q || {};var p = (b && d(b) || f || {}).ownerDocument,
                        n = q.templateEngine || g;
                    a.Ib.Tc(f, n, p);f = n.renderTemplate(f, h, q, p);if ("number" != typeof f.length || 0 < f.length && "number" != typeof f[0].nodeType) throw Error("Template engine must return an array of DOM nodes");p = !1;switch (e) {case "replaceChildren":
                            a.f.fa(b, f);p = !0;break;case "replaceNode":
                            a.a.uc(b, f);p = !0;break;case "ignoreTargetNode":
                            break;default:
                            throw Error("Unknown renderMode: " + e);}p && (c(f, h), q.afterRender && a.l.w(q.afterRender, null, [f, h.$data]));return f;
                }function f(b, c, d) {
                    return a.I(b) ? b() : "function" === typeof b ? b(c, d) : b;
                }
                var g;a.Fb = function (b) {
                    if (b != n && !(b instanceof a.P)) throw Error("templateEngine must inherit from ko.templateEngine");g = b;
                };a.Cb = function (b, c, k, h, q) {
                    k = k || {};if ((k.templateEngine || g) == n) throw Error("Set a template engine before calling renderTemplate");q = q || "replaceChildren";if (h) {
                        var p = d(h);return a.B(function () {
                            var g = c && c instanceof a.R ? c : new a.R(c, null, null, null, { exportDependencies: !0 }),
                                n = f(b, g.$data, g),
                                g = e(h, q, n, g, k);"replaceNode" == q && (h = g, p = d(h));
                        }, null, { ya: function ya() {
                                return !p || !a.a.qb(p);
                            }, i: p && "replaceNode" == q ? p.parentNode : p });
                    }return a.N.yb(function (d) {
                        a.Cb(b, c, k, d, "replaceNode");
                    });
                };a.pd = function (b, d, g, h, q) {
                    function p(a, b) {
                        c(b, t);g.afterRender && g.afterRender(b, a);t = null;
                    }function s(a, c) {
                        t = q.createChildContext(a, g.as, function (a) {
                            a.$index = c;
                        });var d = f(b, a, t);return e(null, "ignoreTargetNode", d, t, g);
                    }var t;return a.B(function () {
                        var b = a.a.c(d) || [];"undefined" == typeof b.length && (b = [b]);b = a.a.Ma(b, function (b) {
                            return g.includeDestroyed || b === n || null === b || !a.a.c(b._destroy);
                        });a.l.w(a.a.Db, null, [h, b, s, g, p]);
                    }, null, { i: h });
                };var h = a.a.e.J();a.d.template = { init: function init(b, c) {
                        var d = a.a.c(c());if ("string" == typeof d || d.name) a.f.za(b);else {
                            if ("nodes" in d) {
                                if (d = d.nodes || [], a.I(d)) throw Error('The "nodes" option must be a plain, non-observable array.');
                            } else d = a.f.childNodes(b);d = a.a.nc(d);new a.v.sa(b).nodes(d);
                        }return { controlsDescendantBindings: !0 };
                    }, update: function update(b, c, d, e, f) {
                        var g = c();c = a.a.c(g);d = !0;e = null;"string" == typeof c ? c = {} : (g = c.name, "if" in c && (d = a.a.c(c["if"])), d && "ifnot" in c && (d = !a.a.c(c.ifnot)));
                        "foreach" in c ? e = a.pd(g || b, d && c.foreach || [], c, b, f) : d ? (f = "data" in c ? f.ac(c.data, c.as) : f, e = a.Cb(g || b, f, c, b)) : a.f.za(b);f = e;(c = a.a.e.get(b, h)) && "function" == typeof c.k && c.k();a.a.e.set(b, h, f && f.ca() ? f : n);
                    } };a.h.va.template = function (b) {
                    b = a.h.Ab(b);return 1 == b.length && b[0].unknown || a.h.fd(b, "name") ? null : "This template engine does not support anonymous templates nested within its templates";
                };a.f.aa.template = !0;
            })();a.b("setTemplateEngine", a.Fb);a.b("renderTemplate", a.Cb);a.a.hc = function (a, c, d) {
                if (a.length && c.length) {
                    var e, f, g, h, l;for (e = f = 0; (!d || e < d) && (h = a[f]); ++f) {
                        for (g = 0; l = c[g]; ++g) {
                            if (h.value === l.value) {
                                h.moved = l.index;l.moved = h.index;c.splice(g, 1);e = g = 0;break;
                            }
                        }e += g;
                    }
                }
            };a.a.lb = function () {
                function b(b, d, e, f, g) {
                    var h = Math.min,
                        l = Math.max,
                        m = [],
                        k,
                        n = b.length,
                        q,
                        p = d.length,
                        s = p - n || 1,
                        t = n + p + 1,
                        v,
                        u,
                        x;for (k = 0; k <= n; k++) {
                        for (u = v, m.push(v = []), x = h(p, k + s), q = l(0, k - 1); q <= x; q++) {
                            v[q] = q ? k ? b[k - 1] === d[q - 1] ? u[q - 1] : h(u[q] || t, v[q - 1] || t) + 1 : q + 1 : k + 1;
                        }
                    }h = [];l = [];s = [];k = n;for (q = p; k || q;) {
                        p = m[k][q] - 1, q && p === m[k][q - 1] ? l.push(h[h.length] = { status: e,
                            value: d[--q], index: q }) : k && p === m[k - 1][q] ? s.push(h[h.length] = { status: f, value: b[--k], index: k }) : (--q, --k, g.sparse || h.push({ status: "retained", value: d[q] }));
                    }a.a.hc(s, l, !g.dontLimitMoves && 10 * n);return h.reverse();
                }return function (a, d, e) {
                    e = "boolean" === typeof e ? { dontLimitMoves: e } : e || {};a = a || [];d = d || [];return a.length < d.length ? b(a, d, "added", "deleted", e) : b(d, a, "deleted", "added", e);
                };
            }();a.b("utils.compareArrays", a.a.lb);(function () {
                function b(b, c, d, h, l) {
                    var m = [],
                        k = a.B(function () {
                        var k = c(d, l, a.a.Ba(m, b)) || [];0 < m.length && (a.a.uc(m, k), h && a.l.w(h, null, [d, k, l]));m.length = 0;a.a.ta(m, k);
                    }, null, { i: b, ya: function ya() {
                            return !a.a.Tb(m);
                        } });return { ea: m, B: k.ca() ? k : n };
                }var c = a.a.e.J(),
                    d = a.a.e.J();a.a.Db = function (e, f, g, h, l) {
                    function m(b, c) {
                        w = q[c];u !== c && (D[b] = w);w.tb(u++);a.a.Ba(w.ea, e);t.push(w);z.push(w);
                    }function k(b, c) {
                        if (b) for (var d = 0, e = c.length; d < e; d++) {
                            c[d] && a.a.r(c[d].ea, function (a) {
                                b(a, d, c[d].ka);
                            });
                        }
                    }f = f || [];h = h || {};var r = a.a.e.get(e, c) === n,
                        q = a.a.e.get(e, c) || [],
                        p = a.a.ib(q, function (a) {
                        return a.ka;
                    }),
                        s = a.a.lb(p, f, h.dontLimitMoves),
                        t = [],
                        v = 0,
                        u = 0,
                        x = [],
                        z = [];f = [];for (var D = [], p = [], w, C = 0, B, E; B = s[C]; C++) {
                        switch (E = B.moved, B.status) {case "deleted":
                                E === n && (w = q[v], w.B && (w.B.k(), w.B = n), a.a.Ba(w.ea, e).length && (h.beforeRemove && (t.push(w), z.push(w), w.ka === d ? w = null : f[C] = w), w && x.push.apply(x, w.ea)));v++;break;case "retained":
                                m(C, v++);break;case "added":
                                E !== n ? m(C, E) : (w = { ka: B.value, tb: a.O(u++) }, t.push(w), z.push(w), r || (p[C] = w));}
                    }a.a.e.set(e, c, t);k(h.beforeMove, D);a.a.r(x, h.beforeRemove ? a.ba : a.removeNode);for (var C = 0, r = a.f.firstChild(e), F; w = z[C]; C++) {
                        w.ea || a.a.extend(w, b(e, g, w.ka, l, w.tb));for (v = 0; s = w.ea[v]; r = s.nextSibling, F = s, v++) {
                            s !== r && a.f.kc(e, s, F);
                        }!w.ad && l && (l(w.ka, w.ea, w.tb), w.ad = !0);
                    }k(h.beforeRemove, f);for (C = 0; C < f.length; ++C) {
                        f[C] && (f[C].ka = d);
                    }k(h.afterMove, D);k(h.afterAdd, p);
                };
            })();a.b("utils.setDomNodeChildrenFromArrayMapping", a.a.Db);a.X = function () {
                this.allowTemplateRewriting = !1;
            };a.X.prototype = new a.P();a.X.prototype.renderTemplateSource = function (b, c, d, e) {
                if (c = (9 > a.a.C ? 0 : b.nodes) ? b.nodes() : null) return a.a.W(c.cloneNode(!0).childNodes);b = b.text();
                return a.a.na(b, e);
            };a.X.vb = new a.X();a.Fb(a.X.vb);a.b("nativeTemplateEngine", a.X);(function () {
                a.xb = function () {
                    var a = this.ed = function () {
                        if (!u || !u.tmpl) return 0;try {
                            if (0 <= u.tmpl.tag.tmpl.open.toString().indexOf("__")) return 2;
                        } catch (a) {}return 1;
                    }();this.renderTemplateSource = function (b, e, f, g) {
                        g = g || t;f = f || {};if (2 > a) throw Error("Your version of jQuery.tmpl is too old. Please upgrade to jQuery.tmpl 1.0.0pre or later.");var h = b.data("precompiled");h || (h = b.text() || "", h = u.template(null, "{{ko_with $item.koBindingContext}}" + h + "{{/ko_with}}"), b.data("precompiled", h));b = [e.$data];e = u.extend({ koBindingContext: e }, f.templateOptions);e = u.tmpl(h, b, e);e.appendTo(g.createElement("div"));u.fragments = {};return e;
                    };this.createJavaScriptEvaluatorBlock = function (a) {
                        return "{{ko_code ((function() { return " + a + " })()) }}";
                    };this.addTemplate = function (a, b) {
                        t.write("<script type='text/html' id='" + a + "'>" + b + "\x3c/script>");
                    };0 < a && (u.tmpl.tag.ko_code = { open: "__.push($1 || '');" }, u.tmpl.tag.ko_with = { open: "with($1) {", close: "} " });
                };a.xb.prototype = new a.P();var b = new a.xb();0 < b.ed && a.Fb(b);a.b("jqueryTmplTemplateEngine", a.xb);
            })();
        });
    })();
})();

//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function () {

    // Baseline setup
    // --------------

    // Establish the root object, `window` in the browser, or `exports` on the server.
    var root = this;

    // Save the previous value of the `_` variable.
    var previousUnderscore = root._;

    // Save bytes in the minified (but not gzipped) version:
    var ArrayProto = Array.prototype,
        ObjProto = Object.prototype,
        FuncProto = Function.prototype;

    // Create quick reference variables for speed access to core prototypes.
    var push = ArrayProto.push,
        slice = ArrayProto.slice,
        toString = ObjProto.toString,
        hasOwnProperty = ObjProto.hasOwnProperty;

    // All **ECMAScript 5** native function implementations that we hope to use
    // are declared here.
    var nativeIsArray = Array.isArray,
        nativeKeys = Object.keys,
        nativeBind = FuncProto.bind,
        nativeCreate = Object.create;

    // Naked function reference for surrogate-prototype-swapping.
    var Ctor = function Ctor() {};

    // Create a safe reference to the Underscore object for use below.
    var _ = function _(obj) {
        if (obj instanceof _) return obj;
        if (!(this instanceof _)) return new _(obj);
        this._wrapped = obj;
    };

    // Export the Underscore object for **Node.js**, with
    // backwards-compatibility for the old `require()` API. If we're in
    // the browser, add `_` as a global object.
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = _;
        }
        exports._ = _;
    } else {
        root._ = _;
    }

    // Current version.
    _.VERSION = '1.8.3';

    // Internal function that returns an efficient (for current engines) version
    // of the passed-in callback, to be repeatedly applied in other Underscore
    // functions.
    var optimizeCb = function optimizeCb(func, context, argCount) {
        if (context === void 0) return func;
        switch (argCount == null ? 3 : argCount) {
            case 1:
                return function (value) {
                    return func.call(context, value);
                };
            case 2:
                return function (value, other) {
                    return func.call(context, value, other);
                };
            case 3:
                return function (value, index, collection) {
                    return func.call(context, value, index, collection);
                };
            case 4:
                return function (accumulator, value, index, collection) {
                    return func.call(context, accumulator, value, index, collection);
                };
        }
        return function () {
            return func.apply(context, arguments);
        };
    };

    // A mostly-internal function to generate callbacks that can be applied
    // to each element in a collection, returning the desired result — either
    // identity, an arbitrary callback, a property matcher, or a property accessor.
    var cb = function cb(value, context, argCount) {
        if (value == null) return _.identity;
        if (_.isFunction(value)) return optimizeCb(value, context, argCount);
        if (_.isObject(value)) return _.matcher(value);
        return _.property(value);
    };
    _.iteratee = function (value, context) {
        return cb(value, context, Infinity);
    };

    // An internal function for creating assigner functions.
    var createAssigner = function createAssigner(keysFunc, undefinedOnly) {
        return function (obj) {
            var length = arguments.length;
            if (length < 2 || obj == null) return obj;
            for (var index = 1; index < length; index++) {
                var source = arguments[index],
                    keys = keysFunc(source),
                    l = keys.length;
                for (var i = 0; i < l; i++) {
                    var key = keys[i];
                    if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
                }
            }
            return obj;
        };
    };

    // An internal function for creating a new object that inherits from another.
    var baseCreate = function baseCreate(prototype) {
        if (!_.isObject(prototype)) return {};
        if (nativeCreate) return nativeCreate(prototype);
        Ctor.prototype = prototype;
        var result = new Ctor();
        Ctor.prototype = null;
        return result;
    };

    var property = function property(key) {
        return function (obj) {
            return obj == null ? void 0 : obj[key];
        };
    };

    // Helper for collection methods to determine whether a collection
    // should be iterated as an array or as an object
    // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
    // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
    var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
    var getLength = property('length');
    var isArrayLike = function isArrayLike(collection) {
        var length = getLength(collection);
        return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
    };

    // Collection Functions
    // --------------------

    // The cornerstone, an `each` implementation, aka `forEach`.
    // Handles raw objects in addition to array-likes. Treats all
    // sparse array-likes as if they were dense.
    _.each = _.forEach = function (obj, iteratee, context) {
        iteratee = optimizeCb(iteratee, context);
        var i, length;
        if (isArrayLike(obj)) {
            for (i = 0, length = obj.length; i < length; i++) {
                iteratee(obj[i], i, obj);
            }
        } else {
            var keys = _.keys(obj);
            for (i = 0, length = keys.length; i < length; i++) {
                iteratee(obj[keys[i]], keys[i], obj);
            }
        }
        return obj;
    };

    // Return the results of applying the iteratee to each element.
    _.map = _.collect = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length,
            results = Array(length);
        for (var index = 0; index < length; index++) {
            var currentKey = keys ? keys[index] : index;
            results[index] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
    };

    // Create a reducing function iterating left or right.
    function createReduce(dir) {
        // Optimized iterator function as using arguments.length
        // in the main function will deoptimize the, see #1991.
        function iterator(obj, iteratee, memo, keys, index, length) {
            for (; index >= 0 && index < length; index += dir) {
                var currentKey = keys ? keys[index] : index;
                memo = iteratee(memo, obj[currentKey], currentKey, obj);
            }
            return memo;
        }

        return function (obj, iteratee, memo, context) {
            iteratee = optimizeCb(iteratee, context, 4);
            var keys = !isArrayLike(obj) && _.keys(obj),
                length = (keys || obj).length,
                index = dir > 0 ? 0 : length - 1;
            // Determine the initial value if none is provided.
            if (arguments.length < 3) {
                memo = obj[keys ? keys[index] : index];
                index += dir;
            }
            return iterator(obj, iteratee, memo, keys, index, length);
        };
    }

    // **Reduce** builds up a single result from a list of values, aka `inject`,
    // or `foldl`.
    _.reduce = _.foldl = _.inject = createReduce(1);

    // The right-associative version of reduce, also known as `foldr`.
    _.reduceRight = _.foldr = createReduce(-1);

    // Return the first value which passes a truth test. Aliased as `detect`.
    _.find = _.detect = function (obj, predicate, context) {
        var key;
        if (isArrayLike(obj)) {
            key = _.findIndex(obj, predicate, context);
        } else {
            key = _.findKey(obj, predicate, context);
        }
        if (key !== void 0 && key !== -1) return obj[key];
    };

    // Return all the elements that pass a truth test.
    // Aliased as `select`.
    _.filter = _.select = function (obj, predicate, context) {
        var results = [];
        predicate = cb(predicate, context);
        _.each(obj, function (value, index, list) {
            if (predicate(value, index, list)) results.push(value);
        });
        return results;
    };

    // Return all the elements for which a truth test fails.
    _.reject = function (obj, predicate, context) {
        return _.filter(obj, _.negate(cb(predicate)), context);
    };

    // Determine whether all of the elements match a truth test.
    // Aliased as `all`.
    _.every = _.all = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length;
        for (var index = 0; index < length; index++) {
            var currentKey = keys ? keys[index] : index;
            if (!predicate(obj[currentKey], currentKey, obj)) return false;
        }
        return true;
    };

    // Determine if at least one element in the object matches a truth test.
    // Aliased as `any`.
    _.some = _.any = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length;
        for (var index = 0; index < length; index++) {
            var currentKey = keys ? keys[index] : index;
            if (predicate(obj[currentKey], currentKey, obj)) return true;
        }
        return false;
    };

    // Determine if the array or object contains a given item (using `===`).
    // Aliased as `includes` and `include`.
    _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
        if (!isArrayLike(obj)) obj = _.values(obj);
        if (typeof fromIndex != 'number' || guard) fromIndex = 0;
        return _.indexOf(obj, item, fromIndex) >= 0;
    };

    // Invoke a method (with arguments) on every item in a collection.
    _.invoke = function (obj, method) {
        var args = slice.call(arguments, 2);
        var isFunc = _.isFunction(method);
        return _.map(obj, function (value) {
            var func = isFunc ? method : value[method];
            return func == null ? func : func.apply(value, args);
        });
    };

    // Convenience version of a common use case of `map`: fetching a property.
    _.pluck = function (obj, key) {
        return _.map(obj, _.property(key));
    };

    // Convenience version of a common use case of `filter`: selecting only objects
    // containing specific `key:value` pairs.
    _.where = function (obj, attrs) {
        return _.filter(obj, _.matcher(attrs));
    };

    // Convenience version of a common use case of `find`: getting the first object
    // containing specific `key:value` pairs.
    _.findWhere = function (obj, attrs) {
        return _.find(obj, _.matcher(attrs));
    };

    // Return the maximum element (or element-based computation).
    _.max = function (obj, iteratee, context) {
        var result = -Infinity,
            lastComputed = -Infinity,
            value,
            computed;
        if (iteratee == null && obj != null) {
            obj = isArrayLike(obj) ? obj : _.values(obj);
            for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value > result) {
                    result = value;
                }
            }
        } else {
            iteratee = cb(iteratee, context);
            _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                    result = value;
                    lastComputed = computed;
                }
            });
        }
        return result;
    };

    // Return the minimum element (or element-based computation).
    _.min = function (obj, iteratee, context) {
        var result = Infinity,
            lastComputed = Infinity,
            value,
            computed;
        if (iteratee == null && obj != null) {
            obj = isArrayLike(obj) ? obj : _.values(obj);
            for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value < result) {
                    result = value;
                }
            }
        } else {
            iteratee = cb(iteratee, context);
            _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed < lastComputed || computed === Infinity && result === Infinity) {
                    result = value;
                    lastComputed = computed;
                }
            });
        }
        return result;
    };

    // Shuffle a collection, using the modern version of the
    // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
    _.shuffle = function (obj) {
        var set = isArrayLike(obj) ? obj : _.values(obj);
        var length = set.length;
        var shuffled = Array(length);
        for (var index = 0, rand; index < length; index++) {
            rand = _.random(0, index);
            if (rand !== index) shuffled[index] = shuffled[rand];
            shuffled[rand] = set[index];
        }
        return shuffled;
    };

    // Sample **n** random values from a collection.
    // If **n** is not specified, returns a single random element.
    // The internal `guard` argument allows it to work with `map`.
    _.sample = function (obj, n, guard) {
        if (n == null || guard) {
            if (!isArrayLike(obj)) obj = _.values(obj);
            return obj[_.random(obj.length - 1)];
        }
        return _.shuffle(obj).slice(0, Math.max(0, n));
    };

    // Sort the object's values by a criterion produced by an iteratee.
    _.sortBy = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        return _.pluck(_.map(obj, function (value, index, list) {
            return {
                value: value,
                index: index,
                criteria: iteratee(value, index, list)
            };
        }).sort(function (left, right) {
            var a = left.criteria;
            var b = right.criteria;
            if (a !== b) {
                if (a > b || a === void 0) return 1;
                if (a < b || b === void 0) return -1;
            }
            return left.index - right.index;
        }), 'value');
    };

    // An internal function used for aggregate "group by" operations.
    var group = function group(behavior) {
        return function (obj, iteratee, context) {
            var result = {};
            iteratee = cb(iteratee, context);
            _.each(obj, function (value, index) {
                var key = iteratee(value, index, obj);
                behavior(result, value, key);
            });
            return result;
        };
    };

    // Groups the object's values by a criterion. Pass either a string attribute
    // to group by, or a function that returns the criterion.
    _.groupBy = group(function (result, value, key) {
        if (_.has(result, key)) result[key].push(value);else result[key] = [value];
    });

    // Indexes the object's values by a criterion, similar to `groupBy`, but for
    // when you know that your index values will be unique.
    _.indexBy = group(function (result, value, key) {
        result[key] = value;
    });

    // Counts instances of an object that group by a certain criterion. Pass
    // either a string attribute to count by, or a function that returns the
    // criterion.
    _.countBy = group(function (result, value, key) {
        if (_.has(result, key)) result[key]++;else result[key] = 1;
    });

    // Safely create a real, live array from anything iterable.
    _.toArray = function (obj) {
        if (!obj) return [];
        if (_.isArray(obj)) return slice.call(obj);
        if (isArrayLike(obj)) return _.map(obj, _.identity);
        return _.values(obj);
    };

    // Return the number of elements in an object.
    _.size = function (obj) {
        if (obj == null) return 0;
        return isArrayLike(obj) ? obj.length : _.keys(obj).length;
    };

    // Split a collection into two arrays: one whose elements all satisfy the given
    // predicate, and one whose elements all do not satisfy the predicate.
    _.partition = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var pass = [],
            fail = [];
        _.each(obj, function (value, key, obj) {
            (predicate(value, key, obj) ? pass : fail).push(value);
        });
        return [pass, fail];
    };

    // Array Functions
    // ---------------

    // Get the first element of an array. Passing **n** will return the first N
    // values in the array. Aliased as `head` and `take`. The **guard** check
    // allows it to work with `_.map`.
    _.first = _.head = _.take = function (array, n, guard) {
        if (array == null) return void 0;
        if (n == null || guard) return array[0];
        return _.initial(array, array.length - n);
    };

    // Returns everything but the last entry of the array. Especially useful on
    // the arguments object. Passing **n** will return all the values in
    // the array, excluding the last N.
    _.initial = function (array, n, guard) {
        return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
    };

    // Get the last element of an array. Passing **n** will return the last N
    // values in the array.
    _.last = function (array, n, guard) {
        if (array == null) return void 0;
        if (n == null || guard) return array[array.length - 1];
        return _.rest(array, Math.max(0, array.length - n));
    };

    // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
    // Especially useful on the arguments object. Passing an **n** will return
    // the rest N values in the array.
    _.rest = _.tail = _.drop = function (array, n, guard) {
        return slice.call(array, n == null || guard ? 1 : n);
    };

    // Trim out all falsy values from an array.
    _.compact = function (array) {
        return _.filter(array, _.identity);
    };

    // Internal implementation of a recursive `flatten` function.
    var flatten = function flatten(input, shallow, strict, startIndex) {
        var output = [],
            idx = 0;
        for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
            var value = input[i];
            if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
                //flatten current level of array or arguments object
                if (!shallow) value = flatten(value, shallow, strict);
                var j = 0,
                    len = value.length;
                output.length += len;
                while (j < len) {
                    output[idx++] = value[j++];
                }
            } else if (!strict) {
                output[idx++] = value;
            }
        }
        return output;
    };

    // Flatten out an array, either recursively (by default), or just one level.
    _.flatten = function (array, shallow) {
        return flatten(array, shallow, false);
    };

    // Return a version of the array that does not contain the specified value(s).
    _.without = function (array) {
        return _.difference(array, slice.call(arguments, 1));
    };

    // Produce a duplicate-free version of the array. If the array has already
    // been sorted, you have the option of using a faster algorithm.
    // Aliased as `unique`.
    _.uniq = _.unique = function (array, isSorted, iteratee, context) {
        if (!_.isBoolean(isSorted)) {
            context = iteratee;
            iteratee = isSorted;
            isSorted = false;
        }
        if (iteratee != null) iteratee = cb(iteratee, context);
        var result = [];
        var seen = [];
        for (var i = 0, length = getLength(array); i < length; i++) {
            var value = array[i],
                computed = iteratee ? iteratee(value, i, array) : value;
            if (isSorted) {
                if (!i || seen !== computed) result.push(value);
                seen = computed;
            } else if (iteratee) {
                if (!_.contains(seen, computed)) {
                    seen.push(computed);
                    result.push(value);
                }
            } else if (!_.contains(result, value)) {
                result.push(value);
            }
        }
        return result;
    };

    // Produce an array that contains the union: each distinct element from all of
    // the passed-in arrays.
    _.union = function () {
        return _.uniq(flatten(arguments, true, true));
    };

    // Produce an array that contains every item shared between all the
    // passed-in arrays.
    _.intersection = function (array) {
        var result = [];
        var argsLength = arguments.length;
        for (var i = 0, length = getLength(array); i < length; i++) {
            var item = array[i];
            if (_.contains(result, item)) continue;
            for (var j = 1; j < argsLength; j++) {
                if (!_.contains(arguments[j], item)) break;
            }
            if (j === argsLength) result.push(item);
        }
        return result;
    };

    // Take the difference between one array and a number of other arrays.
    // Only the elements present in just the first array will remain.
    _.difference = function (array) {
        var rest = flatten(arguments, true, true, 1);
        return _.filter(array, function (value) {
            return !_.contains(rest, value);
        });
    };

    // Zip together multiple lists into a single array -- elements that share
    // an index go together.
    _.zip = function () {
        return _.unzip(arguments);
    };

    // Complement of _.zip. Unzip accepts an array of arrays and groups
    // each array's elements on shared indices
    _.unzip = function (array) {
        var length = array && _.max(array, getLength).length || 0;
        var result = Array(length);

        for (var index = 0; index < length; index++) {
            result[index] = _.pluck(array, index);
        }
        return result;
    };

    // Converts lists into objects. Pass either a single array of `[key, value]`
    // pairs, or two parallel arrays of the same length -- one of keys, and one of
    // the corresponding values.
    _.object = function (list, values) {
        var result = {};
        for (var i = 0, length = getLength(list); i < length; i++) {
            if (values) {
                result[list[i]] = values[i];
            } else {
                result[list[i][0]] = list[i][1];
            }
        }
        return result;
    };

    // Generator function to create the findIndex and findLastIndex functions
    function createPredicateIndexFinder(dir) {
        return function (array, predicate, context) {
            predicate = cb(predicate, context);
            var length = getLength(array);
            var index = dir > 0 ? 0 : length - 1;
            for (; index >= 0 && index < length; index += dir) {
                if (predicate(array[index], index, array)) return index;
            }
            return -1;
        };
    }

    // Returns the first index on an array-like that passes a predicate test
    _.findIndex = createPredicateIndexFinder(1);
    _.findLastIndex = createPredicateIndexFinder(-1);

    // Use a comparator function to figure out the smallest index at which
    // an object should be inserted so as to maintain order. Uses binary search.
    _.sortedIndex = function (array, obj, iteratee, context) {
        iteratee = cb(iteratee, context, 1);
        var value = iteratee(obj);
        var low = 0,
            high = getLength(array);
        while (low < high) {
            var mid = Math.floor((low + high) / 2);
            if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
        }
        return low;
    };

    // Generator function to create the indexOf and lastIndexOf functions
    function createIndexFinder(dir, predicateFind, sortedIndex) {
        return function (array, item, idx) {
            var i = 0,
                length = getLength(array);
            if (typeof idx == 'number') {
                if (dir > 0) {
                    i = idx >= 0 ? idx : Math.max(idx + length, i);
                } else {
                    length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
                }
            } else if (sortedIndex && idx && length) {
                idx = sortedIndex(array, item);
                return array[idx] === item ? idx : -1;
            }
            if (item !== item) {
                idx = predicateFind(slice.call(array, i, length), _.isNaN);
                return idx >= 0 ? idx + i : -1;
            }
            for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
                if (array[idx] === item) return idx;
            }
            return -1;
        };
    }

    // Return the position of the first occurrence of an item in an array,
    // or -1 if the item is not included in the array.
    // If the array is large and already in sort order, pass `true`
    // for **isSorted** to use binary search.
    _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
    _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

    // Generate an integer Array containing an arithmetic progression. A port of
    // the native Python `range()` function. See
    // [the Python documentation](http://docs.python.org/library/functions.html#range).
    _.range = function (start, stop, step) {
        if (stop == null) {
            stop = start || 0;
            start = 0;
        }
        step = step || 1;

        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var range = Array(length);

        for (var idx = 0; idx < length; idx++, start += step) {
            range[idx] = start;
        }

        return range;
    };

    // Function (ahem) Functions
    // ------------------

    // Determines whether to execute a function as a constructor
    // or a normal function with the provided arguments
    var executeBound = function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
        if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
        var self = baseCreate(sourceFunc.prototype);
        var result = sourceFunc.apply(self, args);
        if (_.isObject(result)) return result;
        return self;
    };

    // Create a function bound to a given object (assigning `this`, and arguments,
    // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
    // available.
    _.bind = function (func, context) {
        if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
        if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
        var args = slice.call(arguments, 2);
        var bound = function bound() {
            return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
        };
        return bound;
    };

    // Partially apply a function by creating a version that has had some of its
    // arguments pre-filled, without changing its dynamic `this` context. _ acts
    // as a placeholder, allowing any combination of arguments to be pre-filled.
    _.partial = function (func) {
        var boundArgs = slice.call(arguments, 1);
        var bound = function bound() {
            var position = 0,
                length = boundArgs.length;
            var args = Array(length);
            for (var i = 0; i < length; i++) {
                args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
            }
            while (position < arguments.length) {
                args.push(arguments[position++]);
            }return executeBound(func, bound, this, this, args);
        };
        return bound;
    };

    // Bind a number of an object's methods to that object. Remaining arguments
    // are the method names to be bound. Useful for ensuring that all callbacks
    // defined on an object belong to it.
    _.bindAll = function (obj) {
        var i,
            length = arguments.length,
            key;
        if (length <= 1) throw new Error('bindAll must be passed function names');
        for (i = 1; i < length; i++) {
            key = arguments[i];
            obj[key] = _.bind(obj[key], obj);
        }
        return obj;
    };

    // Memoize an expensive function by storing its results.
    _.memoize = function (func, hasher) {
        var memoize = function memoize(key) {
            var cache = memoize.cache;
            var address = '' + (hasher ? hasher.apply(this, arguments) : key);
            if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
            return cache[address];
        };
        memoize.cache = {};
        return memoize;
    };

    // Delays a function for the given number of milliseconds, and then calls
    // it with the arguments supplied.
    _.delay = function (func, wait) {
        var args = slice.call(arguments, 2);
        return setTimeout(function () {
            return func.apply(null, args);
        }, wait);
    };

    // Defers a function, scheduling it to run after the current call stack has
    // cleared.
    _.defer = _.partial(_.delay, _, 1);

    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run
    // as much as it can, without ever going more than once per `wait` duration;
    // but if you'd like to disable the execution on the leading edge, pass
    // `{leading: false}`. To disable execution on the trailing edge, ditto.
    _.throttle = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) options = {};
        var later = function later() {
            previous = options.leading === false ? 0 : _.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function () {
            var now = _.now();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    _.debounce = function (func, wait, immediate) {
        var timeout, args, context, timestamp, result;

        var later = function later() {
            var last = _.now() - timestamp;

            if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                }
            }
        };

        return function () {
            context = this;
            args = arguments;
            timestamp = _.now();
            var callNow = immediate && !timeout;
            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) {
                result = func.apply(context, args);
                context = args = null;
            }

            return result;
        };
    };

    // Returns the first function passed as an argument to the second,
    // allowing you to adjust arguments, run code before and after, and
    // conditionally execute the original function.
    _.wrap = function (func, wrapper) {
        return _.partial(wrapper, func);
    };

    // Returns a negated version of the passed-in predicate.
    _.negate = function (predicate) {
        return function () {
            return !predicate.apply(this, arguments);
        };
    };

    // Returns a function that is the composition of a list of functions, each
    // consuming the return value of the function that follows.
    _.compose = function () {
        var args = arguments;
        var start = args.length - 1;
        return function () {
            var i = start;
            var result = args[start].apply(this, arguments);
            while (i--) {
                result = args[i].call(this, result);
            }return result;
        };
    };

    // Returns a function that will only be executed on and after the Nth call.
    _.after = function (times, func) {
        return function () {
            if (--times < 1) {
                return func.apply(this, arguments);
            }
        };
    };

    // Returns a function that will only be executed up to (but not including) the Nth call.
    _.before = function (times, func) {
        var memo;
        return function () {
            if (--times > 0) {
                memo = func.apply(this, arguments);
            }
            if (times <= 1) func = null;
            return memo;
        };
    };

    // Returns a function that will be executed at most one time, no matter how
    // often you call it. Useful for lazy initialization.
    _.once = _.partial(_.before, 2);

    // Object Functions
    // ----------------

    // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
    var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
    var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

    function collectNonEnumProps(obj, keys) {
        var nonEnumIdx = nonEnumerableProps.length;
        var constructor = obj.constructor;
        var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

        // Constructor is a special case.
        var prop = 'constructor';
        if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

        while (nonEnumIdx--) {
            prop = nonEnumerableProps[nonEnumIdx];
            if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
                keys.push(prop);
            }
        }
    }

    // Retrieve the names of an object's own properties.
    // Delegates to **ECMAScript 5**'s native `Object.keys`
    _.keys = function (obj) {
        if (!_.isObject(obj)) return [];
        if (nativeKeys) return nativeKeys(obj);
        var keys = [];
        for (var key in obj) {
            if (_.has(obj, key)) keys.push(key);
        } // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
    };

    // Retrieve all the property names of an object.
    _.allKeys = function (obj) {
        if (!_.isObject(obj)) return [];
        var keys = [];
        for (var key in obj) {
            keys.push(key);
        } // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
    };

    // Retrieve the values of an object's properties.
    _.values = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var values = Array(length);
        for (var i = 0; i < length; i++) {
            values[i] = obj[keys[i]];
        }
        return values;
    };

    // Returns the results of applying the iteratee to each element of the object
    // In contrast to _.map it returns an object
    _.mapObject = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = _.keys(obj),
            length = keys.length,
            results = {},
            currentKey;
        for (var index = 0; index < length; index++) {
            currentKey = keys[index];
            results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
    };

    // Convert an object into a list of `[key, value]` pairs.
    _.pairs = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var pairs = Array(length);
        for (var i = 0; i < length; i++) {
            pairs[i] = [keys[i], obj[keys[i]]];
        }
        return pairs;
    };

    // Invert the keys and values of an object. The values must be serializable.
    _.invert = function (obj) {
        var result = {};
        var keys = _.keys(obj);
        for (var i = 0, length = keys.length; i < length; i++) {
            result[obj[keys[i]]] = keys[i];
        }
        return result;
    };

    // Return a sorted list of the function names available on the object.
    // Aliased as `methods`
    _.functions = _.methods = function (obj) {
        var names = [];
        for (var key in obj) {
            if (_.isFunction(obj[key])) names.push(key);
        }
        return names.sort();
    };

    // Extend a given object with all the properties in passed-in object(s).
    _.extend = createAssigner(_.allKeys);

    // Assigns a given object with all the own properties in the passed-in object(s)
    // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
    _.extendOwn = _.assign = createAssigner(_.keys);

    // Returns the first key on an object that passes a predicate test
    _.findKey = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = _.keys(obj),
            key;
        for (var i = 0, length = keys.length; i < length; i++) {
            key = keys[i];
            if (predicate(obj[key], key, obj)) return key;
        }
    };

    // Return a copy of the object only containing the whitelisted properties.
    _.pick = function (object, oiteratee, context) {
        var result = {},
            obj = object,
            iteratee,
            keys;
        if (obj == null) return result;
        if (_.isFunction(oiteratee)) {
            keys = _.allKeys(obj);
            iteratee = optimizeCb(oiteratee, context);
        } else {
            keys = flatten(arguments, false, false, 1);
            iteratee = function iteratee(value, key, obj) {
                return key in obj;
            };
            obj = Object(obj);
        }
        for (var i = 0, length = keys.length; i < length; i++) {
            var key = keys[i];
            var value = obj[key];
            if (iteratee(value, key, obj)) result[key] = value;
        }
        return result;
    };

    // Return a copy of the object without the blacklisted properties.
    _.omit = function (obj, iteratee, context) {
        if (_.isFunction(iteratee)) {
            iteratee = _.negate(iteratee);
        } else {
            var keys = _.map(flatten(arguments, false, false, 1), String);
            iteratee = function iteratee(value, key) {
                return !_.contains(keys, key);
            };
        }
        return _.pick(obj, iteratee, context);
    };

    // Fill in a given object with default properties.
    _.defaults = createAssigner(_.allKeys, true);

    // Creates an object that inherits from the given prototype object.
    // If additional properties are provided then they will be added to the
    // created object.
    _.create = function (prototype, props) {
        var result = baseCreate(prototype);
        if (props) _.extendOwn(result, props);
        return result;
    };

    // Create a (shallow-cloned) duplicate of an object.
    _.clone = function (obj) {
        if (!_.isObject(obj)) return obj;
        return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
    };

    // Invokes interceptor with the obj, and then returns obj.
    // The primary purpose of this method is to "tap into" a method chain, in
    // order to perform operations on intermediate results within the chain.
    _.tap = function (obj, interceptor) {
        interceptor(obj);
        return obj;
    };

    // Returns whether an object has a given set of `key:value` pairs.
    _.isMatch = function (object, attrs) {
        var keys = _.keys(attrs),
            length = keys.length;
        if (object == null) return !length;
        var obj = Object(object);
        for (var i = 0; i < length; i++) {
            var key = keys[i];
            if (attrs[key] !== obj[key] || !(key in obj)) return false;
        }
        return true;
    };

    // Internal recursive comparison function for `isEqual`.
    var eq = function eq(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // A strict comparison is necessary because `null == undefined`.
        if (a == null || b == null) return a === b;
        // Unwrap any wrapped objects.
        if (a instanceof _) a = a._wrapped;
        if (b instanceof _) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = toString.call(a);
        if (className !== toString.call(b)) return false;
        switch (className) {
            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
            case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
        }

        var areArrays = className === '[object Array]';
        if (!areArrays) {
            if ((typeof a === "undefined" ? "undefined" : _typeof(a)) != 'object' || (typeof b === "undefined" ? "undefined" : _typeof(b)) != 'object') return false;

            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor,
                bCtor = b.constructor;
            if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
            }
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while (length--) {
            // Linear search. Performance is inversely proportional to the number of
            // unique nested structures.
            if (aStack[length] === a) return bStack[length] === b;
        }

        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);

        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.
            while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
            }
        } else {
            // Deep compare objects.
            var keys = _.keys(a),
                key;
            length = keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if (_.keys(b).length !== length) return false;
            while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
            }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
    };

    // Perform a deep comparison to check if two objects are equal.
    _.isEqual = function (a, b) {
        return eq(a, b);
    };

    // Is a given array, string, or object empty?
    // An "empty" object has no enumerable own-properties.
    _.isEmpty = function (obj) {
        if (obj == null) return true;
        if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
        return _.keys(obj).length === 0;
    };

    // Is a given value a DOM element?
    _.isElement = function (obj) {
        return !!(obj && obj.nodeType === 1);
    };

    // Is a given value an array?
    // Delegates to ECMA5's native Array.isArray
    _.isArray = nativeIsArray || function (obj) {
        return toString.call(obj) === '[object Array]';
    };

    // Is a given variable an object?
    _.isObject = function (obj) {
        var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
        return type === 'function' || type === 'object' && !!obj;
    };

    // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
    _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
        _['is' + name] = function (obj) {
            return toString.call(obj) === '[object ' + name + ']';
        };
    });

    // Define a fallback version of the method in browsers (ahem, IE < 9), where
    // there isn't any inspectable "Arguments" type.
    if (!_.isArguments(arguments)) {
        _.isArguments = function (obj) {
            return _.has(obj, 'callee');
        };
    }

    // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
    // IE 11 (#1621), and in Safari 8 (#1929).
    if (typeof /./ != 'function' && (typeof Int8Array === "undefined" ? "undefined" : _typeof(Int8Array)) != 'object') {
        _.isFunction = function (obj) {
            return typeof obj == 'function' || false;
        };
    }

    // Is a given object a finite number?
    _.isFinite = function (obj) {
        return isFinite(obj) && !isNaN(parseFloat(obj));
    };

    // Is the given value `NaN`? (NaN is the only number which does not equal itself).
    _.isNaN = function (obj) {
        return _.isNumber(obj) && obj !== +obj;
    };

    // Is a given value a boolean?
    _.isBoolean = function (obj) {
        return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
    };

    // Is a given value equal to null?
    _.isNull = function (obj) {
        return obj === null;
    };

    // Is a given variable undefined?
    _.isUndefined = function (obj) {
        return obj === void 0;
    };

    // Shortcut function for checking if an object has a given property directly
    // on itself (in other words, not on a prototype).
    _.has = function (obj, key) {
        return obj != null && hasOwnProperty.call(obj, key);
    };

    // Utility Functions
    // -----------------

    // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
    // previous owner. Returns a reference to the Underscore object.
    _.noConflict = function () {
        root._ = previousUnderscore;
        return this;
    };

    // Keep the identity function around for default iteratees.
    _.identity = function (value) {
        return value;
    };

    // Predicate-generating functions. Often useful outside of Underscore.
    _.constant = function (value) {
        return function () {
            return value;
        };
    };

    _.noop = function () {};

    _.property = property;

    // Generates a function for a given object that returns a given property.
    _.propertyOf = function (obj) {
        return obj == null ? function () {} : function (key) {
            return obj[key];
        };
    };

    // Returns a predicate for checking whether an object has a given set of
    // `key:value` pairs.
    _.matcher = _.matches = function (attrs) {
        attrs = _.extendOwn({}, attrs);
        return function (obj) {
            return _.isMatch(obj, attrs);
        };
    };

    // Run a function **n** times.
    _.times = function (n, iteratee, context) {
        var accum = Array(Math.max(0, n));
        iteratee = optimizeCb(iteratee, context, 1);
        for (var i = 0; i < n; i++) {
            accum[i] = iteratee(i);
        }return accum;
    };

    // Return a random integer between min and max (inclusive).
    _.random = function (min, max) {
        if (max == null) {
            max = min;
            min = 0;
        }
        return min + Math.floor(Math.random() * (max - min + 1));
    };

    // A (possibly faster) way to get the current timestamp as an integer.
    _.now = Date.now || function () {
        return new Date().getTime();
    };

    // List of HTML entities for escaping.
    var escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;'
    };
    var unescapeMap = _.invert(escapeMap);

    // Functions for escaping and unescaping strings to/from HTML interpolation.
    var createEscaper = function createEscaper(map) {
        var escaper = function escaper(match) {
            return map[match];
        };
        // Regexes for identifying a key that needs to be escaped
        var source = '(?:' + _.keys(map).join('|') + ')';
        var testRegexp = RegExp(source);
        var replaceRegexp = RegExp(source, 'g');
        return function (string) {
            string = string == null ? '' : '' + string;
            return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
        };
    };
    _.escape = createEscaper(escapeMap);
    _.unescape = createEscaper(unescapeMap);

    // If the value of the named `property` is a function then invoke it with the
    // `object` as context; otherwise, return it.
    _.result = function (object, property, fallback) {
        var value = object == null ? void 0 : object[property];
        if (value === void 0) {
            value = fallback;
        }
        return _.isFunction(value) ? value.call(object) : value;
    };

    // Generate a unique integer id (unique within the entire client session).
    // Useful for temporary DOM ids.
    var idCounter = 0;
    _.uniqueId = function (prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
    };

    // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.
    _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
    };

    // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.
    var noMatch = /(.)^/;

    // Certain characters need to be escaped so that they can be put into a
    // string literal.
    var escapes = {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        "\u2028": 'u2028',
        "\u2029": 'u2029'
    };

    var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

    var escapeChar = function escapeChar(match) {
        return '\\' + escapes[match];
    };

    // JavaScript micro-templating, similar to John Resig's implementation.
    // Underscore templating handles arbitrary delimiters, preserves whitespace,
    // and correctly escapes quotes within interpolated code.
    // NB: `oldSettings` only exists for backwards compatibility.
    _.template = function (text, settings, oldSettings) {
        if (!settings && oldSettings) settings = oldSettings;
        settings = _.defaults({}, settings, _.templateSettings);

        // Combine delimiters into one regular expression via alternation.
        var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');

        // Compile the template source, escaping string literals appropriately.
        var index = 0;
        var source = "__p+='";
        text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
            source += text.slice(index, offset).replace(escaper, escapeChar);
            index = offset + match.length;

            if (escape) {
                source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
            } else if (interpolate) {
                source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
            } else if (evaluate) {
                source += "';\n" + evaluate + "\n__p+='";
            }

            // Adobe VMs need the match returned to produce the correct offest.
            return match;
        });
        source += "';\n";

        // If a variable is not specified, place data values in local scope.
        if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

        source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';

        try {
            var render = new Function(settings.variable || 'obj', '_', source);
        } catch (e) {
            e.source = source;
            throw e;
        }

        var template = function template(data) {
            return render.call(this, data, _);
        };

        // Provide the compiled source as a convenience for precompilation.
        var argument = settings.variable || 'obj';
        template.source = 'function(' + argument + '){\n' + source + '}';

        return template;
    };

    // Add a "chain" function. Start chaining a wrapped Underscore object.
    _.chain = function (obj) {
        var instance = _(obj);
        instance._chain = true;
        return instance;
    };

    // OOP
    // ---------------
    // If Underscore is called as a function, it returns a wrapped object that
    // can be used OO-style. This wrapper holds altered versions of all the
    // underscore functions. Wrapped objects may be chained.

    // Helper function to continue chaining intermediate results.
    var result = function result(instance, obj) {
        return instance._chain ? _(obj).chain() : obj;
    };

    // Add your own custom functions to the Underscore object.
    _.mixin = function (obj) {
        _.each(_.functions(obj), function (name) {
            var func = _[name] = obj[name];
            _.prototype[name] = function () {
                var args = [this._wrapped];
                push.apply(args, arguments);
                return result(this, func.apply(_, args));
            };
        });
    };

    // Add all of the Underscore functions to the wrapper object.
    _.mixin(_);

    // Add all mutator Array functions to the wrapper.
    _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
            var obj = this._wrapped;
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
            return result(this, obj);
        };
    });

    // Add all accessor Array functions to the wrapper.
    _.each(['concat', 'join', 'slice'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
            return result(this, method.apply(this._wrapped, arguments));
        };
    });

    // Extracts the result from a wrapped and chained object.
    _.prototype.value = function () {
        return this._wrapped;
    };

    // Provide unwrapping proxy for some methods used in engine operations
    // such as arithmetic and JSON stringification.
    _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

    _.prototype.toString = function () {
        return '' + this._wrapped;
    };

    // AMD registration happens at the end for compatibility with AMD loaders
    // that may not enforce next-turn semantics on modules. Even though general
    // practice for AMD registration is to be anonymous, underscore registers
    // as a named module because, like jQuery, it is a base library that is
    // popular enough to be bundled in a third party lib, but not be part of
    // an AMD load request. Those cases could generate an error when an
    // anonymous define() is called outside of a loader request.
    if (typeof define === 'function' && define.amd) {
        define('underscore', [], function () {
            return _;
        });
    }
}).call(undefined);
if (!window['HRX']) HRX = {};

if (!HRX['NAV']) HRX.NAV = {};

/*focus selector*/
jQuery.expr[':'].focus = function (elem) {
    return elem === document.activeElement && (elem.type || elem.href);
};

;(function ($, len, createRange, duplicate) {
    $.fn.caret = function (options, opt2) {
        var start,
            end,
            t = this[0],
            browser = $.browser.msie;
        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object" && typeof options.start === "number" && typeof options.end === "number") {
            start = options.start;
            end = options.end;
        } else if (typeof options === "number" && typeof opt2 === "number") {
            start = options;
            end = opt2;
        } else if (typeof options === "string") {
            if ((start = t.value.indexOf(options)) > -1) end = start + options[len];else start = null;
        } else if (Object.prototype.toString.call(options) === "[object RegExp]") {
            var re = options.exec(t.value);
            if (re !== null) {
                start = re.index;
                end = start + re[0][len];
            }
        }
        if (typeof start != "undefined") {
            if (browser) {
                var selRange = this[0].createTextRange();
                selRange.collapse(true);
                selRange.moveStart('character', start);
                selRange.moveEnd('character', end - start);
                selRange.select();
            } else {
                this[0].selectionStart = start;
                this[0].selectionEnd = end;
            }
            this[0].focus();
            return this;
        } else {
            var range = void 0,
                s = void 0,
                e = void 0;
            if (browser) {
                var selection = document.selection;
                if (this[0].tagName.toLowerCase() != "textarea") {
                    var val = this.val();
                    range = selection[createRange]()[duplicate]();
                    range.moveEnd("character", val[len]);
                    s = range.text === "" ? val[len] : val.lastIndexOf(range.text);
                    range = selection[createRange]()[duplicate]();
                    range.moveStart("character", -val[len]);
                    e = range.text[len];
                } else {
                    range = selection[createRange]();
                    var stored_range = range[duplicate]();
                    stored_range.moveToElementText(this[0]);
                    stored_range.setEndPoint('EndToEnd', range);
                    s = stored_range.text[len] - range.text[len];
                    e = s + range.text[len];
                }
            } else {
                s = t.selectionStart;
                e = t.selectionEnd;
            }
            var te = t.value.substring(s, e);
            return {
                start: s,
                end: e,
                text: te,
                replace: function replace(st) {
                    return t.value.substring(0, s) + st + t.value.substring(e, t.value[len]);
                }
            };
        }
    };
})(jQuery, "length", "createRange", "duplicate")

/* component plugins*/
;(function ($) {
    /* Expendable Textfield */
    $.fn.expandableTextfield = function (options) {
        var opts = $.extend({}, $.fn.expandableTextfield.defaults, options);
        return this.each(function (i) {
            var field = $(this);
            var popupField = null;
            var onfocus = function onfocus(e) {
                var offset = field.offset();
                var height = field.height();
                var width = opts.width || field.outerWidth();
                if (opts.widthAnchor) {
                    if ($(opts.widthAnchor).length > 0) {
                        width = $(opts.widthAnchor).outerWidth() - (offset.left - $(opts.widthAnchor).offset().left) - opts.rightMargin;
                    }
                }
                var wrapper = $('<div class="' + opts.wrapperClass + '" style="position:absolute; z-index:100; border:2px solid #afc6e9; background:#f4f7fb;"><h1 style="font-family: Arial,Verdana,Tahoma; font-size: 12px; padding-bottom:7px; color:#214478;">' + opts.header + '</h1><input class="' + opts.popupClass + '"/></div>').css({
                    width: width + opts.wrapperPadding * 2 - 20,
                    padding: opts.wrapperPadding
                }).appendTo('body');
                wrapper.attr('id', field.attr('id') + 'PopupWrapper');
                if (!opts.freePosition) wrapper.css({
                    top: offset.top - opts.wrapperPadding + opts.offsetTop,
                    left: offset.left - opts.wrapperPadding + opts.offsetLeft
                });
                popupField = wrapper.children('input').eq(0).val(field.val()).css({
                    width: width,
                    height: height
                }).keyup(function () {
                    field.val($(this).val());
                }).blur(function () {
                    field.val($(this).val());
                    setTimeout(function () {
                        if (!field.is(':focus')) wrapper.remove();
                    }, 50);
                });
                popupField.attr('id', field.attr('id') + 'PopupField');
                if (opts.autoFocus) {
                    HRX.setSelection(popupField, field.caret().start, field.caret().end);
                    popupField.focus();
                }
            };
            $(field).focus(onfocus).keyup(function () {
                if (popupField) popupField.val($(this).val());
            }).blur(function () {
                setTimeout(function () {
                    if (!popupField.is(':focus')) popupField.parent().remove();
                }, 50);
            });
        });
    };

    $.fn.expandableTextfield.defaults = {
        offsetTop: 0,
        offsetLeft: 0,
        freePosition: false,
        width: null,
        popupClass: 'popupTextfield',
        wrapperClass: 'popupTextfieldWrapper',
        wrapperPadding: 10,
        widthAnchor: "document",
        rightMargin: 10,
        autoFocus: false,
        header: ''
    }; /* End of expandable textfield */
})(jQuery)

/*
 * Auto-growing textareas
 */
;(function ($) {
    $.fn.autoGrowTextArea = function (options) {
        var opts = $.extend({}, $.fn.autoGrowTextArea.defaults, options);
        this.filter('textarea').each(function () {
            var $this = $(this),
                minHeight = $this.height(),
                lineHeight = $this.css('lineHeight'),
                shadow = $('<div></div>').css({
                position: 'absolute',
                top: -10000,
                left: -10000,
                width: $(this).width() - parseInt($this.css('paddingLeft')) - parseInt($this.css('paddingRight')),
                fontSize: $this.css('fontSize'),
                fontFamily: $this.css('fontFamily'),
                lineHeight: $this.css('lineHeight'),
                resize: 'none'
            }).after($this);

            var update = function update() {
                var times = function times(string, number) {
                    for (var i = 0, r = ''; i < number; i++) {
                        r += string;
                    }return r;
                };

                var val = this.value.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/\n$/, '<br/>&nbsp;').replace(/\n/g, '<br/>').replace(/ {2,}/g, function (space) {
                    return times('&nbsp;', space.length - 1) + ' ';
                });
                shadow.html(val);
                $this.css('height', Math.min(opts.maxHeight, Math.max(shadow.height() + 20, minHeight)));
            };
            $this.change(update).keyup(update).keydown(update);
            update.apply(this);
        });
        return this;
    };

    $.fn.autoGrowTextArea.defaults = {
        maxHeight: 600
    };
})(jQuery);

/**
 * IFrame enhancement
 */

HRX.iframeRedirect = function (selector, url, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    HRX.iframeSquirt(ifm, squirt);
    ifm.attr('src', url);
};

HRX.iframeSquirt = function (selector, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    if (typeof squirt !== 'undefined') {
        var el = ifm.get(0);
        var doc = el.contentDocument || el.contentWindow.document;
        doc.open();
        doc.writeln(squirt);
        doc.close();
    }
};(function ($) {

    var timer;

    $.fn.src = function (url, onLoad, options) {
        setIFrames($(this), onLoad, options, function () {
            this.src = url;
        });
        return $(this);
    };

    $.fn.squirt = function (content, onLoad, options) {

        setIFrames($(this), onLoad, options, function () {
            var doc = null;
            if (typeof this.contentDocument != 'unknown') {
                doc = this.contentDocument;
            } else if (typeof this.contentWindow != "unknown" && typeof this.contentWindow.document != "unknown") {
                doc = this.contentWindow.document;
            }
            if (doc) {
                doc.open();
                doc.writeln(content);
                doc.close();
            }
        });
        return this;
    };

    function setIFrames(iframes, onLoad, options, iFrameSetter) {
        iframes.each(function () {
            if (this.tagName == "IFRAME") setIFrame(this, onLoad, options, iFrameSetter);
        });
    }

    function setIFrame(iframe, onLoad, options, iFrameSetter) {
        var timer;
        iframe.onload = null;
        if (timer) clearTimeout(timer);

        var defaults = {
            timeoutDuration: 0,
            timeout: null
        };
        var opts = $.extend(defaults, options);
        if (opts.timeout && !opts.timeoutDuration) opts.timeoutDuration = 60000;

        opts.frameactive = true;
        var startTime = new Date().getTime();
        if (opts.timeout) {
            timer = setTimeout(function () {
                opts.frameactive = false;
                iframe.onload = null;
                if (opts.timeout) opts.timeout(iframe, opts.timeout);
            }, opts.timeoutDuration);
        }

        var onloadHandler = function onloadHandler() {
            var duration = new Date().getTime() - startTime;
            if (timer) clearTimeout(timer);
            if (onLoad && opts.frameactive) onLoad.apply(iframe, [duration]);
            opts.frameactive = false;
        };
        iFrameSetter.apply(iframe);
        iframe.onload = onloadHandler;
        opts.completeReadyStateChanges = 0;
        iframe.onreadystatechange = function () {
            // IE ftw
            if (++opts.completeReadyStateChanges == 3) onloadHandler();
        };
        return iframe;
    }
})(jQuery);

/**
 * Navigation
 */
;(function () {
    if (!window['History'] || !History.pushState) return;
    if (!HRX.NAV) HRX.NAV = {};
    var oldIE;
    if (window['Prototype']) {
        oldIE = Prototype.Browser.IE && Prototype.Browser.version < 9;
    } else if (jQuery && jQuery.browser) {
        oldIE = jQuery.browser.ie && jQuery.browser.version < 9;
    }
    if (!oldIE) {
        (function () {
            var href = window.location.href;
            var navPos = href.indexOf("&_nav=");
            navPos = navPos >= 0 ? navPos : href.length;
            var startPos = href.indexOf("?");
            HRX.NAV.baseQueryString = href.substr(startPos, navPos - startPos);
        })();
    }
    HRX.NAV.writingBackUrl = false;
    HRX.NAV.pushStateNoOp = function (stateHash) {
        HRX.NAV.writingBackUrl = true;
        if (oldIE) {
            History.pushState(null, "Springboard", '_nav=' + stateHash);
        } else {
            History.pushState(null, "Springboard", HRX.NAV.baseQueryString + '&_nav=' + stateHash);
        }
        HRX.NAV.writingBackUrl = false;
    };
})();(function ($) {
    if (!window['History'] || !History.options) return;
    $(function () {
        History.options.html4Mode = true;
        History.Adapter.bind(window, 'statechange', function () {
            if (!HRX.NAV.writingBackUrl) {
                var state = History.getState().url;
                var navPosition = state.indexOf("_nav=");
                if (navPosition > 0) {
                    state = state.substr(navPosition + 5);
                    a4jNavigateToStateHash(state);
                }
            }
        });
    });
})(jQuery)

//TinyMCE
;(function () {
    if (typeof tinymce === 'undefined') return;
    var defaultOptions = {
        mode: "specific_textareas",
        theme: "advanced",
        plugins: "pagebreak,style,table,save,advhr,advimage,advlink,iespell,insertdatetime,inlinepopups,preview,media,searchreplace,contextmenu,paste,directionality,fullscreen,noneditable,visualchars,nonbreaking,xhtmlxtras,template,advlist,spellchecker,fullpage",
        pagebreak_separator: "<div style=\"page-break-after: always;\"><span style=\"display: none;\"></span></div>",
        theme_advanced_buttons1: "bold,italic,underline,|,justifyleft,justifycenter,justifyright,justifyfull,fontselect,fontsizeselect,forecolor,charmap",
        theme_advanced_buttons2: "cut,copy,paste,pastetext,pasteword,|,search,replace,|,bullist,numlist,|,outdent,indent,|,undo,redo,|,link,unlink,anchor,image,help,code, spellchecker",
        theme_advanced_buttons3_add: "fullpage",
        theme_advanced_buttons4: "",
        theme_advanced_toolbar_location: "top",
        theme_advanced_toolbar_align: "left",
        theme_advanced_statusbar_location: "bottom",
        theme_advanced_resizing: true,
        add_form_submit_trigger: false,
        theme_advanced_path: false,
        spellchecker_languages: "+English=en-AU",
        spellchecker_rpc_url: "/rasp6/jazzy-spellchecker",
        content_css: "css/content.css",
        template_external_list_url: "lists/template_list.js",
        external_link_list_url: "lists/link_list.js",
        external_image_list_url: "lists/image_list.js",
        media_external_list_url: "lists/media_list.js",
        fullpage_default_title: "Springboard Announcement",
        relative_urls: false,
        remove_script_host: false,
        convert_urls: false,
        invalid_elements: "script,javascript,expression,embed,object",
        style_formats: [{ title: 'Bold text', inline: 'b' }, { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } }, { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } }, { title: 'Example 1', inline: 'span', classes: 'example1' }, { title: 'Example 2', inline: 'span', classes: 'example2' }, { title: 'Table styles' }, { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' }]
    };
    var defaultFinder = function defaultFinder() {
        return true;
    };

    /**
     * Remove a tinymce editor from the page environment.
     * tinymce.remove (at least up to 3.5.11) does not remove the editor from editors array.
     * We need to do it manually. -- DD 31/03/2016 11:20:04 am
     */
    function removeTinyMCEInstance(editor) {
        var oldLength = tinymce.editors.length;
        tinymce.remove(editor);
        if (oldLength == tinymce.editors.length) {
            tinymce.editors.remove(editor);
        }
    }

    HRX.initTinyMCE = function (selector, options, finder) {
        if (!finder) finder = defaultFinder;
        _.chain(tinymce.editors).filter(finder).each(function (e) {
            try {
                removeTinyMCEInstance(e);
            } catch (err) {
                app.console.error(err);
            }
        });
        var opt = jQuery.extend(true, {}, defaultOptions, options, { editor_selector: selector });
        tinymce.init(opt);
    };

    /**
     * Remove tinymce editors for each id group except the last one.
     */
    HRX.cleanUpTinyMCE = function () {
        _.chain(tinymce.editors).groupBy(function (editor) {
            return editor.id;
        }).values().each(function (editors) {
            _.chain(editors).initial().each(function (leakedEditor) {
                try {
                    removeTinyMCEInstance(leakedEditor);
                } catch (err) {
                    app.console.error(err);
                }
            });
        });
    };
})();

;(function (win, ko, $, undefined) {

    if (parseFloat($.fn.jquery) >= 3) {
        $.fn.size = function () {
            return this && this.length || 0;
        };
    }

    if (!win.app) win.app = {};(function () {
        var unified = win.console || {};
        var dummy = {};
        _.each(["assert", "clear", "count", "debug", "dir", "dirxml", "error", "group", "groupCollapsed", "groupEnd", "info", "log", "time", "timeEnd", "trace", "warn", "table"], function (m) {
            if (!unified[m]) unified[m] = _.noop;
            dummy[m] = _.noop;
        });

        win.app.enableConsole = function () {
            win.app.consoleEnabled = true;
            win.app.console = unified;
        };
        win.app.disableConsole = function () {
            win.app.consoleEnabled = false;
            win.app.console = dummy;
        };
        win.app.enableConsole();
    })();

    /**
     * Define win app.utils functions
     */
    win.app.utils = {
        ajaxResult: function ajaxResult() {
            if (!window['OmniFaces'] || !OmniFaces.Ajax) return undefined;
            return OmniFaces.Ajax.data;
        },

        stringEndsWith: function stringEndsWith(s, suffix) {
            s = s + "";
            return s.indexOf(suffix, s.length - suffix.length) !== -1;
        },

        trimString: function trimString(s) {
            s = s.replace(/^\s+/, "");
            for (var i = s.length - 1; i >= 0; i--) {
                if (/\S/.test(s.charAt(i))) {
                    s = s.substring(0, i + 1);
                    break;
                }
            }
            return s;
        },

        isFutureDate: function isFutureDate(day) {
            var date = new Date();
            date.setDate(date.getDate() - 1);
            return day.date.getTime() - date.getTime() >= 0;
        },

        idToSelector: function idToSelector(id) {
            return id.replace(/:/g, "\\:");
        },

        setSelection: function setSelection(field, start, end) {
            var el = $(field).get(0);
            el.focus();
            if (el.setSelectionRange) {
                el.setSelectionRange(start, end);
            } else if (el.createTextRange) {
                var range = el.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', start);
                range.select();
            }
        },

        sequence: function () {
            var _id = 0;
            return {
                next: function next() {
                    _id = _id + 1;
                    return _id;
                },
                peek: function peek() {
                    return _id;
                }
            };
        }(),

        getIfromeWindow: function getIfromeWindow(iframe) {
            var $frame = $(iframe);
            if ($frame.length === 0) return undefined;
            var el = $frame[0];
            return el.contentWindow ? el.contentWindow : el.contentDocument.defaultView;
        },

        pluralize: function () {
            // Rule storage - pluralize and singularize need to be run sequentially,
            // while other rules can be optimized using an object for instant lookups.
            var pluralRules = [];
            var singularRules = [];
            var uncountables = {};
            var irregularPlurals = {};
            var irregularSingles = {};

            /**
             * Title case a string.
             *
             * @param  {string} str
             * @return {string}
             */
            function toTitleCase(str) {
                return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
            }

            /**
             * Sanitize a pluralization rule to a usable regular expression.
             *
             * @param  {(RegExp|string)} rule
             * @return {RegExp}
             */
            function sanitizeRule(rule) {
                if (typeof rule === 'string') {
                    return new RegExp('^' + rule + '$', 'i');
                }

                return rule;
            }

            /**
             * Pass in a word token to produce a function that can replicate the case on
             * another word.
             *
             * @param  {string}   word
             * @param  {string}   token
             * @return {Function}
             */
            function restoreCase(word, token) {
                // Tokens are an exact match.
                if (word === token) {
                    return token;
                }

                // Upper cased words. E.g. "HELLO".
                if (word === word.toUpperCase()) {
                    return token.toUpperCase();
                }

                // Title cased words. E.g. "Title".
                if (word[0] === word[0].toUpperCase()) {
                    return toTitleCase(token);
                }

                // Lower cased words. E.g. "test".
                return token.toLowerCase();
            }

            /**
             * Interpolate a regexp string.
             *
             * @param  {string} str
             * @param  {Array}  args
             * @return {string}
             */
            function interpolate(str, args) {
                return str.replace(/\$(\d{1,2})/g, function (match, index) {
                    return args[index] || '';
                });
            }

            /**
             * Sanitize a word by passing in the word and sanitization rules.
             *
             * @param  {string}   token
             * @param  {string}   word
             * @param  {Array}    collection
             * @return {string}
             */
            function sanitizeWord(token, word, collection) {
                // Empty string or doesn't need fixing.
                if (!token.length || uncountables.hasOwnProperty(token)) {
                    return word;
                }

                var len = collection.length;

                // Iterate over the sanitization rules and use the first one to match.

                var _loop = function _loop() {
                    var rule = collection[len];

                    // If the rule passes, return the replacement.
                    if (rule[0].test(word)) {
                        return {
                            v: word.replace(rule[0], function (match, index, word) {
                                var result = interpolate(rule[1], arguments);

                                if (match === '') {
                                    return restoreCase(word[index - 1], result);
                                }

                                return restoreCase(match, result);
                            })
                        };
                    }
                };

                while (len--) {
                    var _ret = _loop();

                    if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
                }

                return word;
            }

            /**
             * Replace a word with the updated word.
             *
             * @param  {Object}   replaceMap
             * @param  {Object}   keepMap
             * @param  {Array}    rules
             * @return {Function}
             */
            function replaceWord(replaceMap, keepMap, rules) {
                return function (word) {
                    // Get the correct token and case restoration functions.
                    var token = word.toLowerCase();

                    // Check against the keep object map.
                    if (keepMap.hasOwnProperty(token)) {
                        return restoreCase(word, token);
                    }

                    // Check against the replacement map for a direct word replacement.
                    if (replaceMap.hasOwnProperty(token)) {
                        return restoreCase(word, replaceMap[token]);
                    }

                    // Run all the rules against the word.
                    return sanitizeWord(token, word, rules);
                };
            }

            /**
             * Pluralize or singularize a word based on the passed in count.
             *
             * @param  {string}  word
             * @param  {number}  count
             * @param  {boolean} inclusive
             * @return {string}
             */
            function pluralize(word, count, inclusive) {
                var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);

                return (inclusive ? count + ' ' : '') + pluralized;
            }

            /**
             * Pluralize a word.
             *
             * @type {Function}
             */
            pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);

            /**
             * Singularize a word.
             *
             * @type {Function}
             */
            pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);

            /**
             * Add a pluralization rule to the collection.
             *
             * @param {(string|RegExp)} rule
             * @param {string}          replacement
             */
            pluralize.addPluralRule = function (rule, replacement) {
                pluralRules.push([sanitizeRule(rule), replacement]);
            };

            /**
             * Add a singularization rule to the collection.
             *
             * @param {(string|RegExp)} rule
             * @param {string}          replacement
             */
            pluralize.addSingularRule = function (rule, replacement) {
                singularRules.push([sanitizeRule(rule), replacement]);
            };

            /**
             * Add an uncountable word rule.
             *
             * @param {(string|RegExp)} word
             */
            pluralize.addUncountableRule = function (word) {
                if (typeof word === 'string') {
                    uncountables[word.toLowerCase()] = true;
                    return;
                }

                // Set singular and plural references for the word.
                pluralize.addPluralRule(word, '$0');
                pluralize.addSingularRule(word, '$0');
            };

            /**
             * Add an irregular word definition.
             *
             * @param {string} single
             * @param {string} plural
             */
            pluralize.addIrregularRule = function (single, plural) {
                plural = plural.toLowerCase();
                single = single.toLowerCase();

                irregularSingles[single] = plural;
                irregularPlurals[plural] = single;
            };

            /**
             * Irregular rules.
             */
            [
            // Pronouns.
            ['I', 'we'], ['me', 'us'], ['he', 'they'], ['she', 'they'], ['them', 'them'], ['myself', 'ourselves'], ['yourself', 'yourselves'], ['itself', 'themselves'], ['herself', 'themselves'], ['himself', 'themselves'], ['themself', 'themselves'], ['is', 'are'], ['was', 'were'], ['has', 'have'], ['this', 'these'], ['that', 'those'],
            // Words ending in with a consonant and `o`.
            ['echo', 'echoes'], ['dingo', 'dingoes'], ['volcano', 'volcanoes'], ['tornado', 'tornadoes'], ['torpedo', 'torpedoes'],
            // Ends with `us`.
            ['genus', 'genera'], ['viscus', 'viscera'],
            // Ends with `ma`.
            ['stigma', 'stigmata'], ['stoma', 'stomata'], ['dogma', 'dogmata'], ['lemma', 'lemmata'], ['schema', 'schemata'], ['anathema', 'anathemata'],
            // Other irregular rules.
            ['ox', 'oxen'], ['axe', 'axes'], ['die', 'dice'], ['yes', 'yeses'], ['foot', 'feet'], ['eave', 'eaves'], ['goose', 'geese'], ['tooth', 'teeth'], ['quiz', 'quizzes'], ['human', 'humans'], ['proof', 'proofs'], ['carve', 'carves'], ['valve', 'valves'], ['looey', 'looies'], ['thief', 'thieves'], ['groove', 'grooves'], ['pickaxe', 'pickaxes'], ['whiskey', 'whiskies']].forEach(function (rule) {
                return pluralize.addIrregularRule(rule[0], rule[1]);
            });

            /**
             * Pluralization rules.
             */
            [[/s?$/i, 's'], [/[^\u0000-\u007F]$/i, '$0'], [/([^aeiou]ese)$/i, '$1'], [/(ax|test)is$/i, '$1es'], [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'], [/(e[mn]u)s?$/i, '$1s'], [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'], [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'], [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'], [/(seraph|cherub)(?:im)?$/i, '$1im'], [/(her|at|gr)o$/i, '$1oes'], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'], [/sis$/i, 'ses'], [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'], [/([^aeiouy]|qu)y$/i, '$1ies'], [/([^ch][ieo][ln])ey$/i, '$1ies'], [/(x|ch|ss|sh|zz)$/i, '$1es'], [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'], [/([ml])(?:ice|ouse)$/i, '$1ice'], [/(pe)(?:rson|ople)$/i, '$1ople'], [/(child)(?:ren)?$/i, '$1ren'], [/eaux$/i, '$0'], [/m[ae]n$/i, 'men'], ['thou', 'you']].forEach(function (rule) {
                return pluralize.addPluralRule(rule[0], rule[1]);
            });

            /**
             * Singularization rules.
             */
            [[/s$/i, ''], [/(ss)$/i, '$1'], [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'], [/(^analy)(?:sis|ses)$/i, '$1sis'], [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'], [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'], [/ies$/i, 'y'], [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'], [/\b(mon|smil)ies$/i, '$1ey'], [/([ml])ice$/i, '$1ouse'], [/(seraph|cherub)im$/i, '$1'], [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'], [/(e[mn]u)s?$/i, '$1'], [/(movie|twelve)s$/i, '$1'], [/(cris|test|diagnos)(?:is|es)$/i, '$1is'], [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'], [/(alumn|alg|vertebr)ae$/i, '$1a'], [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'], [/(matr|append)ices$/i, '$1ix'], [/(pe)(rson|ople)$/i, '$1rson'], [/(child)ren$/i, '$1'], [/(eau)x?$/i, '$1'], [/men$/i, 'man']].forEach(function (rule) {
                return pluralize.addSingularRule(rule[0], rule[1]);
            });

            /**
             * Uncountable rules.
             */
            [
            // Singular words with no plurals.
            'advice', 'adulthood', 'agenda', 'aid', 'alcohol', 'ammo', 'athletics', 'bison', 'blood', 'bream', 'buffalo', 'butter', 'carp', 'cash', 'chassis', 'chess', 'clothing', 'commerce', 'cod', 'cooperation', 'corps', 'digestion', 'debris', 'diabetes', 'energy', 'equipment', 'elk', 'excretion', 'expertise', 'flounder', 'fun', 'gallows', 'garbage', 'graffiti', 'headquarters', 'health', 'herpes', 'highjinks', 'homework', 'housework', 'information', 'jeans', 'justice', 'kudos', 'labour', 'literature', 'machinery', 'mackerel', 'mail', 'media', 'mews', 'moose', 'music', 'news', 'pike', 'plankton', 'pliers', 'pollution', 'premises', 'rain', 'research', 'rice', 'salmon', 'scissors', 'series', 'sewage', 'shambles', 'shrimp', 'species', 'staff', 'swine', 'trout', 'traffic', 'transporation', 'tuna', 'wealth', 'welfare', 'whiting', 'wildebeest', 'wildlife', 'you',
            // Regexes.
            /pox$/i, // "chickpox", "smallpox"
            /ois$/i, /deer$/i, // "deer", "reindeer"
            /fish$/i, // "fish", "blowfish", "angelfish"
            /sheep$/i, /measles$/i, /[^aeiou]ese$/i // "chinese", "japanese"
            ].forEach(pluralize.addUncountableRule);

            return pluralize;
        }(),

        preprocessVue: function preprocessVue(rootElement) {
            function bindExpression(el, expression) {
                var firstEqualPos = expression.indexOf("=");
                if (firstEqualPos === -1) {
                    $(el).attr(expression, '');
                } else {
                    $(el).attr(expression.substring(0, firstEqualPos), expression.substring(firstEqualPos + 1));
                }
            }
            function attachBulkBinding(el, expression) {
                var regex = new RegExp(/\(\((.*?)\)\)/g);
                var match = void 0;
                while ((match = regex.exec(expression)) !== null) {
                    bindExpression(this, match[1]);
                }
            }
            $.each($(rootElement).find("[vue-bulkbind]"), function () {
                attachBulkBinding(this, $(this).attr('vue-bulkbind'));
            });
            $.each($(rootElement).find("[vue-bind-children]"), function () {
                var element = this;
                $.each(element.attributes, function () {
                    try {
                        var attr = this,
                            name = void 0,
                            value = void 0,
                            parts = void 0;
                        if (attr.specified) {
                            name = attr.name;
                            if (name.match(/^data-bind-child(?:-\d+)?$/i)) {
                                value = attr.value;
                                parts = value.split(/\s*@\s*/);
                                if (parts.length === 2) {
                                    $(element).find(parts[1]).each(function () {
                                        var expression = parts[0];
                                        if (expression[0] === '(' && expression[1] === '(') {
                                            attachBulkBinding(this, expression);
                                        } else {
                                            bindExpression(this, expression);
                                        }
                                    });
                                } else {
                                    app.console.error("Invalid v-bind-child content: " + value);
                                }
                            }
                        }
                    } catch (err) {
                        app.console.error(err);
                    }
                });
            });
        }
    };(function () {
        function intervalBind(vm, elem) {
            if (vm.__type__ === 'vue') {
                app.utils.preprocessVue(elem);
                if (!vm.__vue__) vm.__vue__ = [];
                var opts = $.extend({}, vm.vueOptions || {}, {
                    el: elem,
                    data: vm.data,
                    computed: vm.computed,
                    watch: vm.watch,
                    methods: vm.methods
                });
                vm.__vue__.push(new Vue(opts));
            } else {
                ko.applyBindings(vm, elem);
            }

            function isElementInDom(e) {
                if (document.contains) return document.contains(e);
                if (document.body.contains) return document.body.contains(e);
                while (elem && ko.utils.tagNameLower(elem) !== "html") {
                    elem = elem.parent;
                }return !!elem;
            }

            //clean up bound element list
            var parts = _.partition(vm.__elements__, isElementInDom);
            vm.__elements__ = parts[0];
            //clean up orphan elements
            if (vm.__type__ !== 'vue') {
                _.each(parts[1], function (e) {
                    ko.cleanNode(e);
                });
            }

            //clean up vue model
            if (vm.__type__ === 'vue') {
                var vueArrayParts = _.partition(vm.__vue__, function (vm) {
                    return isElementInDom(vm.$el);
                });
                vm.__vue__ = vueArrayParts[0];
                vm.m = vm.__vue__[0];
                _.each(vueArrayParts[1], function (e) {
                    return e.$destroy();
                });
            }

            //record bound element
            vm.__elements__.push(elem);

            //invoke __init__ callback
            try {
                if (vm.__init__) vm.__init__(elem);
            } catch (e) {
                win.app.console.error(e);
            }
        }

        function bind(elem) {
            var selector = elem;
            elem = $(elem);
            var vm = this;
            if (elem.size() > 0) {
                elem.each(function (idx, el) {
                    var vmName = $(this).attr("data-vm");
                    if (vmName === vm.__vmName__) {
                        if (_.indexOf(vm.__elements__, el) < 0) {
                            intervalBind(vm, el);
                        } else {
                            win.app.console.error("Element has already been bound to the same VM.");
                            win.app.console.error(element);
                        }
                    } else {
                        win.app.console.error("Element must have data-vm attribute refer to " + vm.__vmName__);
                        win.app.console.error(this);
                    }
                });
            } else {
                win.app.console.error("Element " + selector + " not found");
            }
        }

        function addVM(vmName, vm) {
            /* Clean up exiting vm */
            if (win.app.vm[vmName]) {
                var oldVM = win.app.vm[vmName];
                if (oldVM.__type__ === 'vue') {
                    if (oldVM.__vue__) {
                        _.each(oldVM.__vue__, function (v) {
                            try {
                                if (v.__destroy__) v.__destroy__();
                            } catch (e) {
                                app.console.error("Failed calling __destroy__ in " + oldVM.__vmName__);
                                app.console.error(e);
                            }
                            v.$destroy();
                        });
                    }
                } else {
                    try {
                        if (oldVM.__destroy__) oldVM.__destroy__();
                    } catch (e) {
                        app.console.error("Failed calling __destroy__ in " + oldVM.__vmName__);
                        app.console.error(e);
                    }
                    _.each(oldVM.__elements__, function (el) {
                        ko.cleanNode(el);
                    });
                }
                for (var p in oldVM) {
                    try {
                        if (oldVM.hasOwnProperty(p) && _.isFunction(oldVM[p]['dispose'])) {
                            oldVM[p].dispose.call(oldVM);
                        }
                    } catch (e) {}
                }
                oldVM.__elements__ = null;
                oldVM.__vue__ = null;
            }

            vm.__vmName__ = vmName;
            vm.__elements__ = [];
            win.app.vm[vmName] = vm;
        }

        function createVmOnConstructor(constructorName, vmNames) {
            if (!vmNames) vmNames = constructorName;
            if (!_.isArray(vmNames)) vmNames = [vmNames];
            _.each(vmNames, function (vmName) {
                win.app.createVM(constructorName, vmName);
            });
            return app.vm.constructor[constructorName];
        }

        _.extend(win.app, {
            constructors: {},
            vm: {},

            registerConstructor: function registerConstructor(name, type, func, isStatic) {
                if (_.isFunction(type)) {
                    isStatic = func;
                    func = type;
                    type = "ko";
                }
                if (isStatic && this.constructors[name]) return;

                func.prototype.bind = bind;
                func.prototype.__from__ = "Ctor-" + name;
                func.prototype.__type__ = type;

                var self = this;
                self.constructors[name] = function (vmName, options) {
                    if (_.isObject(vmName)) {
                        options = vmName;
                        vmName = undefined;
                    }
                    if (!vmName) vmName = name;
                    var vm = new func(options);
                    addVM(vmName, vm);
                    return vm;
                };

                self.constructors[name].name = name;
                self.constructors[name].createVM = function (vmNames) {
                    return createVmOnConstructor(name, vmNames);
                };

                return self.constructors[name];
            },

            createVM: function createVM() {
                var constructor = void 0,
                    vmName = void 0,
                    options = void 0,
                    vm = void 0,
                    self = this;
                /* Adjust arguments */
                if (_.isObject(arguments[0])) {
                    vm = arguments[0];
                    vmName = arguments[1];
                } else if (_.isString(arguments[1])) {
                    constructor = arguments[0];
                    vmName = arguments[1];
                    options = arguments[2];
                } else if (_.isObject(arguments[1])) {
                    vmName = constructor = arguments[0];
                    options = arguments[1];
                } else if (_.isUndefined(arguments[1])) {
                    if (_.isString(arguments[0])) {
                        vmName = constructor = arguments[0];
                    }
                }

                if (constructor) {
                    //Build from constructor
                    if (self.constructors[constructor]) {
                        vm = self.constructors[constructor](vmName, options);
                    } else {
                        self.console.error("Constructor " + constructor + " not defined.");
                    }
                } else if (vm) {
                    //Build from JS model
                    //TODO VUE: adapt vue
                    if (_.isUndefined(vmName)) {
                        vmName = "vm_" + win.app.utils.id.next();
                    }
                    vm = ko.viewmodel.fromModel(vm);
                    vm.bind = bind;
                    vm.__from__ = "ko.viewmodel";
                    addVM(vmName, vm);
                } else {
                    self.console.error("Illegal arguments.");
                    return;
                }
                return vm;
            },

            updateVM: function updateVM(vmName, viewModel, addNewProperty) {
                var vm = _.isString(vmName) ? app.vm[vmName] : vmName;
                if (!vm) {
                    app.console.error("VM " + vmName + " not found!");
                    return;
                }
                //TODO VUE: adapt vue
                if (vm.__type__ === 'vue') return;

                function updatePropertyIfComplex(prop, value) {
                    if (ko.isWriteableObservable(prop)) {
                        prop(value);
                    } else if (_.isArray(prop)) {
                        if (_.isArray(value)) updateArray(prop, value);
                    } else if (_.isObject(prop)) {
                        if (_.isObject(value)) updateObject(prop, value);
                    } else {
                        return false;
                    }
                    return true;
                }

                function updateObject(target, source) {
                    var pairs = _.pairs(source);
                    _.each(pairs, function (p) {
                        if (target.hasOwnProperty(p[0])) {
                            if (!updatePropertyIfComplex(target[p[0]], p[1])) {
                                target[p[0]] = p[1];
                            }
                        } else if (addNewProperty) {
                            target[p[0]] = p[1];
                        }
                    });
                }

                function getId(obj) {
                    if (_.isFunction(obj.getId)) return obj.getId();
                    if (!_.isUndefined(obj._$id$)) return ko.unwrap(obj._$id$);
                    if (!_.isUndefined(obj.id)) return ko.unwrap(obj.id);
                }

                function removeById(arr, id) {
                    for (var i = arr.length - 1; i >= 0; i--) {
                        if (getId(arr[i]) === id) arr.splice(i, 1);
                    }
                }

                function findById(arr, id) {
                    return _.find(arr, function (el) {
                        return getId(el) === id;
                    });
                }

                function updateArray(target, source) {
                    if (source.length === 0) return;
                    target = ko.unwrap(target);
                    if (!_.isArray(target)) return;
                    var id = void 0,
                        targetEl = void 0;
                    if (_.isObject(source[0])) {
                        if (source[0]._$clear$) {
                            if (target.removeAll) target.removeAll();else target = [];
                        } else {
                            _.each(source, function (sourceEl) {
                                if (_.isObject(sourceEl)) {
                                    if (sourceEl._$add$) {
                                        delete sourceEl["_$add$"];
                                        target.push(ko.viewmodel.fromModel(sourceEl));
                                    } else if (sourceEl._$remove$) {
                                        id = getId(sourceEl);
                                        targetEl = removeById(target, id);
                                    } else {
                                        id = getId(sourceEl);
                                        targetEl = findById(target, id);
                                        if (!_.isUndefined(targetEl)) {
                                            updateObject(targetEl, sourceEl);
                                        }
                                    }
                                }
                            });
                        }
                    } else {
                        var len = Math.min(target.length, source.length);
                        for (var i = 0; i < len; i++) {
                            if (ko.isObservable(target[i])) {
                                target[i](source[i]);
                            } else {
                                target[i] = source[i];
                            }
                        }
                        if (source.length < target.length) {
                            target = target.splice(0, source.length);
                        }
                    }
                }

                if (_.isObject(viewModel)) {
                    if (vm.__form__ === "ko.viewmodel" && viewModel.__form__ === "ko.viewmodel") {
                        delete viewModel.__form__;
                        ko.viewModel.updateFromModel(vm, viewModel);
                    } else {
                        updateObject(vm, viewModel);
                    }
                } else if (_.isArray(viewModel)) {
                    updateArray(vm, viewModel);
                }
            }
        });
    })();

    win.vue = app.vm;
})(window, ko, jQuery);

/***** The Global vm *****/
(function ($) {
    app.registerConstructor("Global", function () {
        this.isSpringboard = false;
        this.viewPort = {
            height: ko.observable(0),
            width: ko.observable(0),
            docWidth: ko.observable(0),
            docHeight: ko.observable(0)
        };
        this.parentScrollTop = function () {
            if (window !== window.parent) {
                $(window.parent.document).find('html, body').animate({ scrollTop: 0 });
            }
        };
        this.getScrollViewportPosition = function () {
            var $win = $(window);
            var viewport = {
                top: $win.scrollTop(),
                left: $win.scrollLeft()
            };
            viewport.bottom = viewport.top + $win.height();
            viewport.right = viewport.left + $win.width();
            return viewport;
        };
        this.showClientMessage = function () {
            app.console.error("showClientMessage is not implemented.");
        };
        this.showLoadingBox = _.noop; //to be implemented by sub systems
        this.hideLoadingBox = _.noop; //to be implemented by sub systems
        this.__resize__ = function () {
            var self = this;
            self.viewPort.width($(window).width());
            self.viewPort.height($(window).height());
            self.viewPort.docWidth($(document).width());
            self.viewPort.docHeight($(document).height());
            var viewPort = {
                height: self.viewPort.height(),
                width: self.viewPort.width(),
                docWidth: self.viewPort.docWidth(),
                docHeight: self.viewPort.docHeight()
            };
            for (var vmName in app.vm) {
                if (app.vm.hasOwnProperty(vmName)) {
                    if (vmName !== 'Global' && app.vm[vmName].__resize__) {
                        app.vm[vmName].__resize__(viewPort);
                    }
                }
            }
        };
        this.$$resizeTimeout = 0;

        this.runWhen = function (action, checker, retry, delay, interval) {
            var t = null;
            if (typeof interval === "undefined") interval = 250;
            function run() {
                if (checker()) {
                    action();
                } else {
                    if (retry-- > 0) {
                        t = setTimeout(run, interval);
                    } else {
                        if (t) clearTimeout(t);
                    }
                }
            }
            if (delay === 0) delay = undefined;
            if (delay) {
                setTimeout(run, delay);
            } else {
                run();
            }
        };

        this.runUntil = function (action, checker, retry, delay, interval) {
            var t = null;
            if (typeof interval === "undefined") interval = 250;
            function run() {
                action();
                if (!checker()) {
                    if (retry-- > 0) {
                        t = setTimeout(run, interval);
                    } else {
                        if (t) clearTimeout(t);
                    }
                }
            }
            if (delay === 0) delay = undefined;
            if (delay) {
                setTimeout(run, delay);
            } else {
                run();
            }
        };

        this.runTick = function (action, interval, immediate) {
            var t = null;
            if (typeof interval === "undefined") interval = 5000;
            if (typeof immediate === "undefined") immediate = true;
            var stopTick = function stopTick() {
                if (t != null) {
                    clearTimeout(t);
                }
            };
            var nextTick = function nextTick() {
                stopTick();
                t = setTimeout(function () {
                    action(nextTick);
                }, interval);
            };
            if (immediate) {
                action(nextTick);
            } else {
                nextTick();
            }
            return stopTick;
        };

        /*--- Fix View State --- */
        /* Copied from OmniFaces.FixViewState but also handles encodeURL for portlet environment */
        this.FixViewState = function (window, document) {

            // "Constant" fields ----------------------------------------------------------------------------------------------

            var VIEW_STATE_PARAM = "javax.faces.ViewState";
            var ENCODED_URL_PARAM = "javax.faces.encodedURL";
            var VIEW_STATE_REGEX = new RegExp("^([\\w]+:)?" + VIEW_STATE_PARAM.replace(/\./g, "\\.") + "(:[0-9]+)?$");
            var RASP_CID_PARAM = new RegExp("(c_id|c_new)=[^&]*&?", "g");

            // Private static fields ------------------------------------------------------------------------------------------

            var self = {};

            // Public static functions ----------------------------------------------------------------------------------------

            function removeRaspConversationParameter(encodedURL) {
                var questionMarkPos = encodedURL.indexOf("?");
                if (questionMarkPos < 0) return encodedURL;
                var base = encodedURL.substring(0, questionMarkPos);
                var queryString = encodedURL.substring(questionMarkPos + 1).replace(RASP_CID_PARAM, "").replace(/&+$/, "");
                if (queryString.length > 0) {
                    return base + "?" + queryString;
                } else {
                    return base;
                }
            }

            /**
             * Apply the "fix view state" on the current document based on the given XML response.
             * @param {XMLHttpRequest} xhr The XMLHttpRequest in the ajax callback
             */
            self.apply = function (xhr) {
                if (typeof xhr === "undefined") return;
                var responseXML = xhr.responseXML;
                var encodedURL = xhr.pfSettings && xhr.pfSettings.url;
                if (typeof responseXML === "undefined" || typeof encodedURL === "undefined") {
                    return;
                }

                var viewStateValue = getViewStateValue(responseXML);

                if (!viewStateValue) {
                    return;
                }

                var encodedURLWithoutRaspCid = removeRaspConversationParameter(encodedURL);

                for (var i = 0; i < document.forms.length; i++) {
                    var form = document.forms[i];
                    var viewStateElement = form[VIEW_STATE_PARAM];
                    var encodedURLElement = form[ENCODED_URL_PARAM];

                    if (form.method === "post" && encodedURLElement && encodedURLElement.value === encodedURL && !viewStateElement) {
                        // This POST form doesn't have a view state. This isn't right. Create it.
                        createViewStateElement(form, viewStateValue);
                    }

                    if (form.method === "post" && encodedURLElement && !viewStateElement) {
                        if (removeRaspConversationParameter(encodedURLElement.value) === encodedURLWithoutRaspCid) {
                            // This POST form doesn't have a view state. This isn't right. Create it.
                            createViewStateElement(form, viewStateValue);
                        }
                    }
                }
            };

            // Private static functions ---------------------------------------------------------------------------------------

            /**
             * Returns the view state value from the given XML response.
             * @param {Document} responseXML The XML response of the XMLHttpRequest.
             * @return {string} The view state value from the given XML response.
             */
            function getViewStateValue(responseXML) {
                var updates = responseXML.getElementsByTagName("update");

                for (var i = 0; i < updates.length; i++) {
                    var update = updates[i];

                    if (VIEW_STATE_REGEX.exec(update.getAttribute("id"))) {
                        return update.textContent || update.innerText;
                    }
                }

                return null;
            }

            /**
             * Create view state hidden input element with given view state value and add it to given form.
             * @param {HTMLFormElement} form The form to add the view state hidden input element to.
             * @param {string} viewStateValue The view state value to be added to the newly created view state hidden input element.
             */
            function createViewStateElement(form, viewStateValue) {
                var hidden = void 0;

                try {
                    hidden = document.createElement("<input name='" + VIEW_STATE_PARAM + "'>"); // IE6-8.
                } catch (e) {
                    hidden = document.createElement("input");
                    hidden.setAttribute("name", VIEW_STATE_PARAM);
                }

                hidden.setAttribute("type", "hidden");
                hidden.setAttribute("value", viewStateValue);
                hidden.setAttribute("autocomplete", "off");
                form.appendChild(hidden);
            }
            return self;
        }(window, document);

        /**
         * Check whether the current browser supports a given css property.
         *
         * Example:
         * app.vm.Global.browserSupportsCSSProperty('animation')
         *
         * returns true in modern browsers and false in IE9 or below.
         * @param propertyName
         * @returns {boolean}
         */
        this.browserSupportsCSSProperty = function (propertyName) {
            var elm = document.createElement('div');
            propertyName = propertyName.toLowerCase();

            if (elm.style[propertyName] !== undefined) return true;

            var propertyNameCapital = propertyName.charAt(0).toUpperCase() + propertyName.substr(1),
                domPrefixes = 'Webkit Moz ms O'.split(' ');

            for (var i = 0; i < domPrefixes.length; i++) {
                if (elm.style[domPrefixes[i] + propertyNameCapital] !== undefined) return true;
            }
            return false;
        };
    }, true);
})(jQuery);

app.createVM("Global");

(function ($) {
    $(document).ready(function () {
        $(window).on('resize', function () {
            if (app.vm.Global.$$resizeTimeout) {
                clearTimeout(app.vm.Global.$$resizeTimeout);
            }
            app.vm.Global.$$resizeTimeout = setTimeout(function () {
                app.vm.Global.__resize__();
            }, 200);
        });

        app.vm.Global.__resize__();
    });
})(jQuery);

/***** Custom bindings *****/

(function ($) {
    ko.bindingHandlers.slideVisible = {
        init: function init(element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            if (!value) $(element).hide();
        },
        update: function update(element, valueAccessor, allBindings) {
            var value = ko.unwrap(valueAccessor());
            var duration = allBindings.get('duration') || 400;
            if (value) $(element).slideDown(duration);else $(element).slideUp(duration);
        }
    };
})(jQuery);(function ($) {
    ko.bindingHandlers.fadeVisible = {
        init: function init(element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            if (!value) $(element).hide();
        },
        update: function update(element, valueAccessor, allBindings) {
            var value = ko.unwrap(valueAccessor());
            var duration = allBindings.get('duration') || 400;
            if (value) $(element).fadeIn(duration);else $(element).fadeOut(duration);
        }
    };
})(jQuery);(function ($) {
    ko.bindingHandlers.hover = {
        init: function init(element, valueAccessor) {
            var className = ko.unwrap(valueAccessor());
            $(element).hover(function () {
                $(this).addClass(className);
            }, function () {
                $(this).removeClass(className);
            });
        }
    };
})(jQuery);

ko.bindingHandlers.href = {
    update: function update(element, valueAccessor) {
        ko.bindingHandlers.attr.update(element, function () {
            return { href: valueAccessor() };
        });
    }
};

ko.bindingHandlers.src = {
    update: function update(element, valueAccessor) {
        ko.bindingHandlers.attr.update(element, function () {
            return { src: valueAccessor() };
        });
    }
};

ko.bindingHandlers.disabled = {
    update: function update(element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        if (value) {
            $(element).addClass('disabled');
        } else {
            $(element).removeClass('disabled');
        }
        ko.bindingHandlers.attr.update(element, function () {
            return { disabled: value };
        });
    }
};
ko.bindingHandlers.enabled = {
    update: function update(element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        if (value) {
            $(element).removeClass('disabled');
        } else {
            $(element).addClass('disabled');
        }
        ko.bindingHandlers.attr.update(element, function () {
            return { disabled: !value };
        });
    }
};

ko.bindingHandlers.hidden = {
    update: function update(element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        ko.bindingHandlers.visible.update(element, function () {
            return !value;
        });
    }
};

ko.bindingHandlers.toggle = {
    init: function init(element, valueAccessor) {
        var value = valueAccessor();
        ko.applyBindingsToNode(element, {
            click: function click() {
                value(!value());
            }
        });
    }
};

(function () {
    var factory = function factory(n) {
        return {
            init: function init(element, valueAccessor) {
                var classNames = ko.unwrap(valueAccessor());
                var el = $(element);
                el.addClass(classNames).data("prev-class-" + n, classNames);
            },
            update: function update(element, valueAccessor) {
                var el = $(element);
                var prev = el.data("prev-class-" + n);
                var current = " " + ko.unwrap(valueAccessor()) + " ";
                var toRemove = ko.utils.arrayFilter((prev || "").split(/\s+/), function (item) {
                    return app.utils.trimString(item).length > 0 && current.indexOf(" " + item + " ") < 0;
                }).join(" ");
                if (toRemove.length > 0) el.removeClass(toRemove);
                el.addClass(current);
            }
        };
    };

    ko.bindingHandlers.styleClass = factory(0);
    for (var i = 1; i < 10; i++) {
        ko.bindingHandlers['styleClass' + i] = factory(i);
    }
})(jQuery);

ko.bindingHandlers.stop = {
    init: function init() {
        return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.stop = true;

ko.bindingHandlers.noKnockout = {
    init: function init() {
        return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.noKnockout = true;(function ($) {
    ko.bindingHandlers.bindChildren = {
        init: function init(element) {
            $.each(element.attributes, function () {
                try {
                    var attr = this,
                        name = void 0,
                        value = void 0,
                        parts = void 0;
                    if (attr.specified) {
                        name = attr.name;
                        if (name.match(/^data-bind-child(?:-\d+)?$/i)) {
                            value = attr.value;
                            parts = value.split(/\s*@\s*/);
                            if (parts.length === 2) {
                                $(element).find(parts[1]).each(function () {
                                    $(this).attr("data-bind", parts[0]);
                                });
                            } else {
                                app.console.error("Invalid data-bind-child content: " + value);
                            }
                        }
                    }
                } catch (err) {
                    app.console.error(err);
                }
            });
        }
    };
})(jQuery);

ko.virtualElements.allowedBindings.bindChildren = true;(function ($) {
    ko.bindingHandlers.select2 = {
        init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (element.tagName.toLowerCase() !== "select") {
                app.console.error("select2 binging must apply on a <select> element.");
                app.console.log(element);
                return;
            }
            if (!$ || !$.fn || !$.fn.select2) {
                app.console.error("jQuery with select2 plugin is required.");
                app.console.log(element);
                return;
            }

            // bind descendant elements
            ko.applyBindingsToDescendants(bindingContext, element);
            // apply select2 plugin
            var opts = ko.unwrap(valueAccessor());
            if ((typeof opts === "undefined" ? "undefined" : _typeof(opts)) !== "object") {
                $(element).select2();
            } else {
                $(element).select2(opts);
            }
            // Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
            return { controlsDescendantBindings: true };
        },

        update: function update(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var selected = ko.unwrap(allBindings.get("selectedOptions"));
            $(element).select2("val", selected);
        }
    };
})(jQuery);

(function ($) {
    ko.bindingHandlers.expandableTextField = {
        init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (ko.utils.tagNameLower(element) !== "input") {
                app.console.error("expandableTextfield binging must apply on a <input> element.");
                app.console.log(element);
                return;
            }
            if (!$ || !$.fn || !$.fn.expandableTextfield) {
                app.console.error("jQuery with expandableTextfield plugin is required.");
                app.console.log(element);
                return;
            }

            var opts = ko.unwrap(valueAccessor());
            if (_.isObject(opts)) {
                $(element).expandableTextfield();
            } else {
                $(element).expandableTextfield(opts);
            }
        }
    };
})(jQuery);

//Shortcut for common events

_.each(["dblclick", "onBlur", "onFocus", "onChange"], function (eventName) {
    ko.bindingHandlers[eventName] = {
        'init': function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var newValueAccessor = function newValueAccessor() {
                var result = {};
                result[eventName] = valueAccessor();
                return result;
            };
            return ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindings, viewModel, bindingContext);
        }
    };
})

//Wrap the textInput and value handler to handle keepInitialValue binding 
;(function ($) {
    var textInputHandler = ko.bindingHandlers.textInput;
    var valueHandler = ko.bindingHandlers.value;
    var initViewModel = function initViewModel(element, valueAccessor, allBindings) {
        if (allBindings.has("keepInitialValue")) {
            if (ko.isWritableObservable(valueAccessor())) {
                valueAccessor()($(element).val());
            }
        }
    };

    ko.bindingHandlers.textInput = {
        'init': function init(element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            textInputHandler.init(element, valueAccessor, allBindings);
        }
    };
    ko.bindingHandlers.textInput.__proto__ = textInputHandler;

    ko.bindingHandlers.value = {
        'init': function init(element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            valueHandler.init(element, valueAccessor, allBindings);
        }
    };
    ko.bindingHandlers.value.__proto__ = valueHandler;
})(jQuery);

//Wrap the checked handler to handle keepInitialValue binding 
(function () {
    var checkedHandler = ko.bindingHandlers.checked;
    var initViewModel = function initViewModel(element, valueAccessor, allBindings) {
        function updateModel() {
            /* A simplified version of internal helper function in ko.bindingHandlers.checked */

            var isCheckbox = element.type === "checkbox",
                isRadio = element.type === "radio",
                isChecked = element.checked;
            var useCheckedValue = isRadio || isValueArray;
            var elemValue = useCheckedValue ? checkedValue() : isChecked;

            // We can ignore unchecked radio buttons, because some other radio
            // button will be getting checked, and that one can take care of updating state.
            if (isRadio && !isChecked) {
                return;
            }
            var isValueArray = isCheckbox && ko.utils.unwrapObservable(valueAccessor()) instanceof Array;
            if (isValueArray) {
                app.console.error('"keepInitialValue" does not support array value on the "checked" binding.');
            } else {
                valueAccessor()(elemValue);
            }
        }

        if (allBindings.has("keepInitialValue")) {
            if (ko.isWritableObservable(valueAccessor())) {
                updateModel();
            }
        }
    };

    ko.bindingHandlers.checked = {
        'init': function init(element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            checkedHandler.init(element, valueAccessor, allBindings);
        }
    };
    ko.bindingHandlers.checked.__proto__ = checkedHandler;
})();

(function ($) {
    var selectedOptionsHandler = ko.bindingHandlers.selectedOptions;
    ko.bindingHandlers.selectedOptions = {
        'init': function init(element, valueAccessor, allBindings) {
            if (allBindings.has("keepInitialValue")) {
                (function () {
                    var value = valueAccessor(),
                        valueToWrite = [];
                    ko.utils.arrayForEach(element.getElementsByTagName("option"), function (node) {
                        if (node.selected) valueToWrite.push(ko.selectExtensions.readValue(node));
                    });
                    value(valueToWrite);
                })();
            }
            selectedOptionsHandler.init(element, valueAccessor, allBindings);
        },
        'update': function update(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (allBindings.has("select2")) {
                if (element.tagName.toLowerCase() !== "select") {
                    app.console.error("select2 binging must apply on a <select> element.");
                    app.console.log(element);
                    return;
                }
                if (!$ || !$.fn || !$.fn.select2) {
                    app.console.error("jQuery with select2 plugin is required.");
                    app.console.log(element);
                    return;
                }
                var selected = ko.unwrap(valueAccessor());
                $(element).select2("val", selected);
            }
            selectedOptionsHandler.update(element, valueAccessor, allBindings, viewModel, bindingContext);
        }

    };
    ko.bindingHandlers.selectedOptions.__proto__ = selectedOptionsHandler;
})(jQuery);

ko.bindingHandlers.currency = {
    symbol: "$",
    decimal: 2,
    update: function update(element, valueAccessor, allBindingsAccessor) {
        return ko.bindingHandlers.text.update(element, function () {
            var value = +(ko.utils.unwrapObservable(valueAccessor()) || 0),
                symbol = ko.utils.unwrapObservable(allBindingsAccessor().symbol !== undefined ? allBindingsAccessor().symbol : ko.bindingHandlers.currency.symbol);
            decimal = ko.utils.unwrapObservable(allBindingsAccessor().decimal !== undefined ? allBindingsAccessor().decimal : ko.bindingHandlers.currency.decimal);
            return symbol + value.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?:\.|$))/g, "$1,");
        });
    }
};

(function () {
    ko.bindingHandlers.inputmask = {
        init: function init(element, valueAccessor, allBindingsAccessor) {

            var mask = valueAccessor();

            var observable = mask.value;

            if (ko.isObservable(observable)) {

                $(element).on('focusout change', function () {

                    if ($(element).inputmask('isComplete')) {
                        observable($(element).val());
                    } else {
                        observable(null);
                    }
                });
            }

            $(element).inputmask(mask);
        },
        update: function update(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var mask = valueAccessor();

            var observable = mask.value;

            if (ko.isObservable(observable)) {

                var valuetoWrite = observable();

                $(element).val(valuetoWrite);
            }
        }

    };
})();

/** Knockout Extensions **/

ko.extenders.url = function (target, protocal) {
    if (!protocal) protocal = "http";
    var newComputedObservable = ko.pureComputed({
        read: target,
        write: function write(newValue) {
            var current = target();
            var valueToWrite = newValue || "";
            if (app.utils.trimString(valueToWrite).length > 0 && current.indexOf("://") >= 0 && valueToWrite.indexOf("://") < 0) {
                valueToWrite = current.substring(current.indexOf("://") + 3);
            }
            if (valueToWrite.length > 10 && valueToWrite.indexOf("://") < 0 && valueToWrite[0] !== "/") {
                valueToWrite = protocal + "://" + valueToWrite;
            }
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always' });

    //initialize with current value to make sure it is rounded appropriately
    newComputedObservable(target());

    //return the new computed observable
    return newComputedObservable;
};

/** Vue filters **/
if (window['Vue']) {
    Vue.filter('removeUnderScore', function (value, replacement) {
        return value.replace(/_/g, replacement || ' ');
    });

    Vue.filter('gt0', function (value) {
        return value > 0;
    });

    Vue.filter('gt1', function (value) {
        return value > 1;
    });

    Vue.filter('pluralizedLabel', function (value, label) {
        return app.utils.pluralize(label, value);
    });

    Vue.filter('attachPluralizedLabel', function (value, label) {
        return app.utils.pluralize(label, value, true);
    });
}
/** Vue filters ends **/

/* Patch PF to output better error message */
(function () {
    if (!window['PF']) return;
    if (window['originalPF']) return;
    window.originalPF = window.PF;
    window.PF = function () {
        var result = window.originalPF.apply(this, arguments);
        if (typeof result === 'undefined') {
            app.console.info('PF(%o) is undefined', arguments);
        }
        return result;
    };
})();

/**
 * History.js jQuery Adapter
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

// Closure
(function (window, undefined) {
    "use strict";

    // Localise Globals

    var History = window.History = window.History || {},
        jQuery = window.jQuery;

    // Check Existence
    if (typeof History.Adapter !== 'undefined') {
        window['console'] && console.log && console.error('History.js Adapter has already been loaded...');
        return;
    }

    // Add the Adapter
    History.Adapter = {
        /**
         * History.Adapter.bind(el,event,callback)
         * @param {Element|string} el
         * @param {string} event - custom and standard events
         * @param {function} callback
         * @return {void}
         */
        bind: function bind(el, event, callback) {
            jQuery(el).bind(event, callback);
        },

        /**
         * History.Adapter.trigger(el,event)
         * @param {Element|string} el
         * @param {string} event - custom and standard events
         * @param {Object=} extra - a object of extra event data (optional)
         * @return {void}
         */
        trigger: function trigger(el, event, extra) {
            jQuery(el).trigger(event, extra);
        },

        /**
         * History.Adapter.extractEventData(key,event,extra)
         * @param {string} key - key for the event data to extract
         * @param {string} event - custom and standard events
         * @param {Object=} extra - a object of extra event data (optional)
         * @return {mixed}
         */
        extractEventData: function extractEventData(key, event, extra) {
            // jQuery Native then jQuery Custom
            var result = event && event.originalEvent && event.originalEvent[key] || extra && extra[key] || undefined;

            // Return
            return result;
        },

        /**
         * History.Adapter.onDomLoad(callback)
         * @param {function} callback
         * @return {void}
         */
        onDomLoad: function onDomLoad(callback) {
            jQuery(callback);
        }
    };

    // Try and Initialise History
    if (typeof History.init !== 'undefined') {
        History.init();
    }
})(window);

/**
 * History.js HTML4 Support
 * Depends on the HTML5 Support
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

(function (window, undefined) {
    "use strict";

    // ========================================================================
    // Initialise

    // Localise Globals

    var document = window.document,
        // Make sure we are using the correct document
    setTimeout = window.setTimeout || setTimeout,
        clearTimeout = window.clearTimeout || clearTimeout,
        setInterval = window.setInterval || setInterval,
        History = window.History = window.History || {}; // Public History Object

    // Check Existence
    if (typeof History.initHtml4 !== 'undefined') {
        window['console'] && console.log && console.error('History.js HTML4 Support has already been loaded...');
        return;
    }

    // ========================================================================
    // Initialise HTML4 Support

    // Initialise HTML4 Support
    History.initHtml4 = function () {
        // Initialise
        if (typeof History.initHtml4.initialized !== 'undefined') {
            // Already Loaded
            return false;
        } else {
            History.initHtml4.initialized = true;
        }

        // ====================================================================
        // Properties

        /**
         * History.enabled
         * Is History enabled?
         */
        History.enabled = true;

        // ====================================================================
        // Hash Storage

        /**
         * History.savedHashes
         * Store the hashes in an array
         */
        History.savedHashes = [];

        /**
         * History.isLastHash(newHash)
         * Checks if the hash is the last hash
         * @param {string} newHash
         * @return {boolean} true
         */
        History.isLastHash = function (newHash) {
            // Prepare
            var oldHash = History.getHashByIndex(),
                isLast;

            // Check
            isLast = newHash === oldHash;

            // Return isLast
            return isLast;
        };

        /**
         * History.isHashEqual(newHash, oldHash)
         * Checks to see if two hashes are functionally equal
         * @param {string} newHash
         * @param {string} oldHash
         * @return {boolean} true
         */
        History.isHashEqual = function (newHash, oldHash) {
            newHash = encodeURIComponent(newHash).replace(/%25/g, "%");
            oldHash = encodeURIComponent(oldHash).replace(/%25/g, "%");
            return newHash === oldHash;
        };

        /**
         * History.saveHash(newHash)
         * Push a Hash
         * @param {string} newHash
         * @return {boolean} true
         */
        History.saveHash = function (newHash) {
            // Check Hash
            if (History.isLastHash(newHash)) {
                return false;
            }

            // Push the Hash
            History.savedHashes.push(newHash);

            // Return true
            return true;
        };

        /**
         * History.getHashByIndex()
         * Gets a hash by the index
         * @param {integer} index
         * @return {string}
         */
        History.getHashByIndex = function (index) {
            // Prepare
            var hash = null;

            // Handle
            if (typeof index === 'undefined') {
                // Get the last inserted
                hash = History.savedHashes[History.savedHashes.length - 1];
            } else if (index < 0) {
                // Get from the end
                hash = History.savedHashes[History.savedHashes.length + index];
            } else {
                // Get from the beginning
                hash = History.savedHashes[index];
            }

            // Return hash
            return hash;
        };

        // ====================================================================
        // Discarded States

        /**
         * History.discardedHashes
         * A hashed array of discarded hashes
         */
        History.discardedHashes = {};

        /**
         * History.discardedStates
         * A hashed array of discarded states
         */
        History.discardedStates = {};

        /**
         * History.discardState(State)
         * Discards the state by ignoring it through History
         * @param {object} State
         * @return {true}
         */
        History.discardState = function (discardedState, forwardState, backState) {
            //History.debug('History.discardState', arguments);
            // Prepare
            var discardedStateHash = History.getHashByState(discardedState),
                discardObject;

            // Create Discard Object
            discardObject = {
                'discardedState': discardedState,
                'backState': backState,
                'forwardState': forwardState
            };

            // Add to DiscardedStates
            History.discardedStates[discardedStateHash] = discardObject;

            // Return true
            return true;
        };

        /**
         * History.discardHash(hash)
         * Discards the hash by ignoring it through History
         * @param {string} hash
         * @return {true}
         */
        History.discardHash = function (discardedHash, forwardState, backState) {
            //History.debug('History.discardState', arguments);
            // Create Discard Object
            var discardObject = {
                'discardedHash': discardedHash,
                'backState': backState,
                'forwardState': forwardState
            };

            // Add to discardedHash
            History.discardedHashes[discardedHash] = discardObject;

            // Return true
            return true;
        };

        /**
         * History.discardedState(State)
         * Checks to see if the state is discarded
         * @param {object} State
         * @return {bool}
         */
        History.discardedState = function (State) {
            // Prepare
            var StateHash = History.getHashByState(State),
                discarded;

            // Check
            discarded = History.discardedStates[StateHash] || false;

            // Return true
            return discarded;
        };

        /**
         * History.discardedHash(hash)
         * Checks to see if the state is discarded
         * @param {string} State
         * @return {bool}
         */
        History.discardedHash = function (hash) {
            // Check
            var discarded = History.discardedHashes[hash] || false;

            // Return true
            return discarded;
        };

        /**
         * History.recycleState(State)
         * Allows a discarded state to be used again
         * @param {object} data
         * @param {string} title
         * @param {string} url
         * @return {true}
         */
        History.recycleState = function (State) {
            //History.debug('History.recycleState', arguments);
            // Prepare
            var StateHash = History.getHashByState(State);

            // Remove from DiscardedStates
            if (History.discardedState(State)) {
                delete History.discardedStates[StateHash];
            }

            // Return true
            return true;
        };

        // ====================================================================
        // HTML4 HashChange Support

        if (History.emulated.hashChange) {
            /*
             * We must emulate the HTML4 HashChange Support by manually checking for hash changes
             */

            /**
             * History.hashChangeInit()
             * Init the HashChange Emulation
             */
            History.hashChangeInit = function () {
                // Define our Checker Function
                History.checkerFunction = null;

                // Define some variables that will help in our checker function
                var lastDocumentHash = '',
                    iframeId,
                    iframe,
                    lastIframeHash,
                    checkerRunning,
                    startedWithHash = Boolean(History.getHash());

                // Handle depending on the browser
                if (History.isInternetExplorer()) {
                    // IE6 and IE7
                    // We need to use an iframe to emulate the back and forward buttons

                    // Create iFrame
                    iframeId = 'historyjs-iframe';
                    iframe = document.createElement('iframe');

                    // Adjust iFarme
                    // IE 6 requires iframe to have a src on HTTPS pages, otherwise it will throw a
                    // "This page contains both secure and nonsecure items" warning.
                    iframe.setAttribute('id', iframeId);
                    iframe.setAttribute('src', '#');
                    iframe.style.display = 'none';

                    // Append iFrame
                    document.body.appendChild(iframe);

                    // Create initial history entry
                    iframe.contentWindow.document.open();
                    iframe.contentWindow.document.close();

                    // Define some variables that will help in our checker function
                    lastIframeHash = '';
                    checkerRunning = false;

                    // Define the checker function
                    History.checkerFunction = function () {
                        // Check Running
                        if (checkerRunning) {
                            return false;
                        }

                        // Update Running
                        checkerRunning = true;

                        // Fetch
                        var documentHash = History.getHash(),
                            iframeHash = History.getHash(iframe.contentWindow.document);

                        // The Document Hash has changed (application caused)
                        if (documentHash !== lastDocumentHash) {
                            // Equalise
                            lastDocumentHash = documentHash;

                            // Create a history entry in the iframe
                            if (iframeHash !== documentHash) {
                                //History.debug('hashchange.checker: iframe hash change', 'documentHash (new):', documentHash, 'iframeHash (old):', iframeHash);

                                // Equalise
                                lastIframeHash = iframeHash = documentHash;

                                // Create History Entry
                                iframe.contentWindow.document.open();
                                iframe.contentWindow.document.close();

                                // Update the iframe's hash
                                iframe.contentWindow.document.location.hash = History.escapeHash(documentHash);
                            }

                            // Trigger Hashchange Event
                            History.Adapter.trigger(window, 'hashchange');
                        }

                        // The iFrame Hash has changed (back button caused)
                        else if (iframeHash !== lastIframeHash) {
                                //History.debug('hashchange.checker: iframe hash out of sync', 'iframeHash (new):', iframeHash, 'documentHash (old):', documentHash);

                                // Equalise
                                lastIframeHash = iframeHash;

                                // If there is no iframe hash that means we're at the original
                                // iframe state.
                                // And if there was a hash on the original request, the original
                                // iframe state was replaced instantly, so skip this state and take
                                // the user back to where they came from.
                                if (startedWithHash && iframeHash === '') {
                                    History.back();
                                } else {
                                    // Update the Hash
                                    History.setHash(iframeHash, false);
                                }
                            }

                        // Reset Running
                        checkerRunning = false;

                        // Return true
                        return true;
                    };
                } else {
                    // We are not IE
                    // Firefox 1 or 2, Opera

                    // Define the checker function
                    History.checkerFunction = function () {
                        // Prepare
                        var documentHash = History.getHash() || '';

                        // The Document Hash has changed (application caused)
                        if (documentHash !== lastDocumentHash) {
                            // Equalise
                            lastDocumentHash = documentHash;

                            // Trigger Hashchange Event
                            History.Adapter.trigger(window, 'hashchange');
                        }

                        // Return true
                        return true;
                    };
                }

                // Apply the checker function
                History.intervalList.push(setInterval(History.checkerFunction, History.options.hashChangeInterval));

                // Done
                return true;
            }; // History.hashChangeInit

            // Bind hashChangeInit
            History.Adapter.onDomLoad(History.hashChangeInit);
        } // History.emulated.hashChange


        // ====================================================================
        // HTML5 State Support

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /*
             * We must emulate the HTML5 State Management by using HTML4 HashChange
             */

            /**
             * History.onHashChange(event)
             * Trigger HTML5's window.onpopstate via HTML4 HashChange Support
             */
            History.onHashChange = function (event) {
                //History.debug('History.onHashChange', arguments);

                // Prepare
                var currentUrl = event && event.newURL || History.getLocationHref(),
                    currentHash = History.getHashByUrl(currentUrl),
                    currentState = null,
                    currentStateHash = null,
                    currentStateHashExits = null,
                    discardObject;

                // Check if we are the same state
                if (History.isLastHash(currentHash)) {
                    // There has been no change (just the page's hash has finally propagated)
                    //History.debug('History.onHashChange: no change');
                    History.busy(false);
                    return false;
                }

                // Reset the double check
                History.doubleCheckComplete();

                // Store our location for use in detecting back/forward direction
                History.saveHash(currentHash);

                // Expand Hash
                if (currentHash && History.isTraditionalAnchor(currentHash)) {
                    //History.debug('History.onHashChange: traditional anchor', currentHash);
                    // Traditional Anchor Hash
                    History.Adapter.trigger(window, 'anchorchange');
                    History.busy(false);
                    return false;
                }

                // Create State
                currentState = History.extractState(History.getFullUrl(currentHash || History.getLocationHref()), true);

                // Check if we are the same state
                if (History.isLastSavedState(currentState)) {
                    //History.debug('History.onHashChange: no change');
                    // There has been no change (just the page's hash has finally propagated)
                    History.busy(false);
                    return false;
                }

                // Create the state Hash
                currentStateHash = History.getHashByState(currentState);

                // Check if we are DiscardedState
                discardObject = History.discardedState(currentState);
                if (discardObject) {
                    // Ignore this state as it has been discarded and go back to the state before it
                    if (History.getHashByIndex(-2) === History.getHashByState(discardObject.forwardState)) {
                        // We are going backwards
                        //History.debug('History.onHashChange: go backwards');
                        History.back(false);
                    } else {
                        // We are going forwards
                        //History.debug('History.onHashChange: go forwards');
                        History.forward(false);
                    }
                    return false;
                }

                // Push the new HTML5 State
                //History.debug('History.onHashChange: success hashchange');
                History.pushState(currentState.data, currentState.title, encodeURI(currentState.url), false);

                // End onHashChange closure
                return true;
            };
            History.Adapter.bind(window, 'hashchange', History.onHashChange);

            /**
             * History.pushState(data,title,url)
             * Add a new State to the history object, become it, and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.pushState = function (data, title, url, queue) {
                //History.debug('History.pushState: called', arguments);

                // We assume that the URL passed in is URI-encoded, but this makes
                // sure that it's fully URI encoded; any '%'s that are encoded are
                // converted back into '%'s
                url = encodeURI(url).replace(/%25/g, "%");

                // Check the State
                if (History.getHashByUrl(url)) {
                    throw new Error('History.js does not support states with fragment-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.pushState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.pushState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy
                History.busy(true);

                // Fetch the State Object
                var newState = History.createStateObject(data, title, url),
                    newStateHash = History.getHashByState(newState),
                    oldState = History.getState(false),
                    oldStateHash = History.getHashByState(oldState),
                    html4Hash = History.getHash(),
                    wasExpected = History.expectedStateId == newState.id;

                // Store the newState
                History.storeState(newState);
                History.expectedStateId = newState.id;

                // Recycle the State
                History.recycleState(newState);

                // Force update of the title
                History.setTitle(newState);

                // Check if we are the same State
                if (newStateHash === oldStateHash) {
                    //History.debug('History.pushState: no change', newStateHash);
                    History.busy(false);
                    return false;
                }

                // Update HTML5 State
                History.saveState(newState);

                // Fire HTML5 Event
                if (!wasExpected) History.Adapter.trigger(window, 'statechange');

                // Update HTML4 Hash
                if (!History.isHashEqual(newStateHash, html4Hash) && !History.isHashEqual(newStateHash, History.getShortUrl(History.getLocationHref()))) {
                    History.setHash(newStateHash, false);
                }

                History.busy(false);

                // End pushState closure
                return true;
            };

            /**
             * History.replaceState(data,title,url)
             * Replace the State and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.replaceState = function (data, title, url, queue) {
                //History.debug('History.replaceState: called', arguments);

                // We assume that the URL passed in is URI-encoded, but this makes
                // sure that it's fully URI encoded; any '%'s that are encoded are
                // converted back into '%'s
                url = encodeURI(url).replace(/%25/g, "%");

                // Check the State
                if (History.getHashByUrl(url)) {
                    throw new Error('History.js does not support states with fragment-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.replaceState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.replaceState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy
                History.busy(true);

                // Fetch the State Objects
                var newState = History.createStateObject(data, title, url),
                    newStateHash = History.getHashByState(newState),
                    oldState = History.getState(false),
                    oldStateHash = History.getHashByState(oldState),
                    previousState = History.getStateByIndex(-2);

                // Discard Old State
                History.discardState(oldState, newState, previousState);

                // If the url hasn't changed, just store and save the state
                // and fire a statechange event to be consistent with the
                // html 5 api
                if (newStateHash === oldStateHash) {
                    // Store the newState
                    History.storeState(newState);
                    History.expectedStateId = newState.id;

                    // Recycle the State
                    History.recycleState(newState);

                    // Force update of the title
                    History.setTitle(newState);

                    // Update HTML5 State
                    History.saveState(newState);

                    // Fire HTML5 Event
                    //History.debug('History.pushState: trigger popstate');
                    History.Adapter.trigger(window, 'statechange');
                    History.busy(false);
                } else {
                    // Alias to PushState
                    History.pushState(newState.data, newState.title, newState.url, false);
                }

                // End replaceState closure
                return true;
            };
        } // History.emulated.pushState


        // ====================================================================
        // Initialise

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /**
             * Ensure initial state is handled correctly
             */
            if (History.getHash() && !History.emulated.hashChange) {
                History.Adapter.onDomLoad(function () {
                    History.Adapter.trigger(window, 'hashchange');
                });
            }
        } // History.emulated.pushState
    }; // History.initHtml4

    // Try to Initialise History
    if (typeof History.init !== 'undefined') {
        History.init();
    }
})(window);
/**
 * History.js Core
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

(function (window, undefined) {
    "use strict";

    // ========================================================================
    // Initialise

    // Localise Globals

    var console = window.console || undefined,
        // Prevent a JSLint complain
    document = window.document,
        // Make sure we are using the correct document
    navigator = window.navigator,
        // Make sure we are using the correct navigator
    sessionStorage = false,
        // sessionStorage
    setTimeout = window.setTimeout,
        clearTimeout = window.clearTimeout,
        setInterval = window.setInterval,
        clearInterval = window.clearInterval,
        JSON = window.JSON,
        alert = window.alert,
        History = window.History = window.History || {},
        // Public History Object
    history = window.history; // Old History Object

    try {
        sessionStorage = window.sessionStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
        sessionStorage.setItem('TEST', '1');
        sessionStorage.removeItem('TEST');
    } catch (e) {
        sessionStorage = false;
    }

    // MooTools Compatibility
    JSON.stringify = JSON.stringify || JSON.encode;
    JSON.parse = JSON.parse || JSON.decode;

    // Check Existence
    if (typeof History.init !== 'undefined') {
        window['console'] && console.log && console.error('History.js Core has already been loaded...');
        return;
    }

    // Initialise History
    History.init = function (options) {
        // Check Load Status of Adapter
        if (typeof History.Adapter === 'undefined') {
            return false;
        }

        // Check Load Status of Core
        if (typeof History.initCore !== 'undefined') {
            History.initCore();
        }

        // Check Load Status of HTML4 Support
        if (typeof History.initHtml4 !== 'undefined') {
            History.initHtml4();
        }

        // Return true
        return true;
    };

    // ========================================================================
    // Initialise Core

    // Initialise Core
    History.initCore = function (options) {
        // Initialise
        if (typeof History.initCore.initialized !== 'undefined') {
            // Already Loaded
            return false;
        } else {
            History.initCore.initialized = true;
        }

        // ====================================================================
        // Options

        /**
         * History.options
         * Configurable options
         */
        History.options = History.options || {};

        /**
         * History.options.hashChangeInterval
         * How long should the interval be before hashchange checks
         */
        History.options.hashChangeInterval = History.options.hashChangeInterval || 100;

        /**
         * History.options.safariPollInterval
         * How long should the interval be before safari poll checks
         */
        History.options.safariPollInterval = History.options.safariPollInterval || 500;

        /**
         * History.options.doubleCheckInterval
         * How long should the interval be before we perform a double check
         */
        History.options.doubleCheckInterval = History.options.doubleCheckInterval || 500;

        /**
         * History.options.disableSuid
         * Force History not to append suid
         */
        History.options.disableSuid = History.options.disableSuid || false;

        /**
         * History.options.storeInterval
         * How long should we wait between store calls
         */
        History.options.storeInterval = History.options.storeInterval || 1000;

        /**
         * History.options.busyDelay
         * How long should we wait between busy events
         */
        History.options.busyDelay = History.options.busyDelay || 250;

        /**
         * History.options.debug
         * If true will enable debug messages to be logged
         */
        History.options.debug = History.options.debug || false;

        /**
         * History.options.initialTitle
         * What is the title of the initial state
         */
        History.options.initialTitle = History.options.initialTitle || document.title;

        /**
         * History.options.html4Mode
         * If true, will force HTMl4 mode (hashtags)
         */
        History.options.html4Mode = History.options.html4Mode || false;

        /**
         * History.options.delayInit
         * Want to override default options and call init manually.
         */
        History.options.delayInit = History.options.delayInit || false;

        // ====================================================================
        // Interval record

        /**
         * History.intervalList
         * List of intervals set, to be cleared when document is unloaded.
         */
        History.intervalList = [];

        /**
         * History.clearAllIntervals
         * Clears all setInterval instances.
         */
        History.clearAllIntervals = function () {
            var i,
                il = History.intervalList;
            if (typeof il !== "undefined" && il !== null) {
                for (i = 0; i < il.length; i++) {
                    clearInterval(il[i]);
                }
                History.intervalList = null;
            }
        };

        // ====================================================================
        // Debug

        /**
         * History.debug(message,...)
         * Logs the passed arguments if debug enabled
         */
        History.debug = function () {
            if (History.options.debug || false) {
                History.log.apply(History, arguments);
            }
        };

        /**
         * History.log(message,...)
         * Logs the passed arguments
         */
        History.log = function () {
            // Prepare
            var consoleExists = !(typeof console === 'undefined' || typeof console.log === 'undefined' || typeof console.log.apply === 'undefined'),
                textarea = document.getElementById('log'),
                message,
                i,
                n,
                args,
                arg;

            // Write to Console
            if (consoleExists) {
                args = Array.prototype.slice.call(arguments);
                message = args.shift();
                if (typeof console.debug !== 'undefined') {
                    console.debug.apply(console, [message, args]);
                } else {
                    console.log.apply(console, [message, args]);
                }
            } else {
                message = "\n" + arguments[0] + "\n";
            }

            // Write to log
            for (i = 1, n = arguments.length; i < n; ++i) {
                arg = arguments[i];
                if ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) === 'object' && typeof JSON !== 'undefined') {
                    try {
                        arg = JSON.stringify(arg);
                    } catch (Exception) {
                        // Recursive Object
                    }
                }
                message += "\n" + arg + "\n";
            }

            // Textarea
            if (textarea) {
                textarea.value += message + "\n-----\n";
                textarea.scrollTop = textarea.scrollHeight - textarea.clientHeight;
            }
            // No Textarea, No Console
            else if (!consoleExists) {
                    alert(message);
                }

            // Return true
            return true;
        };

        // ====================================================================
        // Emulated Status

        /**
         * History.getInternetExplorerMajorVersion()
         * Get's the major version of Internet Explorer
         * @return {integer}
         * @license Public Domain
         * @author Benjamin Arthur Lupton <contact@balupton.com>
         * @author James Padolsey <https://gist.github.com/527683>
         */
        History.getInternetExplorerMajorVersion = function () {
            var result = History.getInternetExplorerMajorVersion.cached = typeof History.getInternetExplorerMajorVersion.cached !== 'undefined' ? History.getInternetExplorerMajorVersion.cached : function () {
                var v = 3,
                    div = document.createElement('div'),
                    all = div.getElementsByTagName('i');
                while ((div.innerHTML = '<!--[if gt IE ' + ++v + ']><i></i><![endif]-->') && all[0]) {}
                return v > 4 ? v : false;
            }();
            return result;
        };

        /**
         * History.isInternetExplorer()
         * Are we using Internet Explorer?
         * @return {boolean}
         * @license Public Domain
         * @author Benjamin Arthur Lupton <contact@balupton.com>
         */
        History.isInternetExplorer = function () {
            var result = History.isInternetExplorer.cached = typeof History.isInternetExplorer.cached !== 'undefined' ? History.isInternetExplorer.cached : Boolean(History.getInternetExplorerMajorVersion());
            return result;
        };

        /**
         * History.emulated
         * Which features require emulating?
         */

        if (History.options.html4Mode) {
            History.emulated = {
                pushState: true,
                hashChange: true
            };
        } else {

            History.emulated = {
                pushState: !Boolean(window.history && window.history.pushState && window.history.replaceState && !(/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(navigator.userAgent) /* disable for versions of iOS before version 4.3 (8F190) */
                || /AppleWebKit\/5([0-2]|3[0-2])/i.test(navigator.userAgent) /* disable for the mercury iOS browser, or at least older versions of the webkit engine */
                )),
                hashChange: Boolean(!('onhashchange' in window || 'onhashchange' in document) || History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8)
            };
        }

        /**
         * History.enabled
         * Is History enabled?
         */
        History.enabled = !History.emulated.pushState;

        /**
         * History.bugs
         * Which bugs are present
         */
        History.bugs = {
            /**
             * Safari 5 and Safari iOS 4 fail to return to the correct state once a hash is replaced by a `replaceState` call
             * https://bugs.webkit.org/show_bug.cgi?id=56249
             */
            setHash: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

            /**
             * Safari 5 and Safari iOS 4 sometimes fail to apply the state change under busy conditions
             * https://bugs.webkit.org/show_bug.cgi?id=42940
             */
            safariPoll: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

            /**
             * MSIE 6 and 7 sometimes do not apply a hash even it was told to (requiring a second call to the apply function)
             */
            ieDoubleCheck: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8),

            /**
             * MSIE 6 requires the entire hash to be encoded for the hashes to trigger the onHashChange event
             */
            hashEscape: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 7)
        };

        /**
         * History.isEmptyObject(obj)
         * Checks to see if the Object is Empty
         * @param {Object} obj
         * @return {boolean}
         */
        History.isEmptyObject = function (obj) {
            for (var name in obj) {
                if (obj.hasOwnProperty(name)) {
                    return false;
                }
            }
            return true;
        };

        /**
         * History.cloneObject(obj)
         * Clones a object and eliminate all references to the original contexts
         * @param {Object} obj
         * @return {Object}
         */
        History.cloneObject = function (obj) {
            var hash, newObj;
            if (obj) {
                hash = JSON.stringify(obj);
                newObj = JSON.parse(hash);
            } else {
                newObj = {};
            }
            return newObj;
        };

        // ====================================================================
        // URL Helpers

        /**
         * History.getRootUrl()
         * Turns "http://mysite.com/dir/page.html?asd" into "http://mysite.com"
         * @return {String} rootUrl
         */
        History.getRootUrl = function () {
            // Create
            var rootUrl = document.location.protocol + '//' + (document.location.hostname || document.location.host);
            if (document.location.port || false) {
                rootUrl += ':' + document.location.port;
            }
            rootUrl += '/';

            // Return
            return rootUrl;
        };

        /**
         * History.getBaseHref()
         * Fetches the `href` attribute of the `<base href="...">` element if it exists
         * @return {String} baseHref
         */
        History.getBaseHref = function () {
            // Create
            var baseElements = document.getElementsByTagName('base'),
                baseElement = null,
                baseHref = '';

            // Test for Base Element
            if (baseElements.length === 1) {
                // Prepare for Base Element
                baseElement = baseElements[0];
                baseHref = baseElement.href.replace(/[^\/]+$/, '');
            }

            // Adjust trailing slash
            baseHref = baseHref.replace(/\/+$/, '');
            if (baseHref) baseHref += '/';

            // Return
            return baseHref;
        };

        /**
         * History.getBaseUrl()
         * Fetches the baseHref or basePageUrl or rootUrl (whichever one exists first)
         * @return {String} baseUrl
         */
        History.getBaseUrl = function () {
            // Create
            var baseUrl = History.getBaseHref() || History.getBasePageUrl() || History.getRootUrl();

            // Return
            return baseUrl;
        };

        /**
         * History.getPageUrl()
         * Fetches the URL of the current page
         * @return {String} pageUrl
         */
        History.getPageUrl = function () {
            // Fetch
            var State = History.getState(false, false),
                stateUrl = (State || {}).url || History.getLocationHref(),
                pageUrl;

            // Create
            pageUrl = stateUrl.replace(/\/+$/, '').replace(/[^\/]+$/, function (part, index, string) {
                return (/\./.test(part) ? part : part + '/'
                );
            });

            // Return
            return pageUrl;
        };

        /**
         * History.getBasePageUrl()
         * Fetches the Url of the directory of the current page
         * @return {String} basePageUrl
         */
        History.getBasePageUrl = function () {
            // Create
            var basePageUrl = History.getLocationHref().replace(/[#\?].*/, '').replace(/[^\/]+$/, function (part, index, string) {
                return (/[^\/]$/.test(part) ? '' : part
                );
            }).replace(/\/+$/, '') + '/';

            // Return
            return basePageUrl;
        };

        /**
         * History.getFullUrl(url)
         * Ensures that we have an absolute URL and not a relative URL
         * @param {string} url
         * @param {Boolean} allowBaseHref
         * @return {string} fullUrl
         */
        History.getFullUrl = function (url, allowBaseHref) {
            // Prepare
            var fullUrl = url,
                firstChar = url.substring(0, 1);
            allowBaseHref = typeof allowBaseHref === 'undefined' ? true : allowBaseHref;

            // Check
            if (/[a-z]+\:\/\//.test(url)) {
                // Full URL
            } else if (firstChar === '/') {
                // Root URL
                fullUrl = History.getRootUrl() + url.replace(/^\/+/, '');
            } else if (firstChar === '#') {
                // Anchor URL
                fullUrl = History.getPageUrl().replace(/#.*/, '') + url;
            } else if (firstChar === '?') {
                // Query URL
                fullUrl = History.getPageUrl().replace(/[\?#].*/, '') + url;
            } else {
                // Relative URL
                if (allowBaseHref) {
                    fullUrl = History.getBaseUrl() + url.replace(/^(\.\/)+/, '');
                } else {
                    fullUrl = History.getBasePageUrl() + url.replace(/^(\.\/)+/, '');
                }
                // We have an if condition above as we do not want hashes
                // which are relative to the baseHref in our URLs
                // as if the baseHref changes, then all our bookmarks
                // would now point to different locations
                // whereas the basePageUrl will always stay the same
            }

            // Return
            return fullUrl.replace(/\#$/, '');
        };

        /**
         * History.getShortUrl(url)
         * Ensures that we have a relative URL and not a absolute URL
         * @param {string} url
         * @return {string} url
         */
        History.getShortUrl = function (url) {
            // Prepare
            var shortUrl = url,
                baseUrl = History.getBaseUrl(),
                rootUrl = History.getRootUrl();

            // Trim baseUrl
            if (History.emulated.pushState) {
                // We are in a if statement as when pushState is not emulated
                // The actual url these short urls are relative to can change
                // So within the same session, we the url may end up somewhere different
                shortUrl = shortUrl.replace(baseUrl, '');
            }

            // Trim rootUrl
            shortUrl = shortUrl.replace(rootUrl, '/');

            // Ensure we can still detect it as a state
            if (History.isTraditionalAnchor(shortUrl)) {
                shortUrl = './' + shortUrl;
            }

            // Clean It
            shortUrl = shortUrl.replace(/^(\.\/)+/g, './').replace(/\#$/, '');

            // Return
            return shortUrl;
        };

        /**
         * History.getLocationHref(document)
         * Returns a normalized version of document.location.href
         * accounting for browser inconsistencies, etc.
         *
         * This URL will be URI-encoded and will include the hash
         *
         * @param {object} document
         * @return {string} url
         */
        History.getLocationHref = function (doc) {
            doc = doc || document;

            // most of the time, this will be true
            if (doc.URL === doc.location.href) return doc.location.href;

            // some versions of webkit URI-decode document.location.href
            // but they leave document.URL in an encoded state
            if (doc.location.href === decodeURIComponent(doc.URL)) return doc.URL;

            // FF 3.6 only updates document.URL when a page is reloaded
            // document.location.href is updated correctly
            if (doc.location.hash && decodeURIComponent(doc.location.href.replace(/^[^#]+/, "")) === doc.location.hash) return doc.location.href;

            if (doc.URL.indexOf('#') == -1 && doc.location.href.indexOf('#') != -1) return doc.location.href;

            return doc.URL || doc.location.href;
        };

        // ====================================================================
        // State Storage

        /**
         * History.store
         * The store for all session specific data
         */
        History.store = {};

        /**
         * History.idToState
         * 1-1: State ID to State Object
         */
        History.idToState = History.idToState || {};

        /**
         * History.stateToId
         * 1-1: State String to State ID
         */
        History.stateToId = History.stateToId || {};

        /**
         * History.urlToId
         * 1-1: State URL to State ID
         */
        History.urlToId = History.urlToId || {};

        /**
         * History.storedStates
         * Store the states in an array
         */
        History.storedStates = History.storedStates || [];

        /**
         * History.savedStates
         * Saved the states in an array
         */
        History.savedStates = History.savedStates || [];

        /**
         * History.noramlizeStore()
         * Noramlize the store by adding necessary values
         */
        History.normalizeStore = function () {
            History.store.idToState = History.store.idToState || {};
            History.store.urlToId = History.store.urlToId || {};
            History.store.stateToId = History.store.stateToId || {};
        };

        /**
         * History.getState()
         * Get an object containing the data, title and url of the current state
         * @param {Boolean} friendly
         * @param {Boolean} create
         * @return {Object} State
         */
        History.getState = function (friendly, create) {
            // Prepare
            if (typeof friendly === 'undefined') {
                friendly = true;
            }
            if (typeof create === 'undefined') {
                create = true;
            }

            // Fetch
            var State = History.getLastSavedState();

            // Create
            if (!State && create) {
                State = History.createStateObject();
            }

            // Adjust
            if (friendly) {
                State = History.cloneObject(State);
                State.url = State.cleanUrl || State.url;
            }

            // Return
            return State;
        };

        /**
         * History.getIdByState(State)
         * Gets a ID for a State
         * @param {State} newState
         * @return {String} id
         */
        History.getIdByState = function (newState) {

            // Fetch ID
            var id = History.extractId(newState.url),
                str;

            if (!id) {
                // Find ID via State String
                str = History.getStateString(newState);
                if (typeof History.stateToId[str] !== 'undefined') {
                    id = History.stateToId[str];
                } else if (typeof History.store.stateToId[str] !== 'undefined') {
                    id = History.store.stateToId[str];
                } else {
                    // Generate a new ID
                    while (true) {
                        id = new Date().getTime() + String(Math.random()).replace(/\D/g, '');
                        if (typeof History.idToState[id] === 'undefined' && typeof History.store.idToState[id] === 'undefined') {
                            break;
                        }
                    }

                    // Apply the new State to the ID
                    History.stateToId[str] = id;
                    History.idToState[id] = newState;
                }
            }

            // Return ID
            return id;
        };

        /**
         * History.normalizeState(State)
         * Expands a State Object
         * @param {object} State
         * @return {object}
         */
        History.normalizeState = function (oldState) {
            // Variables
            var newState, dataNotEmpty;

            // Prepare
            if (!oldState || (typeof oldState === "undefined" ? "undefined" : _typeof(oldState)) !== 'object') {
                oldState = {};
            }

            // Check
            if (typeof oldState.normalized !== 'undefined') {
                return oldState;
            }

            // Adjust
            if (!oldState.data || _typeof(oldState.data) !== 'object') {
                oldState.data = {};
            }

            // ----------------------------------------------------------------

            // Create
            newState = {};
            newState.normalized = true;
            newState.title = oldState.title || '';
            newState.url = History.getFullUrl(oldState.url ? oldState.url : History.getLocationHref());
            newState.hash = History.getShortUrl(newState.url);
            newState.data = History.cloneObject(oldState.data);

            // Fetch ID
            newState.id = History.getIdByState(newState);

            // ----------------------------------------------------------------

            // Clean the URL
            newState.cleanUrl = newState.url.replace(/\??\&_suid.*/, '');
            newState.url = newState.cleanUrl;

            // Check to see if we have more than just a url
            dataNotEmpty = !History.isEmptyObject(newState.data);

            // Apply
            if ((newState.title || dataNotEmpty) && History.options.disableSuid !== true) {
                // Add ID to Hash
                newState.hash = History.getShortUrl(newState.url).replace(/\??\&_suid.*/, '');
                if (!/\?/.test(newState.hash)) {
                    newState.hash += '?';
                }
                newState.hash += '&_suid=' + newState.id;
            }

            // Create the Hashed URL
            newState.hashedUrl = History.getFullUrl(newState.hash);

            // ----------------------------------------------------------------

            // Update the URL if we have a duplicate
            if ((History.emulated.pushState || History.bugs.safariPoll) && History.hasUrlDuplicate(newState)) {
                newState.url = newState.hashedUrl;
            }

            // ----------------------------------------------------------------

            // Return
            return newState;
        };

        /**
         * History.createStateObject(data,title,url)
         * Creates a object based on the data, title and url state params
         * @param {object} data
         * @param {string} title
         * @param {string} url
         * @return {object}
         */
        History.createStateObject = function (data, title, url) {
            // Hashify
            var State = {
                'data': data,
                'title': title,
                'url': url
            };

            // Expand the State
            State = History.normalizeState(State);

            // Return object
            return State;
        };

        /**
         * History.getStateById(id)
         * Get a state by it's UID
         * @param {String} id
         */
        History.getStateById = function (id) {
            // Prepare
            id = String(id);

            // Retrieve
            var State = History.idToState[id] || History.store.idToState[id] || undefined;

            // Return State
            return State;
        };

        /**
         * Get a State's String
         * @param {State} passedState
         */
        History.getStateString = function (passedState) {
            // Prepare
            var State, cleanedState, str;

            // Fetch
            State = History.normalizeState(passedState);

            // Clean
            cleanedState = {
                data: State.data,
                title: passedState.title,
                url: passedState.url
            };

            // Fetch
            str = JSON.stringify(cleanedState);

            // Return
            return str;
        };

        /**
         * Get a State's ID
         * @param {State} passedState
         * @return {String} id
         */
        History.getStateId = function (passedState) {
            // Prepare
            var State, id;

            // Fetch
            State = History.normalizeState(passedState);

            // Fetch
            id = State.id;

            // Return
            return id;
        };

        /**
         * History.getHashByState(State)
         * Creates a Hash for the State Object
         * @param {State} passedState
         * @return {String} hash
         */
        History.getHashByState = function (passedState) {
            // Prepare
            var State, hash;

            // Fetch
            State = History.normalizeState(passedState);

            // Hash
            hash = State.hash;

            // Return
            return hash;
        };

        /**
         * History.extractId(url_or_hash)
         * Get a State ID by it's URL or Hash
         * @param {string} url_or_hash
         * @return {string} id
         */
        History.extractId = function (url_or_hash) {
            // Prepare
            var id, parts, url, tmp;

            // Extract

            // If the URL has a #, use the id from before the #
            if (url_or_hash.indexOf('#') != -1) {
                tmp = url_or_hash.split("#")[0];
            } else {
                tmp = url_or_hash;
            }

            parts = /(.*)\&_suid=([0-9]+)$/.exec(tmp);
            url = parts ? parts[1] || url_or_hash : url_or_hash;
            id = parts ? String(parts[2] || '') : '';

            // Return
            return id || false;
        };

        /**
         * History.isTraditionalAnchor
         * Checks to see if the url is a traditional anchor or not
         * @param {String} url_or_hash
         * @return {Boolean}
         */
        History.isTraditionalAnchor = function (url_or_hash) {
            // Check
            var isTraditional = !/[\/\?\.]/.test(url_or_hash);

            // Return
            return isTraditional;
        };

        /**
         * History.extractState
         * Get a State by it's URL or Hash
         * @param {String} url_or_hash
         * @return {State|null}
         */
        History.extractState = function (url_or_hash, create) {
            // Prepare
            var State = null,
                id,
                url;
            create = create || false;

            // Fetch SUID
            id = History.extractId(url_or_hash);
            if (id) {
                State = History.getStateById(id);
            }

            // Fetch SUID returned no State
            if (!State) {
                // Fetch URL
                url = History.getFullUrl(url_or_hash);

                // Check URL
                id = History.getIdByUrl(url) || false;
                if (id) {
                    State = History.getStateById(id);
                }

                // Create State
                if (!State && create && !History.isTraditionalAnchor(url_or_hash)) {
                    State = History.createStateObject(null, null, url);
                }
            }

            // Return
            return State;
        };

        /**
         * History.getIdByUrl()
         * Get a State ID by a State URL
         */
        History.getIdByUrl = function (url) {
            // Fetch
            var id = History.urlToId[url] || History.store.urlToId[url] || undefined;

            // Return
            return id;
        };

        /**
         * History.getLastSavedState()
         * Get an object containing the data, title and url of the current state
         * @return {Object} State
         */
        History.getLastSavedState = function () {
            return History.savedStates[History.savedStates.length - 1] || undefined;
        };

        /**
         * History.getLastStoredState()
         * Get an object containing the data, title and url of the current state
         * @return {Object} State
         */
        History.getLastStoredState = function () {
            return History.storedStates[History.storedStates.length - 1] || undefined;
        };

        /**
         * History.hasUrlDuplicate
         * Checks if a Url will have a url conflict
         * @param {Object} newState
         * @return {Boolean} hasDuplicate
         */
        History.hasUrlDuplicate = function (newState) {
            // Prepare
            var hasDuplicate = false,
                oldState;

            // Fetch
            oldState = History.extractState(newState.url);

            // Check
            hasDuplicate = oldState && oldState.id !== newState.id;

            // Return
            return hasDuplicate;
        };

        /**
         * History.storeState
         * Store a State
         * @param {Object} newState
         * @return {Object} newState
         */
        History.storeState = function (newState) {
            // Store the State
            History.urlToId[newState.url] = newState.id;

            // Push the State
            History.storedStates.push(History.cloneObject(newState));

            // Return newState
            return newState;
        };

        /**
         * History.isLastSavedState(newState)
         * Tests to see if the state is the last state
         * @param {Object} newState
         * @return {boolean} isLast
         */
        History.isLastSavedState = function (newState) {
            // Prepare
            var isLast = false,
                newId,
                oldState,
                oldId;

            // Check
            if (History.savedStates.length) {
                newId = newState.id;
                oldState = History.getLastSavedState();
                oldId = oldState.id;

                // Check
                isLast = newId === oldId;
            }

            // Return
            return isLast;
        };

        /**
         * History.saveState
         * Push a State
         * @param {Object} newState
         * @return {boolean} changed
         */
        History.saveState = function (newState) {
            // Check Hash
            if (History.isLastSavedState(newState)) {
                return false;
            }

            // Push the State
            History.savedStates.push(History.cloneObject(newState));

            // Return true
            return true;
        };

        /**
         * History.getStateByIndex()
         * Gets a state by the index
         * @param {integer} index
         * @return {Object}
         */
        History.getStateByIndex = function (index) {
            // Prepare
            var State = null;

            // Handle
            if (typeof index === 'undefined') {
                // Get the last inserted
                State = History.savedStates[History.savedStates.length - 1];
            } else if (index < 0) {
                // Get from the end
                State = History.savedStates[History.savedStates.length + index];
            } else {
                // Get from the beginning
                State = History.savedStates[index];
            }

            // Return State
            return State;
        };

        /**
         * History.getCurrentIndex()
         * Gets the current index
         * @return (integer)
         */
        History.getCurrentIndex = function () {
            // Prepare
            var index = null;

            // No states saved
            if (History.savedStates.length < 1) {
                index = 0;
            } else {
                index = History.savedStates.length - 1;
            }
            return index;
        };

        // ====================================================================
        // Hash Helpers

        /**
         * History.getHash()
         * @param {Location=} location
         * Gets the current document hash
         * Note: unlike location.hash, this is guaranteed to return the escaped hash in all browsers
         * @return {string}
         */
        History.getHash = function (doc) {
            var url = History.getLocationHref(doc),
                hash;
            hash = History.getHashByUrl(url);
            return hash;
        };

        /**
         * History.unescapeHash()
         * normalize and Unescape a Hash
         * @param {String} hash
         * @return {string}
         */
        History.unescapeHash = function (hash) {
            // Prepare
            var result = History.normalizeHash(hash);

            // Unescape hash
            result = decodeURIComponent(result);

            // Return result
            return result;
        };

        /**
         * History.normalizeHash()
         * normalize a hash across browsers
         * @return {string}
         */
        History.normalizeHash = function (hash) {
            // Prepare
            var result = hash.replace(/[^#]*#/, '').replace(/#.*/, '');

            // Return result
            return result;
        };

        /**
         * History.setHash(hash)
         * Sets the document hash
         * @param {string} hash
         * @return {History}
         */
        History.setHash = function (hash, queue) {
            // Prepare
            var State, pageUrl;

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.setHash: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.setHash,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Log
            //History.debug('History.setHash: called',hash);

            // Make Busy + Continue
            History.busy(true);

            // Check if hash is a state
            State = History.extractState(hash, true);
            if (State && !History.emulated.pushState) {
                // Hash is a state so skip the setHash
                //History.debug('History.setHash: Hash is a state so skipping the hash set with a direct pushState call',arguments);

                // PushState
                History.pushState(State.data, State.title, State.url, false);
            } else if (History.getHash() !== hash) {
                // Hash is a proper hash, so apply it

                // Handle browser bugs
                if (History.bugs.setHash) {
                    // Fix Safari Bug https://bugs.webkit.org/show_bug.cgi?id=56249

                    // Fetch the base page
                    pageUrl = History.getPageUrl();

                    // Safari hash apply
                    History.pushState(null, null, pageUrl + '#' + hash, false);
                } else {
                    // Normal hash apply
                    document.location.hash = hash;
                }
            }

            // Chain
            return History;
        };

        /**
         * History.escape()
         * normalize and Escape a Hash
         * @return {string}
         */
        History.escapeHash = function (hash) {
            // Prepare
            var result = History.normalizeHash(hash);

            // Escape hash
            result = window.encodeURIComponent(result);

            // IE6 Escape Bug
            if (!History.bugs.hashEscape) {
                // Restore common parts
                result = result.replace(/\%21/g, '!').replace(/\%26/g, '&').replace(/\%3D/g, '=').replace(/\%3F/g, '?');
            }

            // Return result
            return result;
        };

        /**
         * History.getHashByUrl(url)
         * Extracts the Hash from a URL
         * @param {string} url
         * @return {string} url
         */
        History.getHashByUrl = function (url) {
            // Extract the hash
            var hash = String(url).replace(/([^#]*)#?([^#]*)#?(.*)/, '$2');

            // Unescape hash
            hash = History.unescapeHash(hash);

            // Return hash
            return hash;
        };

        /**
         * History.setTitle(title)
         * Applies the title to the document
         * @param {State} newState
         * @return {Boolean}
         */
        History.setTitle = function (newState) {
            // Prepare
            var title = newState.title,
                firstState;

            // Initial
            if (!title) {
                firstState = History.getStateByIndex(0);
                if (firstState && firstState.url === newState.url) {
                    title = firstState.title || History.options.initialTitle;
                }
            }

            // Apply
            try {
                document.getElementsByTagName('title')[0].innerHTML = title.replace('<', '&lt;').replace('>', '&gt;').replace(' & ', ' &amp; ');
            } catch (Exception) {}
            document.title = title;

            // Chain
            return History;
        };

        // ====================================================================
        // Queueing

        /**
         * History.queues
         * The list of queues to use
         * First In, First Out
         */
        History.queues = [];

        /**
         * History.busy(value)
         * @param {boolean} value [optional]
         * @return {boolean} busy
         */
        History.busy = function (value) {
            // Apply
            if (typeof value !== 'undefined') {
                //History.debug('History.busy: changing ['+(History.busy.flag||false)+'] to ['+(value||false)+']', History.queues.length);
                History.busy.flag = value;
            }
            // Default
            else if (typeof History.busy.flag === 'undefined') {
                    History.busy.flag = false;
                }

            // Queue
            if (!History.busy.flag) {
                // Execute the next item in the queue
                clearTimeout(History.busy.timeout);
                var fireNext = function fireNext() {
                    var i, queue, item;
                    if (History.busy.flag) return;
                    for (i = History.queues.length - 1; i >= 0; --i) {
                        queue = History.queues[i];
                        if (queue.length === 0) continue;
                        item = queue.shift();
                        History.fireQueueItem(item);
                        History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
                    }
                };
                History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
            }

            // Return
            return History.busy.flag;
        };

        /**
         * History.busy.flag
         */
        History.busy.flag = false;

        /**
         * History.fireQueueItem(item)
         * Fire a Queue Item
         * @param {Object} item
         * @return {Mixed} result
         */
        History.fireQueueItem = function (item) {
            return item.callback.apply(item.scope || History, item.args || []);
        };

        /**
         * History.pushQueue(callback,args)
         * Add an item to the queue
         * @param {Object} item [scope,callback,args,queue]
         */
        History.pushQueue = function (item) {
            // Prepare the queue
            History.queues[item.queue || 0] = History.queues[item.queue || 0] || [];

            // Add to the queue
            History.queues[item.queue || 0].push(item);

            // Chain
            return History;
        };

        /**
         * History.queue (item,queue), (func,queue), (func), (item)
         * Either firs the item now if not busy, or adds it to the queue
         */
        History.queue = function (item, queue) {
            // Prepare
            if (typeof item === 'function') {
                item = {
                    callback: item
                };
            }
            if (typeof queue !== 'undefined') {
                item.queue = queue;
            }

            // Handle
            if (History.busy()) {
                History.pushQueue(item);
            } else {
                History.fireQueueItem(item);
            }

            // Chain
            return History;
        };

        /**
         * History.clearQueue()
         * Clears the Queue
         */
        History.clearQueue = function () {
            History.busy.flag = false;
            History.queues = [];
            return History;
        };

        // ====================================================================
        // IE Bug Fix

        /**
         * History.stateChanged
         * States whether or not the state has changed since the last double check was initialised
         */
        History.stateChanged = false;

        /**
         * History.doubleChecker
         * Contains the timeout used for the double checks
         */
        History.doubleChecker = false;

        /**
         * History.doubleCheckComplete()
         * Complete a double check
         * @return {History}
         */
        History.doubleCheckComplete = function () {
            // Update
            History.stateChanged = true;

            // Clear
            History.doubleCheckClear();

            // Chain
            return History;
        };

        /**
         * History.doubleCheckClear()
         * Clear a double check
         * @return {History}
         */
        History.doubleCheckClear = function () {
            // Clear
            if (History.doubleChecker) {
                clearTimeout(History.doubleChecker);
                History.doubleChecker = false;
            }

            // Chain
            return History;
        };

        /**
         * History.doubleCheck()
         * Create a double check
         * @return {History}
         */
        History.doubleCheck = function (tryAgain) {
            // Reset
            History.stateChanged = false;
            History.doubleCheckClear();

            // Fix IE6,IE7 bug where calling history.back or history.forward does not actually change the hash (whereas doing it manually does)
            // Fix Safari 5 bug where sometimes the state does not change: https://bugs.webkit.org/show_bug.cgi?id=42940
            if (History.bugs.ieDoubleCheck) {
                // Apply Check
                History.doubleChecker = setTimeout(function () {
                    History.doubleCheckClear();
                    if (!History.stateChanged) {
                        //History.debug('History.doubleCheck: State has not yet changed, trying again', arguments);
                        // Re-Attempt
                        tryAgain();
                    }
                    return true;
                }, History.options.doubleCheckInterval);
            }

            // Chain
            return History;
        };

        // ====================================================================
        // Safari Bug Fix

        /**
         * History.safariStatePoll()
         * Poll the current state
         * @return {History}
         */
        History.safariStatePoll = function () {
            // Poll the URL

            // Get the Last State which has the new URL
            var urlState = History.extractState(History.getLocationHref()),
                newState;

            // Check for a difference
            if (!History.isLastSavedState(urlState)) {
                newState = urlState;
            } else {
                return;
            }

            // Check if we have a state with that url
            // If not create it
            if (!newState) {
                //History.debug('History.safariStatePoll: new');
                newState = History.createStateObject();
            }

            // Apply the New State
            //History.debug('History.safariStatePoll: trigger');
            History.Adapter.trigger(window, 'popstate');

            // Chain
            return History;
        };

        // ====================================================================
        // State Aliases

        /**
         * History.back(queue)
         * Send the browser history back one item
         * @param {Integer} queue [optional]
         */
        History.back = function (queue) {
            //History.debug('History.back: called', arguments);

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.back: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.back,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Make Busy + Continue
            History.busy(true);

            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function () {
                History.back(false);
            });

            // Go back
            history.go(-1);

            // End back closure
            return true;
        };

        /**
         * History.forward(queue)
         * Send the browser history forward one item
         * @param {Integer} queue [optional]
         */
        History.forward = function (queue) {
            //History.debug('History.forward: called', arguments);

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.forward: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.forward,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Make Busy + Continue
            History.busy(true);

            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function () {
                History.forward(false);
            });

            // Go forward
            history.go(1);

            // End forward closure
            return true;
        };

        /**
         * History.go(index,queue)
         * Send the browser history back or forward index times
         * @param {Integer} queue [optional]
         */
        History.go = function (index, queue) {
            //History.debug('History.go: called', arguments);

            // Prepare
            var i;

            // Handle
            if (index > 0) {
                // Forward
                for (i = 1; i <= index; ++i) {
                    History.forward(queue);
                }
            } else if (index < 0) {
                // Backward
                for (i = -1; i >= index; --i) {
                    History.back(queue);
                }
            } else {
                throw new Error('History.go: History.go requires a positive or negative integer passed.');
            }

            // Chain
            return History;
        };

        // ====================================================================
        // HTML5 State Support

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /*
             * Provide Skeleton for HTML4 Browsers
             */

            // Prepare
            var emptyFunction = function emptyFunction() {};
            History.pushState = History.pushState || emptyFunction;
            History.replaceState = History.replaceState || emptyFunction;
        } // History.emulated.pushState

        // Native pushState Implementation
        else {
                /*
                 * Use native HTML5 History API Implementation
                 */

                /**
                 * History.onPopState(event,extra)
                 * Refresh the Current State
                 */
                History.onPopState = function (event, extra) {
                    // Prepare
                    var stateId = false,
                        newState = false,
                        currentHash,
                        currentState;

                    // Reset the double check
                    History.doubleCheckComplete();

                    // Check for a Hash, and handle apporiatly
                    currentHash = History.getHash();
                    if (currentHash) {
                        // Expand Hash
                        currentState = History.extractState(currentHash || History.getLocationHref(), true);
                        if (currentState) {
                            // We were able to parse it, it must be a State!
                            // Let's forward to replaceState
                            //History.debug('History.onPopState: state anchor', currentHash, currentState);
                            History.replaceState(currentState.data, currentState.title, currentState.url, false);
                        } else {
                            // Traditional Anchor
                            //History.debug('History.onPopState: traditional anchor', currentHash);
                            History.Adapter.trigger(window, 'anchorchange');
                            History.busy(false);
                        }

                        // We don't care for hashes
                        History.expectedStateId = false;
                        return false;
                    }

                    // Ensure
                    stateId = History.Adapter.extractEventData('state', event, extra) || false;

                    // Fetch State
                    if (stateId) {
                        // Vanilla: Back/forward button was used
                        newState = History.getStateById(stateId);
                    } else if (History.expectedStateId) {
                        // Vanilla: A new state was pushed, and popstate was called manually
                        newState = History.getStateById(History.expectedStateId);
                    } else {
                        // Initial State
                        newState = History.extractState(History.getLocationHref());
                    }

                    // The State did not exist in our store
                    if (!newState) {
                        // Regenerate the State
                        newState = History.createStateObject(null, null, History.getLocationHref());
                    }

                    // Clean
                    History.expectedStateId = false;

                    // Check if we are the same state
                    if (History.isLastSavedState(newState)) {
                        // There has been no change (just the page's hash has finally propagated)
                        //History.debug('History.onPopState: no change', newState, History.savedStates);
                        History.busy(false);
                        return false;
                    }

                    // Store the State
                    History.storeState(newState);
                    History.saveState(newState);

                    // Force update of the title
                    History.setTitle(newState);

                    // Fire Our Event
                    History.Adapter.trigger(window, 'statechange');
                    History.busy(false);

                    // Return true
                    return true;
                };
                History.Adapter.bind(window, 'popstate', History.onPopState);

                /**
                 * History.pushState(data,title,url)
                 * Add a new State to the history object, become it, and trigger onpopstate
                 * We have to trigger for HTML4 compatibility
                 * @param {object} data
                 * @param {string} title
                 * @param {string} url
                 * @return {true}
                 */
                History.pushState = function (data, title, url, queue) {
                    //History.debug('History.pushState: called', arguments);

                    // Check the State
                    if (History.getHashByUrl(url) && History.emulated.pushState) {
                        throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
                    }

                    // Handle Queueing
                    if (queue !== false && History.busy()) {
                        // Wait + Push to Queue
                        //History.debug('History.pushState: we must wait', arguments);
                        History.pushQueue({
                            scope: History,
                            callback: History.pushState,
                            args: arguments,
                            queue: queue
                        });
                        return false;
                    }

                    // Make Busy + Continue
                    History.busy(true);

                    // Create the newState
                    var newState = History.createStateObject(data, title, url);

                    // Check it
                    if (History.isLastSavedState(newState)) {
                        // Won't be a change
                        History.busy(false);
                    } else {
                        // Store the newState
                        History.storeState(newState);
                        History.expectedStateId = newState.id;

                        // Push the newState
                        history.pushState(newState.id, newState.title, newState.url);

                        // Fire HTML5 Event
                        History.Adapter.trigger(window, 'popstate');
                    }

                    // End pushState closure
                    return true;
                };

                /**
                 * History.replaceState(data,title,url)
                 * Replace the State and trigger onpopstate
                 * We have to trigger for HTML4 compatibility
                 * @param {object} data
                 * @param {string} title
                 * @param {string} url
                 * @return {true}
                 */
                History.replaceState = function (data, title, url, queue) {
                    //History.debug('History.replaceState: called', arguments);

                    // Check the State
                    if (History.getHashByUrl(url) && History.emulated.pushState) {
                        throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
                    }

                    // Handle Queueing
                    if (queue !== false && History.busy()) {
                        // Wait + Push to Queue
                        //History.debug('History.replaceState: we must wait', arguments);
                        History.pushQueue({
                            scope: History,
                            callback: History.replaceState,
                            args: arguments,
                            queue: queue
                        });
                        return false;
                    }

                    // Make Busy + Continue
                    History.busy(true);

                    // Create the newState
                    var newState = History.createStateObject(data, title, url);

                    // Check it
                    if (History.isLastSavedState(newState)) {
                        // Won't be a change
                        History.busy(false);
                    } else {
                        // Store the newState
                        History.storeState(newState);
                        History.expectedStateId = newState.id;

                        // Push the newState
                        history.replaceState(newState.id, newState.title, newState.url);

                        // Fire HTML5 Event
                        History.Adapter.trigger(window, 'popstate');
                    }

                    // End replaceState closure
                    return true;
                };
            } // !History.emulated.pushState


        // ====================================================================
        // Initialise

        /**
         * Load the Store
         */
        if (sessionStorage) {
            // Fetch
            try {
                History.store = JSON.parse(sessionStorage.getItem('History.store')) || {};
            } catch (err) {
                History.store = {};
            }

            // Normalize
            History.normalizeStore();
        } else {
            // Default Load
            History.store = {};
            History.normalizeStore();
        }

        /**
         * Clear Intervals on exit to prevent memory leaks
         */
        History.Adapter.bind(window, "unload", History.clearAllIntervals);

        /**
         * Create the initial State
         */
        History.saveState(History.storeState(History.extractState(History.getLocationHref(), true)));

        /**
         * Bind for Saving Store
         */
        if (sessionStorage) {
            // When the page is closed
            History.onUnload = function () {
                // Prepare
                var currentStore, item, currentStoreString;

                // Fetch
                try {
                    currentStore = JSON.parse(sessionStorage.getItem('History.store')) || {};
                } catch (err) {
                    currentStore = {};
                }

                // Ensure
                currentStore.idToState = currentStore.idToState || {};
                currentStore.urlToId = currentStore.urlToId || {};
                currentStore.stateToId = currentStore.stateToId || {};

                // Sync
                for (item in History.idToState) {
                    if (!History.idToState.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.idToState[item] = History.idToState[item];
                }
                for (item in History.urlToId) {
                    if (!History.urlToId.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.urlToId[item] = History.urlToId[item];
                }
                for (item in History.stateToId) {
                    if (!History.stateToId.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.stateToId[item] = History.stateToId[item];
                }

                // Update
                History.store = currentStore;
                History.normalizeStore();

                // In Safari, going into Private Browsing mode causes the
                // Session Storage object to still exist but if you try and use
                // or set any property/function of it it throws the exception
                // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to
                // add something to storage that exceeded the quota." infinitely
                // every second.
                currentStoreString = JSON.stringify(currentStore);
                try {
                    // Store
                    sessionStorage.setItem('History.store', currentStoreString);
                } catch (e) {
                    if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
                        if (sessionStorage.length) {
                            // Workaround for a bug seen on iPads. Sometimes the quota exceeded error comes up and simply
                            // removing/resetting the storage can work.
                            sessionStorage.removeItem('History.store');
                            sessionStorage.setItem('History.store', currentStoreString);
                        } else {
                            // Otherwise, we're probably private browsing in Safari, so we'll ignore the exception.
                        }
                    } else {
                        throw e;
                    }
                }
            };

            // For Internet Explorer
            History.intervalList.push(setInterval(History.onUnload, History.options.storeInterval));

            // For Other Browsers
            History.Adapter.bind(window, 'beforeunload', History.onUnload);
            History.Adapter.bind(window, 'unload', History.onUnload);

            // Both are enabled for consistency
        }

        // Non-Native pushState Implementation
        if (!History.emulated.pushState) {
            // Be aware, the following is only for native pushState implementations
            // If you are wanting to include something for all browsers
            // Then include it above this if block

            /**
             * Setup Safari Fix
             */
            if (History.bugs.safariPoll) {
                History.intervalList.push(setInterval(History.safariStatePoll, History.options.safariPollInterval));
            }

            /**
             * Ensure Cross Browser Compatibility
             */
            if (navigator.vendor === 'Apple Computer, Inc.' || (navigator.appCodeName || '') === 'Mozilla') {
                /**
                 * Fix Safari HashChange Issue
                 */

                // Setup Alias
                History.Adapter.bind(window, 'hashchange', function () {
                    History.Adapter.trigger(window, 'popstate');
                });

                // Initialise Alias
                if (History.getHash()) {
                    History.Adapter.onDomLoad(function () {
                        History.Adapter.trigger(window, 'hashchange');
                    });
                }
            }
        } // !History.emulated.pushState

    }; // History.initCore

    // Try to Initialise History
    if (!History.options || !History.options.delayInit) {
        History.init();
    }
})(window);

/* Patch PF request to support div loading*/
PrimeFaces.ajax.Request.collectEarlyPostParams = function (cfg) {
    var earlyPostParams;

    var sourceElement;
    if (typeof cfg.source === 'string') {
        sourceElement = $(PrimeFaces.escapeClientId(cfg.source));
    } else {
        sourceElement = $(cfg.source);
    }
    if (sourceElement.is(':input') && sourceElement.is(':not(:button)')) {
        earlyPostParams = [];
        earlyPostParams.push({
            name: sourceElement.attr('name'),
            value: sourceElement.is(':checkbox') ? sourceElement.is(':checked') : sourceElement.val()
        });
    } else {
        //Rasp patched: Do not collect elements inside .skip-submission
        var skipSubmissionFilter = function skipSubmissionFilter(i, e) {
            var skips = $(e).parentsUntil(sourceElement, '.skip-ajax-submission');
            return skips.size() === 0 || skips.size() === 1 && skips.get(0) === sourceElement;
        };
        earlyPostParams = sourceElement.find(':input')
        //Rasp patched: Do not collect elements inside .skip-submission
        .filter(skipSubmissionFilter).serializeArray();
        // jQuery doesn't add unchecked checkboxes
        earlyPostParams = earlyPostParams.concat(sourceElement.find('input[type=checkbox]:not(:checked)')
        //Rasp patched: Do not collect elements inside .skip-submission
        .filter(skipSubmissionFilter).map(function () {
            var $this = $(this);
            return { 'name': $this.attr('name'), 'value': $this.is(':checked') };
        }).get());
    }

    return earlyPostParams;
};

PrimeFaces.ajax.Request.send = function (cfg) {
    PrimeFaces.debug('Initiating ajax request.');

    PrimeFaces.customFocus = false;

    var global = cfg.global === true || cfg.global === undefined,
        form = null,
        sourceId = null,
        retVal = null;

    if (cfg.onstart) {
        retVal = cfg.onstart.call(this, cfg);
    }
    if (cfg.ext && cfg.ext.onstart) {
        retVal = cfg.ext.onstart.call(this, cfg);
    }

    if (retVal === false) {
        PrimeFaces.debug('Ajax request cancelled by onstart callback.');

        //remove from queue
        if (!cfg.async) {
            PrimeFaces.ajax.Queue.poll();
        }

        return false; //cancel request
    }

    $(document).trigger('raspAjaxStart', [cfg]);
    if (global) {
        $(document).trigger('pfAjaxStart');
    }

    //source can be a client id or an element defined by this keyword
    if (typeof cfg.source === 'string') {
        sourceId = cfg.source;
    } else {
        sourceId = $(cfg.source).attr('id');
    }

    if (cfg.formId) {
        //Explicit form is defined
        form = PrimeFaces.expressions.SearchExpressionFacade.resolveComponentsAsSelector(cfg.formId);
    } else {
        var $source = $(PrimeFaces.escapeClientId(sourceId));
        //look for a parent of source
        form = $source.closest('form');

        //source has no parent form so use first form in document
        if (form.length === 0) {
            form = $('form').eq(0);
        }
    }

    PrimeFaces.debug('Form to post ' + form.attr('id') + '.');

    var postURL = form.attr('action'),
        encodedURLfield = form.children("input[name*='javax.faces.encodedURL']"),
        postParams = [];

    // See #6857 - parameter namespace for porlet
    var parameterPrefix = PrimeFaces.ajax.Request.extractParameterNamespace(form);

    //portlet support
    var portletFormsSelector = null;
    if (encodedURLfield.length > 0) {
        portletFormsSelector = 'form[id*="' + parameterPrefix + '"]';
        postURL = encodedURLfield.val();
    }

    PrimeFaces.debug('URL to post ' + postURL + '.');

    //partial ajax
    PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_REQUEST_PARAM, true, parameterPrefix);

    //source
    PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_SOURCE_PARAM, sourceId, parameterPrefix);

    //resetValues
    if (cfg.resetValues) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.RESET_VALUES_PARAM, true, parameterPrefix);
    }

    //ignoreAutoUpdate
    if (cfg.ignoreAutoUpdate) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.IGNORE_AUTO_UPDATE_PARAM, true, parameterPrefix);
    }

    //skip children
    if (cfg.skipChildren === false) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.SKIP_CHILDREN_PARAM, false, parameterPrefix);
    }

    //process
    var processArray = PrimeFaces.ajax.Request.resolveComponentsForAjaxCall(cfg, 'process');
    if (cfg.fragmentId) {
        processArray.push(cfg.fragmentId);
    }
    // default == @none
    var processIds = '@none';
    // use defined process + resolved keywords (@widget, PFS)?
    if (processArray.length > 0) {
        processIds = processArray.join(' ');
    }
    // fallback to @all if no process was defined by the user
    else {
            var definedProcess = PrimeFaces.ajax.Request.resolveComponentsForAjaxCall(cfg, 'process');
            definedProcess = $.trim(definedProcess);
            if (definedProcess === '') {
                processIds = '@all';
            }
        }
    if (processIds !== '@none') {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_PROCESS_PARAM, processIds, parameterPrefix);
    }

    //update
    var updateArray = PrimeFaces.ajax.Request.resolveComponentsForAjaxCall(cfg, 'update');
    if (cfg.fragmentId && cfg.fragmentUpdate) {
        updateArray.push(cfg.fragmentId);
    }
    if (updateArray.length > 0) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_UPDATE_PARAM, updateArray.join(' '), parameterPrefix);
    }

    //behavior event
    if (cfg.event) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.BEHAVIOR_EVENT_PARAM, cfg.event, parameterPrefix);

        var domEvent = cfg.event;

        if (cfg.event === 'valueChange') domEvent = 'change';else if (cfg.event === 'action') domEvent = 'click';

        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_EVENT_PARAM, domEvent, parameterPrefix);
    } else {
        PrimeFaces.ajax.Request.addParam(postParams, sourceId, sourceId, parameterPrefix);
    }

    //params
    if (cfg.params) {
        PrimeFaces.ajax.Request.addParams(postParams, cfg.params, parameterPrefix);
    }
    if (cfg.ext && cfg.ext.params) {
        PrimeFaces.ajax.Request.addParams(postParams, cfg.ext.params, parameterPrefix);
    }

    /**
     * Only add params of process components and their children
     * if partial submit is enabled and there are components to process partially
     */
    if (cfg.partialSubmit && processIds.indexOf('@all') === -1) {
        var formProcessed = false,
            partialSubmitFilter = cfg.partialSubmitFilter || ':input';

        if (processIds.indexOf('@none') === -1) {
            for (var i = 0; i < processArray.length; i++) {
                var jqProcess = $(PrimeFaces.escapeClientId(processArray[i]));
                var componentPostParams = null;

                if (jqProcess.is('form')) {
                    componentPostParams = jqProcess.serializeArray();
                    formProcessed = true;
                } else if (jqProcess.is(':input')) {
                    componentPostParams = jqProcess.serializeArray();
                } else {
                    componentPostParams = jqProcess.find(partialSubmitFilter).serializeArray();

                    //Rasp patched: Do not collect elements inside .skip-submission
                    componentPostParams = jqProcess.find(partialSubmitFilter).filter(function (i, e) {
                        var skips = $(e).parentsUntil(jqProcess, '.skip-ajax-submission');
                        return skips.size() === 0 || skips.size() === 1 && skips.get(0) === jqProcess;
                    }).serializeArray();
                }

                $.merge(postParams, componentPostParams);
            }
        }

        //add form state if necessary
        if (!formProcessed) {
            PrimeFaces.ajax.Request.addParamFromInput(postParams, PrimeFaces.VIEW_STATE, form, parameterPrefix);
            PrimeFaces.ajax.Request.addParamFromInput(postParams, PrimeFaces.CLIENT_WINDOW, form, parameterPrefix);
            PrimeFaces.ajax.Request.addParamFromInput(postParams, 'dsPostWindowId', form, parameterPrefix);
            PrimeFaces.ajax.Request.addParamFromInput(postParams, 'dspwid', form, parameterPrefix);
        }
    } else {
        $.merge(postParams, form.serializeArray());
    }

    // remove postParam if already available in earlyPostParams
    if (PrimeFaces.settings.earlyPostParamEvaluation && cfg.earlyPostParams) {
        // loop early post params
        $.each(cfg.earlyPostParams, function (earlyPostParamIndex, earlyPostParam) {
            // loop post params and remove it, if it's the same param as the early post param
            postParams = $.grep(postParams, function (postParam, postParamIndex) {
                return postParam.name !== earlyPostParam.name;
            });
        });

        $.merge(postParams, cfg.earlyPostParams);
    }

    //serialize
    var postData = $.param(postParams);

    PrimeFaces.debug('Post Data:' + postData);

    var xhrOptions = {
        url: postURL,
        type: "POST",
        cache: false,
        dataType: "xml",
        data: postData,
        portletForms: portletFormsSelector,
        source: cfg.source,
        global: false,
        beforeSend: function beforeSend(xhr, settings) {
            xhr.setRequestHeader('Faces-Request', 'partial/ajax');
            xhr.pfSettings = settings;
            xhr.pfArgs = {}; // default should be an empty object
            PrimeFaces.nonAjaxPosted = false;

            $(document).trigger('raspAjaxSend', [xhr, this]);
            if (global) {
                $(document).trigger('pfAjaxSend', [xhr, this]);
            }
        },
        error: function error(xhr, status, errorThrown) {
            if (cfg.onerror) {
                cfg.onerror.call(this, xhr, status, errorThrown);
            }
            if (cfg.ext && cfg.ext.onerror) {
                cfg.ext.onerror.call(this, xhr, status, errorThrown);
            }

            $(document).trigger('raspAjaxError', [xhr, this, errorThrown]);
            if (global) {
                $(document).trigger('pfAjaxError', [xhr, this, errorThrown]);
            }

            PrimeFaces.error('Request return with error:' + status + '.');
        },
        success: function success(data, status, xhr) {
            PrimeFaces.debug('Response received succesfully.');

            var parsed;

            //call user callback
            if (cfg.onsuccess) {
                parsed = cfg.onsuccess.call(this, data, status, xhr);
            }

            //extension callback that might parse response
            if (cfg.ext && cfg.ext.onsuccess && !parsed) {
                parsed = cfg.ext.onsuccess.call(this, data, status, xhr);
            }

            $(document).trigger('raspAjaxSuccess', [xhr, this]);
            if (global) {
                $(document).trigger('pfAjaxSuccess', [xhr, this]);
            }

            //do not execute default handler as response already has been parsed
            if (parsed) {
                return;
            } else {
                PrimeFaces.ajax.Response.handle(data, status, xhr);
            }

            PrimeFaces.debug('DOM is updated.');
        },
        complete: function complete(xhr, status) {
            if (cfg.oncomplete) {
                cfg.oncomplete.call(this, xhr, status, xhr.pfArgs);
            }

            if (cfg.ext && cfg.ext.oncomplete) {
                cfg.ext.oncomplete.call(this, xhr, status, xhr.pfArgs);
            }

            $(document).trigger('raspAjaxComplete', [xhr, this]);
            if (global) {
                $(document).trigger('pfAjaxComplete', [xhr, this]);
            }

            PrimeFaces.debug('Response completed.');

            PrimeFaces.ajax.Queue.removeXHR(xhr);

            if (!cfg.async && !PrimeFaces.nonAjaxPosted) {
                PrimeFaces.ajax.Queue.poll();
            }
        }
    };

    if (cfg.timeout) {
        xhrOptions['timeout'] = cfg.timeout;
    }

    PrimeFaces.ajax.Queue.addXHR($.ajax(xhrOptions));
};

//Patch for autocomplete - do not search with 'enter' key in keyup search mode
//(function() {
//    var wrapped = PrimeFaces.widget.AutoComplete.prototype.processKeyEvent;
//    PrimeFaces.widget.AutoComplete.prototype.processKeyEvent = function(e) {
//        //debugger;
//        if(this.cfg.queryEvent !== 'enter') {
//            //console.log(this.cfg.queryEvent);
//            var keyCode = $.ui.keyCode;
//            var key = e.which;
//            if(key === keyCode.ENTER || key === keyCode.NUMPAD_ENTER){
//                e.preventDefault();
//                return
//            }
//        }
//        wrapped.apply(this, arguments);
//    }
//})();